import _ from "lodash";
import React from "react";
import {
  generateRandomId,
  extractContentFromHTML,
  getWeekStartDate,
  getDateTimeStringsBasedOnFormat,
  getTimelineLabels,
  getRethumbUrl,
  getMemoizedItemsFunction,
  getMemoizedLangFunction,
  getInitials,
  getYearDurationFormat,
  getCurrentTerm,
  hashString,
  getFileExtensionFromMimeType,
} from "Utils";
import {
  getUserType,
  getUserArchivalStatus,
  getUserEntityType,
} from "modules/CommonSelectors";
import { getStudentSortByList } from "Utils/GetStudentSortByList";
import update from "immutability-helper";
import moment from "moment";
import {
  ASSIGNMENT_TODO_STATE_TABS,
  ASSIGNMENT_CREATE_OPTIONS_NEW,
  MYP_ASSIGNMENT_OPTIONS_NEW,
  UBD_ASSIGNMENT_OPTIONS_NEW,
  DP_ASSIGNMENT_OPTIONS_NEW,
  UBD_CREATE_OPTIONS,
  MYP_CREATE_OPTIONS,
  PYP_CREATE_OPTIONS,
  PYP_IMPORT_OPTIONS_GROUP,
  MYP_IMPORT_OPTIONS_GROUP,
  UBD_IMPORT_OPTIONS_GROUP,
  DP_IMPORT_OPTIONS_GROUP,
  STUDENT_EMPTY_STATE_MAPPING,
  SUBMISSION_OPTIONS_V2,
  INCLUDE_ITEM_TYPES_FOR_UNREAD_MESSAGES_COUNT,
  INCLUDE_ITEM_TYPES_FOR_STUDENT_UNREAD_MESSAGES_COUNT,
} from "./ClassRoomModule/ClassRoomConstants";
import {
  getAssignmentStateTabsForStaff,
  getAssignmentStateTabs,
  getTimeTrackingEventsFromLocalStorage,
} from "./ClassRoomModule/ClassRoomUtils";
import { colors } from "Constants";
import { EXCLUDED_ASSESSMENT_TYPES } from "store/static";
import {
  AllCompletedIllustration,
  fontStyles,
  NoAccessIllustration,
  NoAssignmentIllustration,
  NoSearchInFilterIllustration,
} from "@toddle-edu/ds-theme";
import {
  AI_TRANSLATION_LANGUAGES,
  AI_ANALYSIS_SCALE_MAPPING,
  ASSESSMENT_TOOLS,
  STUDENT_COMMUNICATION_MODES,
  TUTOR_COMMUNICATION_MODES,
} from "@toddle-edu/common-utils";
import { getInitialStep } from "Assessments/modules/AssessmentModule/AssessmentUtils";
import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_DP,
  ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
  ASSESSMENT_GRADE_BOUNDARY,
  SCORE,
  DP_ASSESSMENT_RUBRIC,
  COMMENT,
  MYP_OBJECTIVE_RUBRIC,
  MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC,
  DP_EXPERIMENTAL_PROGRAMME,
  DP_PRACTICAL_ACTIVITY,
  CUSTOM_WEIGHTS,
  ASSESSMENT_TYPE_AI_TUTOR,
  TASK_TYPE_AI_TUTOR,
  AI_TUTOR_CREATION,
  ASSIGNMENT_TYPE_QUICK_TASK,
  CREATE_AI_TUTOR,
  CREATE_QUICK_TASK,
  LEARNING_ENGAGEMENT,
  ASSESSMENT_TYPE_QUICK_TASK,
  CREATE_WORKSHEET,
  CREATE_LE,
  ANALYSIS,
  VISIBLE,
  SINGLE_POINT_RUBRIC,
  CHECKLIST,
  CLASS_STREAM,
  CLASS_FLOW,
  DESC,
  GRADING_PERIOD_CUMULATIVE,
  CREATE_SA,
  CREATE_FA,
  SCORE_BASED_RUBRIC,
  STANDARD_BASED_RUBRIC,
  GRADE_SCALE_TOOL,
  DP_1,
  DP_2,
  ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW,
  ELEMENT_TYPE_ALL_ASSESSMENTS,
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  ELEMENT_TYPE_PYP_KEY_CONCEPT,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_DP_OBJECTIVES,
  ELEMENT_TYPE_DP_LEARNER_PROFILE,
  SUBJECT_TYPE_EE,
} from "Constants/stringConstants";
import {
  getOrganizationConstantsFromCache,
  getOrganizationDetailsFromCache,
} from "modules/CommonGraphqlHelpers";
import { getAssessmentTemplatesFromCache } from "ChildrenPage/modules/ChildrenPageGraphqlHelpers";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import { getDeadlineStartAndEndDate } from "Teacher/routes/Projects/modules/Utils";
import { getTaggableElements } from "modules/TaggableElementsUtils";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import {
  getCriteriaSetBasedOnPlannerElementType,
  GENERIC_TAGS_INFO,
  EVALUATE_PLANNER_ELEMENTS_BY_CURRICULUM,
  STANDARD_UIDS,
} from "modules/Services";
import { checkEmptyElementValue } from "modules/ElementValueUtils";
import {
  pypElementMapping,
  pypElementSubjectStandardsMapping,
  pypElementSetMapping,
} from "Constants/plannerElementMappings";
import {
  CommentMultipleOutlined,
  FilterOutlined,
  StudentShareOutlined,
  ReSubmissionRequestOutlined,
  AssessmentApplicableOutlined,
  PencilLineOutlined,
  TickSmallOutlined,
  WarningCircleOutlined,
  ClockTimerOutlined,
  EvaluationNotApplicableOutlined,
  SortOutlined,
  SinglePointRubricOutlined,
  ClockOutlined,
  DownArrowOutlined,
  UpArrowOutlined,
  UpDownArrowOutlined,
  ClipboardPencilLinesOutlined,
  LockOutlined,
  LockOpenOutlined,
  TableOutlined,
  AssessmentOutlined,
  ConfigureColumnsOutlined,
  HamburgerOutlined,
  SectionOutlined,
  LockFilled,
  CircleFilled,
  CloseCircleOutlined,
  UserPendingOutlined,
  UserTickOutlined,
  StudentEvaluateOutlined,
  StudentPendingOutlined,
  RubricOutlined,
  BadgeStarOutlined,
  CommentCircleRightOutlined,
  AttachmentClipOutlined,
  DashedCircleMinusOutlined,
  TickCircleOpenOutlined,
  ClipboardArrowOutlined,
  ScoreBasedAssessmentOutlined,
  InsightsSquareOutlined,
  InformationOutlined,
  ApprovalTickOutlined,
} from "@toddle-edu/ds-icons";
import ACLStore from "lib/aclStore";
import {
  getRatedScoreMemoized,
  getTotalScoreMemoized,
} from "AppComponents/CriteriaRubricAssessment/Utils";
import { showNewTheatreMode } from "Utils/GetTheatreModeType";
import { getIsResponseAdded } from "AppComponents/ProgressSummaryV2Shared/modules/Utils";
import { getScoreDetailsMemoize } from "ScoreCategories/modules/ScoreCategoriesModule";
import { getStudentScore } from "ClassProgressSummaryV2/modules/Utils";
import {
  ASSESSMENT_TYPE_WORKSHEET,
  WORKSHEET_TEMPLATES,
  TASK_TYPE_WORKSHEET,
} from "Worksheet/modules/WorksheetConstants";
import { WORKSHEET_SCOREBOOK } from "WorksheetInsights/modules/WorksheetInsightsConstants";
import { isPortfolioEnabled } from "Post/utils";
import {
  ENABLE_BROADCAST_MESSAGE,
  ENABLE_BULK_REMINDER,
  ENABLE_GRADE_WISE_ASSESSMENT,
  ASSIGNMENTS_MANAGE_PERMISSION,
  ASSIGNMENTS_ADD_RESPONSE_ON_BEHALF_OF_STUDENTS_PERMISSION,
  ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
  ASSIGNMENTS_ACCESS_PERMISSION,
  CLASS_FLOW_EDIT_PERMISSION,
  CLASS_FLOW_VIEW_PERMISSION,
  COURSE_GRADEBOOK_ACCESS_PERMISSION,
  PSOW_ROEP_MANAGE_PERMISSION,
  ENABLE_AI_TUTOR,
  MANAGE_GRADEBOOK_PERMISSION,
  ASSIGNMENTS_MANAGE_PERMISSION_IN_CALENDAR,
  USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
} from "Constants/permissionConstants";
import { setEncryptedJsonItem } from "services/localStorage";
import { isToddleLibraryEnabledForWorksheets } from "Worksheet/modules/WorksheetUtils";
import {
  getDefaultOrderBy,
  getFormattedUserName,
} from "Utils/GetFormattedUserName";
import {
  checkIsDateBefore,
  formatDate,
  getTodaysDate,
} from "Utils/DateTimeHelpers";
import { getGradeCalculationMethodSetting } from "routes/routes/Administrator/routes/DPAcademicSetup/routes/AssessmentSetup/modules/utils";
import { getIsConfigurationEnabledForCPAY } from "modules/PermissionModule";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";
import { insertAfterId, insertBeforeId } from "Utils/Common";
import hexToRgba from "hex-to-rgba";
import { isAITutorMarketingEnabled } from "Platform/modules/PlatformUtils";
import {
  Avatar,
  EmptyState,
  IconButton,
  Tag,
  Tooltip,
} from "@toddle-edu/ds-web";
import {
  ASSIGNMENT_FEED_DATE_TIME_FORMAT,
  FEED_VIEW,
  TABULAR_VIEW,
  VALID_STUDENT_SUBMISSION_TYPE,
  CODE_BASED_MIME_TYPES,
  ASSIGNMENT_STATE_TO_HEADER_TAB_MAPPING,
  DONE_STATUSES,
  RESUBMISSION_STATUSES,
} from "ClassRoom/modules/Constants";
import { isToddleLibraryEnabled } from "ToddleLibrary/modules/ToddleLibraryUtils";
import ACLStorage from "lib/aclService";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import classNames from "classnames";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";
import { getCourseDetailsFromCache as getCourseDetails } from "ProgressSummary/modules/ProgressSummaryGraphqlHelpers";
import { AVATAR_COLORS } from "Constants/colorConstants";
import { getSelectedIcon } from "UIComponents/IconSelector/modules/IconSelectorUtils";
import {
  getIsEnabledExcusedStatusInAssignment,
  getIsEnabledAssignmentImprovements,
  getIsAITutorEnhancementsV2Enabled,
  getIsStudentAssignmentFeedRevampEnabled,
  getIsAssessmentTypeConfigurationEnabled,
  getIsAITutorInEEEnabled,
  getIsSubmissionStatusOverrideEnabled,
} from "Utils/ACLStoreUtils";
// Imported from the file directly (not the Utils/EntityFlowUtils barrel) to
// avoid a circular dependency: the barrel re-exports NestedAccordionHelpers,
// which imports getSubjectLevelLabel from this file.
import { getTaskTypeAvatarName } from "Utils/EntityFlowUtils/AssessmentHelpers";
import { getFormattedTimeSinceV2 } from "Utils/GetTimeSince";
import {
  getIsWorksheetMonitoringEnabled,
  getIsWorksheetLayoutUpdateEnabled,
} from "Worksheet/modules/WorksheetFeatureFlags";
import { generateRnPContextsByLevel } from "Utils/RnPHelpers";
import { compareInScaledRange } from "Utils/AssessmentToolHelpers";
import { getSettingValue } from "Utils/ConfigurationUtils";

export const STUDENT_STANDARDS_GRADEBOOK = "STUDENT_STANDARDS_GRADEBOOK";

export const getEvaluationTextsForInstructions = ({
  isTeacherEvaluationEnabled,
  isStudentEvaluationEnabled,
  t,
}) => {
  if (isTeacherEvaluationEnabled && isStudentEvaluationEnabled) {
    return t("classRoom:teacher_and_student_eval");
  } else {
    if (isTeacherEvaluationEnabled) {
      return t("common:teacher_evaluation");
    }
    if (isStudentEvaluationEnabled) {
      return t("common:student_evaluation");
    }
  }
};

const getSubtextForInstructions = ({
  t,
  assessmentTool,
  assessmentToolType,
  isStudentEvaluationEnabled,
  isTeacherEvaluationEnabled,
  getEditModeSubtext,
}) => {
  switch (assessmentToolType) {
    case SCORE:
      return t("common:max_score_count_plural", {
        count: _.get(assessmentTool, "scoreToolData.maxScore", ""),
      });
    case DP_ASSESSMENT_RUBRIC: {
      const totalMarks = getEditModeSubtext({
        t,
        assessmentTool,
        assessmentToolType,
      });
      return totalMarks;
    }
    case ASSESSMENT_GRADE_BOUNDARY:
      return t("classRoom:manually_graded");
    case ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY:
      return t("classRoom:automatically_graded");
    case GRADE_SCALE_TOOL:
      return _.get(assessmentTool, "gradeScale.displayName", "");
    default:
      return getEvaluationTextsForInstructions({
        t,
        isStudentEvaluationEnabled,
        isTeacherEvaluationEnabled,
      });
  }
};

export const getEvaluationTexts = ({
  isTeacherEvaluationEnabled,
  isStudentEvaluationEnabled,
  t,
  isEvaluationApplicable = true,
  teacherEvaluationOnly = false,
  sourceFrom = "",
  isInstructionsRevamp = false,
  mode,
  assessmentTool = {},
  assessmentToolType = "",
  getEditModeSubtext,
}) => {
  if (
    isInstructionsRevamp &&
    mode === "view" &&
    sourceFrom === "CUSTOM_MEDIA_CARD"
  ) {
    return getSubtextForInstructions({
      t,
      isTeacherEvaluationEnabled,
      isStudentEvaluationEnabled,
      assessmentTool,
      assessmentToolType,
      getEditModeSubtext,
    });
  }
  const teacherEvaluation = t("common:teacher_evaluation");
  const studentEvaluation = t("common:student_evaluation");
  const teacherEvalNotApplicable = t("common:teacher_eval_not_applicable");
  const studentEvalNotApplicable = t("common:student_eval_not_applicable");
  const evaluationNotApplicable = t("classRoom:evaluation_not_applicable");

  if (teacherEvaluationOnly) {
    if (isTeacherEvaluationEnabled) {
      return isEvaluationApplicable
        ? [teacherEvaluation]
        : [teacherEvalNotApplicable];
    } else {
      return null;
    }
  }

  if (isTeacherEvaluationEnabled) {
    if (isStudentEvaluationEnabled) {
      // both teacher and student evaluation
      return isEvaluationApplicable
        ? [teacherEvaluation, studentEvaluation]
        : [evaluationNotApplicable];
    }
    // only teacher evaluation
    return isEvaluationApplicable
      ? [teacherEvaluation]
      : [teacherEvalNotApplicable];
  }
  if (isStudentEvaluationEnabled) {
    // only student evaluation
    return isEvaluationApplicable
      ? [studentEvaluation]
      : [studentEvalNotApplicable];
  }
};

const getSubmissionAttachmentsToDisplay = ({
  attachmentGroups,
  attachments = [],
}) => {
  const attachmentGroupsToDisplay = _.reduce(
    attachmentGroups,
    (result, attachmentGroup) => {
      const attachmentGroupAttachments = _.get(
        attachmentGroup,
        "attachments",
        []
      );

      if (!_.isEmpty(attachmentGroupAttachments)) {
        result = _.concat(result, attachmentGroupAttachments);
      }
      return result;
    },
    []
  );
  if (_.isEmpty(attachments)) return attachmentGroupsToDisplay;
  else return _.concat(attachmentGroupsToDisplay, attachments);
};

const shouldDisplayAttachment = attachment => {
  const isLTITool = _.isEqual(_.get(attachment, "metadata.type"), "LTI_TOOL");
  const isLTIAttempted = _.get(attachment, "metadata.isLTIAttempted", false);
  const isAnyLTIAttemptMade = _.get(
    attachment,
    "metadata.isAnyLTIAttemptMade",
    false
  );
  return !isLTITool || isAnyLTIAttemptMade || isLTIAttempted;
};

const getAttachmentsToDisplayWithPostConfigLocal = ({
  attachmentGroups,
  attachments = [],
  shouldShowLTIAttachments = false,
}) => {
  const newAttachmentGroups = _.reduce(
    attachmentGroups,
    (result, attachmentGroup) => {
      let attachmentGroupAttachments = [];
      attachmentGroupAttachments = _.map(
        _.get(attachmentGroup, "attachments", []),
        attachment => {
          return {
            ...attachmentGroup,
            attachmentId: attachment?.id,
            attachments: [attachment],
            isPost: true,
          };
        }
      );

      if (shouldShowLTIAttachments) {
        attachmentGroupAttachments = _.filter(
          attachmentGroupAttachments,
          attachmentGroupAttachment => {
            const attachment = _.get(
              attachmentGroupAttachment,
              "attachments[0]"
            );

            return shouldDisplayAttachment(attachment);
          }
        );
      }

      if (!_.isEmpty(attachmentGroupAttachments)) {
        result = _.concat(result, attachmentGroupAttachments);
      }
      return result;
    },
    []
  );
  return _.concat(newAttachmentGroups, attachments);
};

export const getAttachmentsToDisplayWithPostConfig = _.memoize(
  params => getAttachmentsToDisplayWithPostConfigLocal(params),
  params => {
    const attachmentIds = _.reduce(
      params?.attachmentGroups,
      (result, attachmentGroup) => {
        const attachmentGroupAttachments = _.map(
          _.get(attachmentGroup, "attachments", []),
          attachment => attachment?.id
        );

        if (!_.isEmpty(attachmentGroupAttachments)) {
          result = _.concat(result, attachmentGroupAttachments);
        }
        return result;
      },
      []
    );

    return JSON.stringify({ ...params, attachmentIds });
  }
);

const getSubmissionAttachmentsToDownload = ({
  attachmentGroups,
  attachments,
}) => {
  const attachmentsToDownload = _.reduce(
    _.concat(attachmentGroups, attachments),
    (result, obj) => {
      if (!_.isEmpty(_.get(obj, "attachments", []))) {
        result = result.concat(_.get(obj, "attachments", []));
      } else {
        result = result.concat(obj);
      }
      return result;
    },
    []
  );
  return attachmentsToDownload;
};

export const getStudentSubmissionObj = ({
  studentId,
  studentName,
  attachmentGroups,
  attachments,
  response,
}) => {
  let studentSubmissionObj = {};
  let attachmentsToDownload = getSubmissionAttachmentsToDownload({
    attachmentGroups,
    attachments,
  });

  attachmentsToDownload = _.filter(
    attachmentsToDownload,
    item =>
      !(
        _.isEqual(_.get(item, "type", ""), "WORKBOOK") &&
        _.isEmpty(_.get(item, "metadata.publicUrl", ""))
      )
  );

  studentSubmissionObj = update(studentSubmissionObj, {
    [studentId]: { $set: {} },
  });
  studentSubmissionObj = update(studentSubmissionObj, {
    [studentId]: { attachments: { $set: attachmentsToDownload } },
  });
  if (!_.isEmpty(response)) {
    studentSubmissionObj = update(studentSubmissionObj, {
      [studentId]: {
        attachments: {
          $push: [
            { id: generateRandomId(), type: "RESPONSE", title: response },
          ],
        },
      },
    });
  }

  studentSubmissionObj = update(studentSubmissionObj, {
    [studentId]: { folderName: { $set: studentName } },
  });
  return studentSubmissionObj;
};

export const getAllStudentsSubmissionObj = ({ sortedAssignedStudents }) => {
  let allStudentsSubmissionObj = {};
  _.map(sortedAssignedStudents, ({ student = {}, submission = {} }) => {
    const { id: studentId } = student;
    const response = _.get(submission, "response", "") || "";
    const attachmentGroups = _.get(submission, "attachmentGroups", []) || [];
    const attachments = _.get(submission, "attachments", []) || [];

    const studentSubmissionObj = getStudentSubmissionObj({
      studentId,
      studentName: getFormattedUserName({ user: student }),
      attachmentGroups,
      attachments,
      response,
    });

    allStudentsSubmissionObj = update(allStudentsSubmissionObj, {
      [studentId]: { $set: studentSubmissionObj[studentId] },
    });
  });
  return allStudentsSubmissionObj;
};

const getDefaultTodoFilters = ({
  userId,
  courseIds,
  filterOptions,
  todoActiveTab,
  orgId,
  createdBy,
  userType,
  searchText,
  excludedAssessmentTypes,
  contentTypes,
  academicYears,
}) => {
  let filters = {
    courseIds:
      _.get(courseIds, "length", 0) == 0 || _.get(courseIds, "0") === "ALL"
        ? userType === "staff"
          ? _.map(_.get(filterOptions, "courses", []), "value")
          : undefined
        : courseIds,
    contentTypes,
    excludedAssessmentTypes,
  };

  if (userType === "staff") {
    filters = {
      ...filters,
      searchText,
      createdBy:
        createdBy === "ALL" || _.get(createdBy, 0) === "ALL"
          ? undefined
          : _.get(createdBy, 0),
      organizationId: orgId,
    };
  } else {
    filters = {
      ...filters,
      studentId: userId,
      academicYears,
    };
  }

  if (todoActiveTab === "ASSIGNED") {
    filters = {
      ...filters,
      states: "PUBLISHED",
      status: [
        "EVALUATION_PENDING",
        "SUBMISSION_PENDING",
        "EVALUATED",
        "REQUEST_RESUBMISSION",
        "SUBMISSION_NOT_REQUIRED",
        "TURNED_IN",
        "EVALUATED_SHARED",
      ],
    };
  } else if (todoActiveTab === "OVERDUE") {
    filters = {
      ...filters,
      status: "OVERDUE",
      states: "PUBLISHED",
    };
  } else if (todoActiveTab === "COMPLETED") {
    filters = {
      ...filters,
      states: "ARCHIVED",
    };
  } else if (todoActiveTab === "TO_REVIEW") {
    filters = {
      ...filters,
      states: "PUBLISHED",
    };
  } else if (todoActiveTab === "REVIEWED") {
    filters = {
      ...filters,
      states: "ARCHIVED",
    };
  }

  return filters;
};

export const getClassroomTodoCountFilters = params => {
  const { orgId, todoActiveTab } = params;
  const {
    lastWeekStartDate,
    lastWeekEndDate,
    earlierEndDate,
    thisWeekStartDate,
    thisWeekEndDate,
    laterStartDate,
  } = getDateList({
    orgId,
    todoActiveTab,
  });
  let dateFilters = {};
  if (todoActiveTab == "REVIEWED" || todoActiveTab == "COMPLETED") {
    dateFilters = {
      archiveLastWeekStartDate: lastWeekStartDate,
      archiveLastWeekEndDate: lastWeekEndDate,
      archiveEarlierEndDate: earlierEndDate,
      archiveThisWeekStartDate: thisWeekStartDate,
      archiveThisWeekEndDate: thisWeekEndDate,
      archiveLaterStartDate: laterStartDate,
    };
  } else {
    dateFilters = {
      lastWeekStartDate,
      lastWeekEndDate,
      earlierEndDate,
      thisWeekStartDate,
      thisWeekEndDate,
      laterStartDate,
    };
  }
  const filters = {
    ...getDefaultTodoFilters(params),
    ...(dateFilters || {}),
  };

  return filters;
};

export const getDateList = ({ orgId }) => {
  const organizationDetails = getOrganizationConstantsFromCache(orgId);
  const { scheduler } = organizationDetails || {};
  const week_start_day = _.get(scheduler, "week_start_day");
  const currentWeekStartDate = getWeekStartDate({
    startDate: moment(),
    weekStartDay: week_start_day,
    weekLength: 7,
  });
  const lastWeekStartDate = moment(currentWeekStartDate)
    .subtract(7, "days")
    .startOf("day")
    .toDate()
    .toISOString();
  const lastWeekEndDate = moment(currentWeekStartDate)
    .startOf("day")
    .toDate()
    .toISOString();
  const earlierEndDate = moment(currentWeekStartDate)
    .subtract(7, "days")
    .startOf("day")
    .toDate()
    .toISOString();
  const thisWeekStartDate = moment(currentWeekStartDate)
    .startOf("day")
    .toDate()
    .toISOString();
  const thisWeekEndDate = moment(currentWeekStartDate)
    .add(7, "days")
    .startOf("day")
    .toDate()
    .toISOString();
  const nextWeekStartDate = moment(currentWeekStartDate)
    .add(7, "days")
    .startOf("day")
    .toDate()
    .toISOString();
  const nextWeekEndDate = moment(currentWeekStartDate)
    .add(14, "days")
    .startOf("day")
    .toDate()
    .toISOString();
  const laterStartDate = moment(currentWeekStartDate)
    .add(7, "days")
    .startOf("day")
    .toDate()
    .toISOString();

  return {
    lastWeekStartDate,
    lastWeekEndDate,
    earlierEndDate,
    thisWeekStartDate,
    thisWeekEndDate,
    laterStartDate,
    nextWeekEndDate,
    nextWeekStartDate,
  };
};

export const getDatesFilters = ({ orgId, filterDate, todoActiveTab }) => {
  const filters = {};
  const {
    lastWeekStartDate,
    lastWeekEndDate,
    earlierEndDate,
    thisWeekStartDate,
    thisWeekEndDate,
    laterStartDate,
  } = getDateList({
    orgId,
    todoActiveTab,
  });

  let filterKey = "deadlineDates";
  if (todoActiveTab == "REVIEWED" || todoActiveTab == "COMPLETED") {
    filterKey = "archiveDates";
  }
  switch (filterDate) {
    case "LAST_WEEK":
      filters[filterKey] = {
        startDate: lastWeekStartDate,
        endDate: lastWeekEndDate,
      };

      break;
    case "EARLIER":
      filters[filterKey] = {
        endDate: earlierEndDate,
      };
      break;
    case "THIS_WEEK":
      filters[filterKey] = {
        startDate: thisWeekStartDate,
        endDate: thisWeekEndDate,
      };
      break;
    case "LATER":
      filters[filterKey] = {
        startDate: laterStartDate,
      };
      break;
    case "NO_DUE_DATE":
      filters["isNoDeadlineDate"] = true;
      break;
  }
  return filters;
};

export const getClassroomTodoFilters = ({
  orgId,
  filterDate,
  todoActiveTab,
  ...rest
}) => {
  const filters = {
    ...getDefaultTodoFilters({
      ...(rest || {}),
      orgId,
      todoActiveTab,
    }),
    ...getDatesFilters({ orgId, filterDate, todoActiveTab }),
  };
  let { orderBy, orderByDirection } =
    _.find(ASSIGNMENT_TODO_STATE_TABS, item => item.value == todoActiveTab) ||
    {};

  if (
    todoActiveTab == "ASSIGNED" ||
    todoActiveTab === "OVERDUE" ||
    todoActiveTab === "TO_REVIEW" ||
    todoActiveTab === "OVERDUE"
  ) {
    if (filterDate != "NO_DUE_DATE") {
      orderBy = "DUE_AT";
    }
  }

  if (filterDate == "LATER") {
    orderByDirection = "ASC";
  }

  return { ...(filters || {}), orderBy, orderByDirection };
};

export const getAssignmentStats = _.memoize(
  ({ assignedStudents }) => {
    const completeOrEvaluatedAssignments = [];
    const sharedAssignments = [];
    const submittedAssignments = [];
    const students = [];

    _.forEach(assignedStudents, item => {
      const { isEvaluated, isSharedWithStudent, isSubmitted } = item;
      const student = _.get(item, "student", {});
      const name = getFormattedUserName({ user: student });

      const isStudentArchived = getUserArchivalStatus(student);

      if (isEvaluated) {
        completeOrEvaluatedAssignments.push({
          name,
          isArchived: isStudentArchived,
        });
      }
      if (isSharedWithStudent) {
        sharedAssignments.push({
          ...student,
          name,
          isArchived: isStudentArchived,
        });
      }
      if (isSubmitted) {
        submittedAssignments.push({
          ...student,
          name,
          isArchived: isStudentArchived,
        });
      }

      students.push({ ...student, name, isArchived: isStudentArchived });
    });

    return {
      students,
      submittedAssignments,
      completeOrEvaluatedAssignments,
      sharedAssignments,
    };
  },
  ({ assignedStudents }) =>
    JSON.stringify(
      _.map(assignedStudents, item => ({
        student: item?.student,
        isSubmitted: item?.isSubmitted,
        isEvaluated: item?.isEvaluated,
        isSharedWithStudent: item?.isSharedWithStudent,
      }))
    )
);

export const formatDueDate = ({ deadline, t }) => {
  return deadline
    ? `${t("classRoom:due_date")}: ${
        getDateTimeStringsBasedOnFormat({
          inputDateTimeString: deadline,
          dateTimeFormat: "Do MMM YYYY, hh:mm a",
        }).dateTimeString
      }`
    : t("classRoom:no_due_date");
};

export const formatDueOnDate = ({ deadline, t }) => {
  return deadline
    ? `${t("classRoom:due_on")} ${
        getDateTimeStringsBasedOnFormat({
          inputDateTimeString: deadline,
          dateTimeFormat: "Do MMM YYYY",
        }).dateLabelStringWithoutComma
      }`
    : t("classRoom:no_due_date");
};

export const extractEntityName = ({ content }) => {
  return (
    _.get(content, "assignmentTitle", "") ||
    _.get(content, "title.value", "") ||
    extractContentFromHTML({
      htmlString: _.get(content, "label", ""),
    })
  );
};

export const getStatusDetails = ({ data, t, userType }) => {
  const {
    isEvaluated,
    assignment,
    status,
    evaluatedAt,
    submission,
    state: assignmentStateTabV2,
    publishedAt: publishedAtV2,
    isFixedStartTimeBeforeTime,
  } = data || {};

  const { deadline, state, contentType } = assignment || {};
  const { publishedAt, state: assignmentStateTab } = state || {};
  const { submittedAt, returnedAt } = submission || {};

  let statusColor = colors.neutral400;
  let dateColor = colors.black;
  let label = "";
  let date = "";
  let iconVariant = "subtle";
  let iconBgColor = colors.surfaceSubtle;
  let showStatus = true;

  const publishedAtDate = publishedAt ? publishedAt : publishedAtV2;
  const assignmentStateTabValue =
    userType == "parent" ? assignmentStateTabV2 : assignmentStateTab;

  const {
    submissionStatus,
    isStatusRevamp,
    isSubmissionStatusOverridden,
  } = getSubmissionStatus({
    submission,
  });
  const displaySubmittedAt = isSubmissionStatusOverridden ? null : submittedAt;

  let _status = status;
  if (isStatusRevamp) {
    _status = isEvaluated ? status : submissionStatus;
  }

  if (
    contentType == "ASSIGNMENT_MEETING" ||
    assignmentStateTabValue == "SCHEDULED"
  ) {
    date = publishedAtDate
      ? getDateTimeStringsBasedOnFormat({
          inputDateTimeString: publishedAtDate,
        }).dateTimeString
      : "-";
    label = t("common:scheduled_for");
  } else {
    switch (_status) {
      case "REQUEST_RESUBMISSION":
        date = getDateTimeStringsBasedOnFormat({
          inputDateTimeString: returnedAt,
        }).dateLabelString;
        break;
      case "REQUEST_RESUBMISSION_OVERDUE":
        date = getDateTimeStringsBasedOnFormat({
          inputDateTimeString: returnedAt,
        }).dateLabelString;
        statusColor = colors.textWarning;
        iconVariant = "warning";
        iconBgColor = colors.surfaceWarning;
        break;

      case "SUBMISSION_NOT_REQUIRED":
      case "SUBMISSION_PENDING":
        date = deadline
          ? getDateTimeStringsBasedOnFormat({ inputDateTimeString: deadline })
              .dateTimeString
          : t("classRoom:no_due_date");
        break;

      case "COMPLETED":
      case "EVALUATED_SHARED":
        date = getDateTimeStringsBasedOnFormat({
          inputDateTimeString: evaluatedAt,
        }).dateLabelString;
        break;
      case "EVALUATED":
        date = getDateTimeStringsBasedOnFormat({
          inputDateTimeString: evaluatedAt,
        }).dateLabelString;
        statusColor = colors.blue400;
        dateColor = colors.blue400;
        break;
      case "OVERDUE":
        date = getDateTimeStringsBasedOnFormat({
          inputDateTimeString: deadline,
        }).dateTimeString;
        statusColor = colors.textWarning;
        iconVariant = "warning";
        iconBgColor = colors.surfaceWarning;
        break;
      case "TURNED_IN":
      case "TURNED_IN_ON_TIME": {
        date = displaySubmittedAt
          ? getDateTimeStringsBasedOnFormat({
              inputDateTimeString: displaySubmittedAt,
            }).dateTimeString
          : "";
        statusColor = colors.textSuccess;
        iconVariant = "success";
        iconBgColor = colors.surfaceSuccess;
        break;
      }
      case "TURNED_IN_LATE": {
        date = displaySubmittedAt
          ? getDateTimeStringsBasedOnFormat({
              inputDateTimeString: displaySubmittedAt,
            }).dateTimeString
          : "";
        statusColor = colors.textLink;
        iconVariant = "link";
        iconBgColor = colors.surfaceLink;
        break;
      }
      case "NOT_SUBMITTED":
      case "RESUBMISSION_NOT_SUBMITTED":
        date = deadline
          ? getDateTimeStringsBasedOnFormat({ inputDateTimeString: deadline })
              .dateTimeString
          : t("classRoom:no_due_date");
        statusColor = colors.textCritical;
        iconVariant = "critical";
        iconBgColor = colors.surfaceError;
        break;
    }
    label = getAssignmentStatusLabel({ status: _status, t });
  }

  if (isFixedStartTimeBeforeTime) {
    // * if is worksheet, fixed start time and is not ended or not submitted
    label = t("common:starts_at");
    if (publishedAtDate) {
      date = getDateTimeStringsBasedOnFormat({
        inputDateTimeString: publishedAtDate,
      }).dateTimeString;
    }
  }

  // If student is marked as excused then...
  // - hide status if evaluated and StudentAssignment -> status still coming as EVALUATION_NOT_APPLICABLE (need to change BE logic -> status should be EVALUATED)
  // - hide status if not evaluated and submission is pending
  if (
    getIsEnabledExcusedStatusInAssignment() &&
    status === "EVALUATION_NOT_APPLICABLE" &&
    (isEvaluated ||
      !_.includes(
        ["TURNED_IN", "TURNED_IN_ON_TIME", "TURNED_IN_LATE"],
        submissionStatus
      ))
  ) {
    showStatus = false;
  }

  return {
    date,
    statusColor,
    dateColor,
    label,
    iconVariant,
    iconBgColor,
    showStatus,
  };
};

export const getAssignmentStatusLabel = ({ status, t }) => {
  return status ? t(`classRoom:${_.toLower(status)}`) : "";
};

export const getClassroomPostDetails = ({
  attachments,
  student,
  content,
  title,
  curriculumProgramType,
  courseId,
}) => {
  const allFields = _.get(content, "allFields", []);
  const unitPlanField = _.find(allFields, { uid: "unitPlan" }) || {};
  const taggedUnitPlan = _.get(
    unitPlanField,
    "resolvedMinimalTree.unitPlan",
    {}
  );
  const taggedAssessment = {
    id: _.get(content, "id"),
    title: _.get(content, "title", {}),
    image: _.get(content, "image", {}),
    unitPlan: taggedUnitPlan,
  };

  const userInfo = getUserInfo({ portalType: "PLANNER" });
  let pypTaggedDetails = {};
  if (
    _.isEmpty(taggedUnitPlan) ||
    (taggedUnitPlan &&
      _.get(taggedUnitPlan, "organization.id") == _.get(userInfo, "org_id"))
  ) {
    const taggablElements = getTaggableElements({
      curriculumProgramType,
      unitPlan: taggedUnitPlan,
    });
    const uids = _.map(
      taggablElements,
      taggableElement => taggableElement.value
    );
    const allFields = _.get(content, "allFields", []);
    const fields = !_.isEmpty(allFields)
      ? allFields
      : _.get(taggedAssessment, "fields", []);

    const elementPYP = [];
    _.forEach(uids, uid => {
      const field = _.find(fields, item => item?.uid == uid);
      if (!_.isEmpty(field)) {
        elementPYP.push({
          fieldUID: uid,
          parentType: "RESOURCE",
          value: _.get(field, "value", []) || [],
          resolvedMinimalTree: _.get(field, "resolvedMinimalTree", []) || [],
        });
      }
    });
    pypTaggedDetails = {
      resourceItem: _.cloneDeep(taggedAssessment),
      unitPlan: _.cloneDeep(taggedUnitPlan),
      resourceType: "ASSESSMENT",
      elementPYP,
    };
  }
  const postCreateDetail = {
    attachments: _.map(attachments, attachment =>
      _.omit(attachment, [
        "__typename",
        "streamUrl",
        "isRead",
        "questionAttachment",
        "signedUrl",
      ])
    ),
    students: {
      totalCount: 1,
      edges: [
        {
          node: student,
          __typename: "StudentsEdge",
        },
      ],
    },
    isHiddenFromStudents: false,
    isPrivate: false,
    title,
    courseId,
    ...pypTaggedDetails,
  };
  return postCreateDetail;
};

export const getFormattedCoursesDetails = ({
  courses,
  selectedTimeSlot,
  itemType,
  showCalendarAssignmentByDueDate,
}) => {
  const selectedTimeSlotStartDate = _.get(selectedTimeSlot, "startDate", null);
  const selectedTimeSlotStartTime = _.get(selectedTimeSlot, "startTime", null);
  return _.reduce(
    courses,
    (result, course) => {
      const details = {
        id: _.get(course, "id"),
        title: _.get(course, "title"),
        students: _.map(
          _.get(
            course,
            "students.edges",
            _.get(course, "allStudents.edges", [])
          ),
          student => student.node
        ),
        totalStudents: _.map(
          _.get(course, "students.edges", []),
          student => student.node
        ),
        subjects: _.get(course, "subjects", []),
        deadlineDate:
          showCalendarAssignmentByDueDate && itemType == "ASSIGNMENT"
            ? selectedTimeSlotStartDate
            : null,
        deadlineTime:
          showCalendarAssignmentByDueDate &&
          itemType == "ASSIGNMENT" &&
          selectedTimeSlotStartTime
            ? moment(selectedTimeSlotStartTime, "HH:mm")
                .add(30, "minutes")
                .format("HH:mm")
            : null,
        state: {
          state: "PUBLISHED",
          scheduleDate:
            itemType !== "ASSIGNMENT" ||
            (itemType == "ASSIGNMENT" && !showCalendarAssignmentByDueDate)
              ? selectedTimeSlotStartDate
              : null,
          scheduleTime:
            itemType !== "ASSIGNMENT" ||
            (itemType == "ASSIGNMENT" && !showCalendarAssignmentByDueDate)
              ? selectedTimeSlotStartTime
              : null,
        },
        closeSubmissionDate: null,
        visibility: VISIBLE,
        // Per-class worksheet settings: when WorksheetAssignModalV2 is enabled,
        // security mode and duration are stored per-class instead of globally.
        // Using ACLStore directly to avoid circular dependency with WorksheetUtils.
        ...(ACLStore.can("FeatureFlag:WorksheetAssignModalV2")
          ? {
              isLockScreenEnabled: false,
              isSafeBrowserEnabled: false,
              timedTestDuration: { hours: 1, minutes: 0 },
            }
          : {}),
      };

      result.push(details);
      return result;
    },
    []
  );
};

export const getFormattedCoursesDetailsMemoize = _.memoize(
  params => getFormattedCoursesDetails(params),
  params => JSON.stringify(params)
);

export const getAttachmentGroupFromCurrentMedia = (
  attachmentGroups,
  currentMediaId
) => {
  const foundAttachmentGroup = _.first(
    _.filter(
      attachmentGroups,
      attachmentGroup =>
        _.findIndex(
          _.get(attachmentGroup, "attachments", []),
          attachment => attachment?.id === currentMediaId
        ) != -1
    )
  );
  return foundAttachmentGroup?.id;
};

const getAttachmentGroupResponseObject = ({
  attachmentGroups,
  conversations,
}) => {
  // Returns an object that gives messageIdArr corresponding to the attachmentGroup id
  const conversationItems = [];
  _.forEach(conversations, conversation => {
    const item = _.get(conversation, "node.item", {});
    if (
      !_.isEmpty(item) &&
      _.get(conversation, "node.itemType") ===
        "STUDENT_ASSIGNMENT_SUBMISSION_FEEDBACK"
    ) {
      conversationItems.push({
        ...item,
        messageId: _.get(conversation, "node.id"),
      });
    }
  });

  const attachmentGroupFeedbackMapper = {};

  _.forEach(attachmentGroups, attachmentGroup => {
    const messageIdArr = _.map(
      _.filter(
        conversationItems,
        conversationItem => _.get(conversationItem, "id") == attachmentGroup.id
      ),
      item => item.messageId
    );

    const messageLength = _.get(messageIdArr, "length");
    if (messageLength > 0) {
      attachmentGroupFeedbackMapper[attachmentGroup.id] = messageIdArr;
    }
  });
  return attachmentGroupFeedbackMapper;
};

export const getAttachmentGroupResponseObjectMemoize = _.memoize(
  params => getAttachmentGroupResponseObject(params),
  ({ conversations, attachmentGroups }) => {
    return JSON.stringify({
      conversations: _.map(conversations, ({ node }) => ({
        id: node?.id,
        item: node?.item,
      })),
      attachmentIds: _.map(attachmentGroups, "id"),
    });
  }
);

export const isStudentPartOfCourse = ({ courseId, courses }) => {
  const studentArchivedCourseIds = _.map(
    _.filter(
      courses,
      ({ isRemovedCourseForLoggedInUser }) => isRemovedCourseForLoggedInUser
    ),
    ({ id }) => id
  );
  return !studentArchivedCourseIds.includes(courseId);
};

const getClassroomProps = ({ sourceType }) => {
  switch (sourceType) {
    case "SNP":
      return {
        showHeaderBackButton: false,
        showEvaluationDropdown: false,
        showDeleteMessageOption: false,
        showSendMessageOption: false,
        showCreatePostButton: false,
        showGiveFeedbackButton: false,
        isPypEvaluationEditable: false,
        isToolResponseEnabled: false,
        showAddResponseButton: false,
        showStudentCheckbox: false,
        showActionsColumn: false,
        showActionButtons: false,
        showAssignmentActionsDropdown: false,
        showSendAlertMesssageModalIcon: false,
      };
    default:
      return {
        isPypEvaluationEditable: true,
        isToolResponseEnabled: true,
        showCreatePostButton: isPortfolioEnabled(),
        showAddResponseButton: true,
      };
  }
};

export const getClassroomPropsMemoize = _.memoize(
  params => getClassroomProps(params),
  ({ sourceType }) => JSON.stringify({ sourceType })
);

export const getAssignmentTypeFilterOptions = ({
  t,
  currentCurriculumProgramType,
}) => {
  switch (currentCurriculumProgramType) {
    case "IB_MYP": {
      return [
        { label: t("common:le_label"), value: "le", key: "le" },
        {
          label: t("classRoom:formative_assessment"),
          value: "fmt",
          key: "fmt",
        },
        {
          label: t("classRoom:summative_assessment"),
          value: "smt",
          key: "smt",
        },
      ];
    }
    // ! Temporarily Disabled
    // case "UBD": {
    //   return [
    //     { label: t("common:le_label"), value: "le" },
    //     { label: t("common:assessment"), value: "assessment" },
    //   ];
    // }
    case "IB_PYP": {
      return [];
    }
    default:
      return [];
  }
};

/** util to get the content type value based on the curriculum program for the insights query */

export const getPostIconState = params => {
  const {
    postsAddedToJournalCount,
    assignedStudentsCount,
    responsesEvaluatedButNotPublishedToJournalCount,
    isLTIAttachmentPresent,
    isAddingWorksheetResponsesToPost = false,
  } = params;

  let tooltip = "";
  let tooltipContainerStyle = {};
  let align = {};
  let isDisabled = false;
  let isPostAddIcon = true;
  let iconVariant = "subtle";
  let hasOnClickAction = false;
  const label = "classRoom:add_all_responses_to_portfolio";

  if (isLTIAttachmentPresent) {
    tooltip = "classRoom:disabled_add_to_portfolio_external_tool";
    tooltipContainerStyle = {
      maxWidth: "180px",
      padding: "0px",
    };
    align = { offset: [14, 0] };
    isDisabled = true;
  } else if (postsAddedToJournalCount === assignedStudentsCount) {
    tooltip = "classRoom:all_responses_added_to_journal";
    align = { offset: [6, 0] };
    isPostAddIcon = false;
    iconVariant = "success";
    tooltipContainerStyle = {
      padding: "0px",
    };
  } else if (
    responsesEvaluatedButNotPublishedToJournalCount === 0 &&
    postsAddedToJournalCount > 0
  ) {
    tooltip = "classRoom:all_marked_evaluated_responses_have_been_added";
    tooltipContainerStyle = {
      maxWidth: "180px",
      padding: "0px",
    };
    align = { offset: [14, 0] };
    isPostAddIcon = false;
    iconVariant = "success";
  } else if (responsesEvaluatedButNotPublishedToJournalCount > 0) {
    tooltip = isAddingWorksheetResponsesToPost
      ? "worksheet:action_disabled_till_all_responses_added_to_portfolio"
      : "classRoom:add_all_responses_to_portfolio";
    tooltipContainerStyle = {
      maxWidth: "180px",
      padding: "0px",
    };
    align = { offset: [6, 0] };
    hasOnClickAction = true;
  } else {
    tooltip = "classRoom:only_completed_evaluated_responses_can_be_added";
    tooltipContainerStyle = {
      maxWidth: "180px",
      padding: "0px",
    };
    align = { offset: [14, 0] };
    isDisabled = true;
  }
  return {
    tooltip,
    tooltipContainerStyle,
    align,
    isDisabled,
    isPostAddIcon,
    iconVariant,
    hasOnClickAction,
    label,
  };
};
const STATUS_COLOR_MAPPING = {
  critical: {
    textColor: colors.textCritical,
    surfaceColor: colors.surfaceError,
    iconVariant: "critical",
  },
  warning: {
    textColor: colors.textWarning,
    surfaceColor: colors.surfaceWarning,
    iconVariant: "warning",
  },
  success: {
    textColor: colors.textSuccess,
    surfaceColor: colors.surfaceSuccess,
    iconVariant: "success",
  },
  disabled: {
    textColor: colors.textSubtle,
    surfaceColor: colors.surfaceSubtle,
    iconVariant: "subtle",
  },
  link: {
    textColor: colors.textLink,
    surfaceColor: colors.surfaceLink,
    iconVariant: "link",
  },
};

const STATUS_COLOR_MAPPING_V2 = {
  critical: {
    textColor: "var(--text-semantic-error)",
    surfaceColor: "var(--surface-semantic-error)",
  },
  warning: {
    textColor: "var(--text-semantic-warning)",
    surfaceColor: "var(--surface-semantic-warning)",
  },
  success: {
    textColor: "var(--text-semantic-success)",
    surfaceColor: "var(--surface-semantic-success)",
  },
  disabled: {
    textColor: "var(--text-secondary)",
    surfaceColor: "var(--surface-primary-active)",
  },
  link: {
    textColor: "var(--text-semantic-info)",
    surfaceColor: "var(--surface-semantic-info)",
  },
};

/* util to get submission, teacher evaluation, student evaluation status along with colors, based on student assignment data */

export const getStudentAssignmentStatus = _.memoize(
  params => _getStudentAssignmentStatus(params),
  ({
    submission,
    isEvaluated,
    isEvaluationApplicable,
    isStudentEvaluationEnabled,
    isStudentSubmissionEnabled,
    isTeacherEvaluationEnabled,
    toolResponses,
    isScheduled,
    isFixedStartTime,
    publishedAt,
    templateId,
    userType,
    isTestStarted,
  }) => {
    const submissionData = {
      status: submission?.status,
      statusV2: submission?.statusV2,
      isDraftSubmission: submission?.isDraftSubmission,
    };
    const toolResponseIds = _.map(toolResponses, "toolId");

    return JSON.stringify({
      submissionData,
      toolResponseIds,
      isEvaluated,
      isScheduled,
      isFixedStartTime,
      publishedAt,
      templateId,
      userType,
      isTestStarted,
      isEvaluationApplicable,
      isStudentEvaluationEnabled,
      isStudentSubmissionEnabled,
      isTeacherEvaluationEnabled,
    });
  }
);

const _getStudentAssignmentStatus = studentAssignmentData => {
  const {
    submission,
    isEvaluated,
    isEvaluationApplicable,
    isStudentEvaluationEnabled,
    isStudentSubmissionEnabled,
    isTeacherEvaluationEnabled,
    toolResponses,
    isScheduled,
    isFixedStartTime,
    publishedAt,
    t,
    templateId,
    userType,
    isTestStarted,
  } = studentAssignmentData;
  const isEnabledExcusedStatusInAssignment = getIsEnabledExcusedStatusInAssignment();

  const isStudentEvaluationDone = getIsEvaluationDone({
    toolResponses,
    creatorType: "STUDENT",
  });
  const { submissionStatus, isSubmitted } = getSubmissionStatus({ submission });

  let submissionStatusData = {
    ...STATUS_COLOR_MAPPING["disabled"],
    label: "Submission not required",
    isDisabled: true,
  };
  let teacherEvaluationStatus = {};
  let studentEvaluationStatus = {};

  if (isStudentSubmissionEnabled) {
    if (isScheduled) {
      submissionStatusData = {
        ...STATUS_COLOR_MAPPING["disabled"],
        label: isFixedStartTime
          ? t("common:starts_at_with_label", {
              label: publishedAt
                ? moment(publishedAt).format("Do, MMM YYYY hh:mm a")
                : "-",
            })
          : t("common:scheduled_for_with_label", {
              label: publishedAt
                ? moment(publishedAt).format("Do, MMM YYYY hh:mm a")
                : "-",
            }),
        isDisabled: true,
      };
    } else {
      switch (submissionStatus) {
        case "DRAFT":
        case "SUBMISSION_PENDING":
          submissionStatusData = {
            ...STATUS_COLOR_MAPPING["warning"],
            label: t(
              _.includes(WORKSHEET_TEMPLATES, templateId)
                ? _.isEqual(userType, "parent")
                  ? "common:pending"
                  : !isTestStarted
                  ? "worksheet:not_attempted"
                  : "common:pending"
                : "common:pending"
            ),
            isDisabled: false,
          };
          break;
        case "SUBMITTED":
        case "TURNED_IN_ON_TIME":
          submissionStatusData = {
            ...STATUS_COLOR_MAPPING["success"],
            label: t("classRoom:turned_in"),
            isDisabled: false,
          };
          break;
        case "TURNED_IN_LATE":
          submissionStatusData = {
            ...STATUS_COLOR_MAPPING["link"],
            label: t("classRoom:turned_in_late"),
            isDisabled: false,
          };
          break;
        case "RETURNED":
        case "REQUEST_RESUBMISSION":
          submissionStatusData = {
            ...STATUS_COLOR_MAPPING["disabled"],
            label: t("classRoom:request_resubmission"),
            isDisabled: false,
          };
          break;
        case "REQUEST_RESUBMISSION_OVERDUE":
          submissionStatusData = {
            ...STATUS_COLOR_MAPPING["warning"],
            label: t("classRoom:request_resubmission_overdue"),
            isDisabled: false,
          };
          break;

        case "OVERDUE":
          submissionStatusData = {
            ...STATUS_COLOR_MAPPING["warning"],
            label: t("classRoom:overdue"),
            isDisabled: false,
          };
          break;
        case "NOT_SUBMITTED":
          submissionStatusData = {
            ...STATUS_COLOR_MAPPING["critical"],
            label: t("classRoom:not_submitted"),
            isDisabled: false,
          };
          break;
        case "RESUBMISSION_NOT_SUBMITTED":
          submissionStatusData = {
            ...STATUS_COLOR_MAPPING["critical"],
            label: t("classRoom:resubmission_not_submitted"),
            isDisabled: false,
          };
          break;
      }
    }
  }

  if (isTeacherEvaluationEnabled && !isScheduled) {
    if (getIsEvaluationApplicable(isEvaluationApplicable)) {
      if (isEvaluated) {
        teacherEvaluationStatus = {
          ...STATUS_COLOR_MAPPING["success"],
          label: t("common:completed"),
          isDisabled: false,
        };
      } else {
        teacherEvaluationStatus = {
          ...STATUS_COLOR_MAPPING["warning"],
          label: t("common:pending"),
          isDisabled: false,
        };
      }
    } else {
      teacherEvaluationStatus = {
        ...(isEnabledExcusedStatusInAssignment
          ? STATUS_COLOR_MAPPING["disabled"]
          : STATUS_COLOR_MAPPING["critical"]),
        label: isEnabledExcusedStatusInAssignment
          ? t("classRoom:excused")
          : t("common:na"),
        isDisabled: false,
      };
    }
  }

  if (isStudentEvaluationEnabled && !isScheduled) {
    if (getIsEvaluationApplicable(isEvaluationApplicable)) {
      if (isSubmitted && isStudentEvaluationDone) {
        studentEvaluationStatus = {
          ...STATUS_COLOR_MAPPING["success"],
          label: t("common:completed"),
          isDisabled: false,
        };
      } else {
        studentEvaluationStatus = {
          ...STATUS_COLOR_MAPPING["warning"],
          label: t("common:pending"),
          isDisabled: false,
        };
      }
    } else {
      studentEvaluationStatus = {
        ...(isEnabledExcusedStatusInAssignment
          ? STATUS_COLOR_MAPPING["disabled"]
          : STATUS_COLOR_MAPPING["critical"]),
        label: isEnabledExcusedStatusInAssignment
          ? t("classRoom:excused")
          : t("common:na"),
        isDisabled: false,
      };
    }
  }

  return {
    submissionStatusData,
    teacherEvaluationStatus,
    studentEvaluationStatus,
  };
};

export const getStudentAssignmentStatusV2 = ({
  submission,
  isEvaluated,
  isEvaluationApplicable,
  isStudentEvaluationEnabled,
  isStudentSubmissionEnabled,
  isTeacherEvaluationEnabled,
  toolResponses,
  evaluatedAt,
  t,
  classes,
  status,
}) => {
  const isEnabledExcusedStatusInAssignment = getIsEnabledExcusedStatusInAssignment();
  const isStudentEvaluationDone = getIsEvaluationDone({
    toolResponses,
    creatorType: "STUDENT",
  });
  const {
    submissionStatus,
    isSubmitted,
    isSubmissionStatusOverridden,
  } = getSubmissionStatus({ submission });
  const { submittedAt } = submission || {};
  const displaySubmittedAt = isSubmissionStatusOverridden ? null : submittedAt;
  const DATE_FORMAT = "Do MMM YYYY, h:mm A";

  let submissionStatusData = {
    label: t("common:not_required"),
    icon: <CloseCircleOutlined variant="subtle" size="x-small" />,
    ...STATUS_COLOR_MAPPING_V2["disabled"],
  };
  let teacherEvaluationStatus = {};
  let studentEvaluationStatus = {};

  // prepare submission status data if student submission is enabled
  if (isStudentSubmissionEnabled) {
    if (
      getIsEnabledExcusedStatusInAssignment() &&
      status === "EVALUATION_NOT_APPLICABLE" &&
      !_.includes(
        ["TURNED_IN", "TURNED_IN_ON_TIME", "TURNED_IN_LATE"],
        submissionStatus
      )
    ) {
      submissionStatusData = {
        label: t("classRoom:excused"),
        icon: (
          <EvaluationNotApplicableOutlined variant={"subtle"} size="x-small" />
        ),
        ...STATUS_COLOR_MAPPING_V2["disabled"],
        showStatusInFeedItem: false,
      };
    } else {
      switch (submissionStatus) {
        case "DRAFT":
        case "SUBMISSION_PENDING":
          submissionStatusData = {
            label: t("common:pending"),
            icon: <AssessmentOutlined variant="warning" size="x-small" />,
            ...STATUS_COLOR_MAPPING_V2["warning"],
          };
          break;

        case "SUBMITTED":
        case "TURNED_IN_ON_TIME": {
          const formattedDate = displaySubmittedAt
            ? formatDate({ date: displaySubmittedAt, format: DATE_FORMAT })
            : null;
          submissionStatusData = {
            label: formattedDate
              ? t("classRoom:turned_in_on_date", { date: formattedDate })
              : t("classRoom:turned_in"),
            icon: (
              <AssessmentApplicableOutlined
                variant="success"
                size="x-small"
                className={classes.iconSuccess}
              />
            ),
            ...STATUS_COLOR_MAPPING_V2["success"],
          };
          break;
        }

        case "TURNED_IN_LATE": {
          const formattedDate = displaySubmittedAt
            ? formatDate({ date: displaySubmittedAt, format: DATE_FORMAT })
            : null;
          submissionStatusData = {
            label: formattedDate
              ? t("classRoom:turned_in_late_on_date", { date: formattedDate })
              : t("classRoom:turned_in_late"),
            icon: (
              <AssessmentApplicableOutlined
                variant="link"
                size="x-small"
                className={classes.iconLink}
              />
            ),
            ...STATUS_COLOR_MAPPING_V2["link"],
          };
          break;
        }

        case "OVERDUE":
          submissionStatusData = {
            label: t("classRoom:overdue"),
            icon: (
              <AssessmentOutlined
                variant="warning"
                size="x-small"
                className={classes.iconWarning}
              />
            ),
            ...STATUS_COLOR_MAPPING_V2["warning"],
          };
          break;

        case "NOT_SUBMITTED":
          submissionStatusData = {
            label: t("classRoom:not_submitted"),
            icon: (
              <CloseCircleOutlined
                variant="critical"
                size="x-small"
                className={classes.iconCritical}
              />
            ),
            ...STATUS_COLOR_MAPPING_V2["critical"],
          };
          break;

        case "RETURNED":
        case "REQUEST_RESUBMISSION":
          submissionStatusData = {
            label: t("classRoom:request_resubmission"),
            icon: <AssessmentOutlined variant="subtle" size="x-small" />,
            ...STATUS_COLOR_MAPPING_V2["disabled"],
          };
          break;

        case "REQUEST_RESUBMISSION_OVERDUE":
          submissionStatusData = {
            label: t("classRoom:request_resubmission_overdue"),
            icon: (
              <AssessmentOutlined
                variant="warning"
                size="x-small"
                className={classes.iconWarning}
              />
            ),
            ...STATUS_COLOR_MAPPING_V2["warning"],
          };
          break;

        case "RESUBMISSION_NOT_SUBMITTED":
          submissionStatusData = {
            label: t("classRoom:resubmission_not_submitted"),
            icon: (
              <CloseCircleOutlined
                variant="critical"
                size="x-small"
                className={classes.iconCritical}
              />
            ),
            ...STATUS_COLOR_MAPPING_V2["critical"],
          };
          break;
      }
    }
  }

  // prepare teacher evaluation status data if teacher evaluation is enabled
  if (isTeacherEvaluationEnabled) {
    if (getIsEvaluationApplicable(isEvaluationApplicable)) {
      if (isEvaluated) {
        teacherEvaluationStatus = {
          label: t("classRoom:evaluated_on_date", {
            date: formatDate({
              date: evaluatedAt,
              format: DATE_FORMAT,
            }),
          }),
          icon: (
            <UserTickOutlined
              variant="success"
              size="x-small"
              className={classes.iconSuccess}
            />
          ),
          ...STATUS_COLOR_MAPPING_V2["success"],
        };
      } else {
        teacherEvaluationStatus = {
          label: t("common:pending"),
          icon: (
            <UserPendingOutlined
              variant="warning"
              size="x-small"
              className={classes.iconWarning}
            />
          ),
          ...STATUS_COLOR_MAPPING_V2["warning"],
        };
      }
    } else {
      teacherEvaluationStatus = {
        label: isEnabledExcusedStatusInAssignment
          ? t("classRoom:excused")
          : t("common:na"),
        icon: (
          <EvaluationNotApplicableOutlined
            variant={isEnabledExcusedStatusInAssignment ? "subtle" : "critical"}
            size="x-small"
            className={
              !isEnabledExcusedStatusInAssignment
                ? classes.iconCritical
                : undefined
            }
          />
        ),
        ...(isEnabledExcusedStatusInAssignment
          ? STATUS_COLOR_MAPPING_V2["disabled"]
          : STATUS_COLOR_MAPPING_V2["critical"]),
        showStatusInFeedItem: !isEnabledExcusedStatusInAssignment,
      };
    }
  }

  // prepare student evaluation status data if student evaluation is enabled
  if (isStudentEvaluationEnabled) {
    if (getIsEvaluationApplicable(isEvaluationApplicable)) {
      if (isSubmitted && isStudentEvaluationDone) {
        studentEvaluationStatus = {
          label: t("common:completed"),
          icon: (
            <StudentEvaluateOutlined
              variant="success"
              size="x-small"
              className={classes.iconSuccess}
            />
          ),
          ...STATUS_COLOR_MAPPING_V2["success"],
        };
      } else {
        studentEvaluationStatus = {
          label: t("common:pending"),
          icon: (
            <StudentPendingOutlined
              variant="warning"
              size="x-small"
              className={classes.iconWarning}
            />
          ),
          ...STATUS_COLOR_MAPPING_V2["warning"],
        };
      }
    } else {
      studentEvaluationStatus = {
        label: isEnabledExcusedStatusInAssignment
          ? t("classRoom:excused")
          : t("common:na"),
        icon: (
          <EvaluationNotApplicableOutlined
            variant={isEnabledExcusedStatusInAssignment ? "subtle" : "critical"}
            size="x-small"
            className={
              !isEnabledExcusedStatusInAssignment
                ? classes.iconCritical
                : undefined
            }
          />
        ),
        ...(isEnabledExcusedStatusInAssignment
          ? STATUS_COLOR_MAPPING_V2["disabled"]
          : STATUS_COLOR_MAPPING_V2["critical"]),
        showStatusInFeedItem: !isEnabledExcusedStatusInAssignment,
      };
    }
  }

  return {
    submissionStatusData,
    teacherEvaluationStatus,
    studentEvaluationStatus,
  };
};

export const getStudentAssignmentSubmissionStatus = _.memoize(
  params => _getStudentAssignmentSubmissionStatus(params),
  params => JSON.stringify(params)
);

const _getStudentAssignmentSubmissionStatus = ({ submissionStatus, t }) => {
  let submissionStatusLabel = t("classRoom:submission_not_required");
  switch (submissionStatus) {
    case "DRAFT":
    case "SUBMISSION_PENDING":
      submissionStatusLabel = t("common:submission_pending");
      break;
    case "SUBMITTED":
    case "TURNED_IN_ON_TIME":
    case "TURNED_IN_LATE":
      submissionStatusLabel = t("classRoom:turned_in");
      break;
    case "RETURNED":
    case "REQUEST_RESUBMISSION":
    case "REQUEST_RESUBMISSION_OVERDUE":
      submissionStatusLabel = t("classRoom:request_resubmission");
      break;
    case "Overdue":
      submissionStatusLabel = t("classRoom:overdue");
      break;
    case "NOT_SUBMITTED":
      submissionStatusLabel = t("classRoom:not_submitted");
      break;
    case "RESUBMISSION_NOT_SUBMITTED":
      submissionStatusLabel = t("classRoom:resubmission_not_submitted");
      break;
  }
  return submissionStatusLabel;
};

/* util to check if  evaluation is done, based on toolResponses */
export const getIsEvaluationDone = ({
  toolResponses: toolResponsesData,
  creatorType = "STUDENT",
  assessmentToolId,
}) => {
  if (assessmentToolId) {
    const toolResponses = _.get(
      _.find(toolResponsesData, ({ toolId }) => toolId === assessmentToolId),
      "toolResponses",
      {}
    );

    return _.some(
      toolResponses,
      toolResponse => _.get(toolResponse, "creatorType") === creatorType
    );
  } else {
    return _.some(toolResponsesData, ({ toolResponses }) => {
      return _.some(
        toolResponses,
        toolResponse => _.get(toolResponse, "creatorType") === creatorType
      );
    });
  }
};

export const STUDENT_ASSIGNMENT_MEDIA_CREATION_OPTIONS = {
  enableTagging: false,
  enableCaption: false,
  isPost: false,
  addButtonLabel: "common:add_to_work",
  creationTitle: "common:add_work",
  addMediaOptions: [
    "PHOTO",
    "VOICE",
    "VIDEO",
    "FILE",
    "WORKBOOK",
    "LINK",
    "TODDLE_DOC",
  ],
  showInstructionsWithVoice: true,
  allowCarouselCreation: false,
};

export const getShowAssessmentTool = assessment => {
  const { assessmentToolType, allFields, assessmentTool } = assessment;

  if (_.isEmpty(assessmentTool)) return false;

  if (assessmentToolType === ANALYSIS) {
    return _.size(_.get(assessmentTool, "criterias")) > 0;
  }

  const assessmentToolTypeHasEval = _.get(
    _.find(ASSESSMENT_TOOLS, item => item.type == assessmentToolType),
    "hasEvaluation",
    false
  );

  const interdisciplinaryField = _.find(allFields, field => {
    return _.get(field, "uid") === "interdisciplinaryCriteriaMYP";
  });

  const isMYPObjectiveRubric = assessmentToolType === MYP_OBJECTIVE_RUBRIC;
  const isMYPInterdisciplinaryRubric =
    assessmentToolType === MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC;

  let objectivesMYP = {};

  if (isMYPObjectiveRubric) {
    objectivesMYP = _.find(allFields, field => {
      return _.get(field, "uid") === "objectivesMYP";
    });
    if (_.isEmpty(_.get(objectivesMYP, "value"))) {
      objectivesMYP = interdisciplinaryField;
    }
  }

  const hasValue = isMYPObjectiveRubric
    ? !_.isEmpty(_.get(objectivesMYP, "value"))
    : isMYPInterdisciplinaryRubric
    ? !_.isEmpty(_.get(interdisciplinaryField, "value"))
    : !_.isEmpty(assessmentTool);

  return (
    !_.isEmpty(assessmentToolType) && assessmentToolTypeHasEval && hasValue
  );
};

const _checkAssessmentHasPypEvaluation = ({
  assessmentDetails,
  curriculumProgramType,
}) => {
  const plannerElementsToEvaluate = getPlannerElementsToEvaluate({
    assessmentDetails,
    curriculumProgramType,
  });

  return !_.isEmpty(plannerElementsToEvaluate);
};

export const checkAssessmentHasPypEvaluation = _.memoize(
  params => _checkAssessmentHasPypEvaluation(params),
  params => JSON.stringify(params)
);

export const getScoreValueElementRatings = ({
  ibPYPElementRatings,
  isAiEvaluationEnabled,
}) => {
  const aiRating = _.find(ibPYPElementRatings, {
    ibPYPElementType: SCORE,
    creatorType: "AI",
    isDeleted: false,
  });

  const staffRating = _.find(ibPYPElementRatings, {
    ibPYPElementType: SCORE,
    creatorType: "STAFF",
  });

  const rating = _.find(ibPYPElementRatings, rating => {
    const isScore = rating?.ibPYPElementType === SCORE;
    return (
      isScore && (!_.has(rating, "isDeleted") || !_.get(rating, "isDeleted"))
    );
  });

  const aiScore = _.get(aiRating, "value", "");
  const staffScore = _.get(staffRating, "value", "");
  const score = _.get(rating, "value", "");

  // If staff or ai value is not undefined, then use that value
  const hasAiOrStaffRating = aiRating || staffRating;
  const defaultScore = !hasAiOrStaffRating ? score : "";

  return isAiEvaluationEnabled
    ? aiScore || staffScore || defaultScore
    : staffScore || aiScore || defaultScore;
};

/* util to get student response data */

export const getStudentResponseData = _.memoize(
  params => _getStudentResponseData(params),
  items => {
    const studentResponseData = _.find(items, {
      itemType: "STUDENT_ASSIGNMENT",
    });
    return JSON.stringify(studentResponseData);
  }
);

const _getStudentResponseData = items => {
  const studentResponseData = _.find(items, {
    itemType: "STUDENT_ASSIGNMENT",
  });

  const item = _.get(studentResponseData, "item", {});
  const itemId = _.get(item, "id");
  const itemType = _.get(studentResponseData, "itemType", "");
  const content = _.get(item, "assignment.content", {});
  const assessmentType = _.get(content, "assessmentType.value");
  const taskTypeGroup = _.get(content, "taskType.value");
  const assessmentId = _.get(content, "id");
  const studentResponseAttachments = getSubmissionAttachmentsToDisplay({
    attachmentGroups: _.get(
      studentResponseData,
      "item.submission.attachmentGroups",
      {}
    ),
  });
  const postId = _.get(item, "post.id", "");
  return {
    itemId,
    postId,
    itemType,
    assessmentType,
    assessmentId,
    taskTypeGroup,
    studentResponseAttachments,
  };
};

export const checkAchievementCriteriaExists = _.memoize(
  params => _checkAchievementCriteriaExists(params),
  params => JSON.stringify(params)
);

const _checkAchievementCriteriaExists = ({
  assessmentFields,
  curriculumProgramType,
  getCriteriaSetOfPypType,
}) => {
  const plannerElementsToEvaluate = getPlannerElementsToEvaluate({
    assessmentDetails: {
      allFields: assessmentFields,
    },
    curriculumProgramType,
  });

  let isCriteriaSetsExists = false;

  _.map(plannerElementsToEvaluate, pypElement => {
    const elementKey = pypElement.value;

    if (getIsNewGradingSetupEnabled()) {
      isCriteriaSetsExists = true;
      return;
    }

    const type = pypElementMapping[elementKey];

    const criteriaSet = getCriteriaSetBasedOnPlannerElementType({
      type,
      getCriteriaSetOfPypType,
    });

    if (!_.isEmpty(criteriaSet)) {
      isCriteriaSetsExists = true;
    } else {
      // for subject standards need to check for the case where only subject criteria is selected
      const type = pypElementSubjectStandardsMapping[elementKey];

      if (type) {
        const criteriaSet = getCriteriaSetBasedOnPlannerElementType({
          type,
          getCriteriaSetOfPypType,
        });

        if (!_.isEmpty(criteriaSet)) {
          isCriteriaSetsExists = true;
        }
      }
    }
  });
  return !isCriteriaSetsExists;
};

export const getCourseStudents = ({ coursesUserMap, courseId }) => {
  const courseUserMap = _.find(coursesUserMap, item => {
    return _.get(item, "id") == courseId;
  });
  return _.map(courseUserMap?.userMap?.edges, item => {
    return {
      ..._.get(item, "node.user", {}),
      tags: _.get(item, "node.tags", []),
    };
  });
};

export const filterFieldsBasedOnConfig = ({ fields, field_list, userType }) => {
  const filteredFields = _.filter(fields, field => {
    const hideForUserTypes = _.get(
      field_list,
      `${field}.config.hideForUserTypes`,
      []
    );
    return !_.includes(hideForUserTypes, userType);
  });

  return filteredFields;
};

export const getLeftPaneOptions = params => {
  const {
    t,
    classDiscussionUnreadCount,
    isStudentSubmissionEnabled,
    isClassDiscussionEnabled,
    isWorksheet,
    isScheduled,
    isDraft,
  } = params;

  const showDivider = isClassDiscussionEnabled || isWorksheet;

  const styles = {
    paddedItem: {
      padding: "24px 24px 24px 18px",
    },
  };

  const isWorksheetMonitoringEnabled = getIsWorksheetMonitoringEnabled();
  const isWorksheetLayoutUpdateEnabled = getIsWorksheetLayoutUpdateEnabled();

  const COMMON_OPTIONS = {
    ALL_SUBMISSIONS: {
      key: "ALL_SUBMISSIONS",
      Icon: AssessmentOutlined,
      title: t("classRoom:all_submissions"),
      action: "allsubmissions",
      customStyles: styles.paddedItem,
    },
    WORKSHEET_SCOREBOOK: {
      key: WORKSHEET_SCOREBOOK,
      Icon: TableOutlined,
      title: t("worksheet:scorebook"),
      action: "scorebook",
      customStyles: styles.paddedItem,
      hideItem: !isWorksheet,
    },
    CLASS_DISCUSSION: {
      key: "CLASS_DISCUSSION",
      Icon: CommentMultipleOutlined,
      title: t("classRoom:class_discussion"),
      action: "classdiscussion",
      count: classDiscussionUnreadCount,
      customStyles: {
        marginTop: isStudentSubmissionEnabled ? "4px" : "0px",
        ...styles.paddedItem,
      },
      hideItem: !isClassDiscussionEnabled,
    },
    DIVIDER: {
      key: "DIVIDER",
      showDivider,
      hideItem: true,
    },
    FILTER: {
      key: "FILTER",
      Icon: FilterOutlined,
      customStyles: styles.paddedItem,
      showDropdown: true,
    },
  };

  if (isWorksheetLayoutUpdateEnabled && isWorksheet) {
    /**
     * Worksheet Layout Restructuring
     * Only for Assessment type "WORKSHEET"
     * Handled for both Scheduled and Open Assessment
     */
    const WORKSHEET_OPTIONS = {
      MONITORING: {
        key: "WORKSHEET_MONITORING",
        Icon: ScoreBasedAssessmentOutlined,
        title: t("worksheet:monitoring"),
        action: "monitoring",
        customStyles: styles.paddedItem,
        hideItem: !isWorksheetMonitoringEnabled || isDraft,
      },
      INSIGHTS: {
        key: "EVALUATION_INSIGHTS",
        Icon: InsightsSquareOutlined,
        title: t("assessmentEvaluation:evaluation_insights"),
        action: "evaluation-insights",
        customStyles: styles.paddedItem,
      },
      INSTRUCTIONS: {
        key: "WORKSHEET_INSTRUCTIONS",
        Icon: InformationOutlined,
        title: t("common:instruction_plural"),
        action: "details",
        customStyles: styles.paddedItem,
      },
    };

    return isScheduled || isDraft
      ? [WORKSHEET_OPTIONS.INSTRUCTIONS, WORKSHEET_OPTIONS.MONITORING]
      : [
          COMMON_OPTIONS.ALL_SUBMISSIONS,
          WORKSHEET_OPTIONS.MONITORING,
          COMMON_OPTIONS.CLASS_DISCUSSION,
          COMMON_OPTIONS.WORKSHEET_SCOREBOOK,
          WORKSHEET_OPTIONS.INSIGHTS,
          WORKSHEET_OPTIONS.INSTRUCTIONS,
          COMMON_OPTIONS.DIVIDER,
          COMMON_OPTIONS.FILTER,
        ];
  }

  const options = [
    COMMON_OPTIONS.ALL_SUBMISSIONS,
    COMMON_OPTIONS.WORKSHEET_SCOREBOOK,
    COMMON_OPTIONS.CLASS_DISCUSSION,
    COMMON_OPTIONS.DIVIDER,
    COMMON_OPTIONS.FILTER,
  ];

  return options;
};

export const getStudentTypeOptions = _.memoize(
  params => _getStudentTypeOptions(params),
  ({
    assignedStudents,
    isStudentSubmissionEnabled,
    isTeacherEvaluationEnabled,
    isWorksheet,
  }) =>
    JSON.stringify({
      assignedStudents: _.map(assignedStudents, student => ({
        statusV2: _.get(student, "submission.statusV2"),
        status: _.get(student, "status"),
        id: _.get(student, "student.id"),
      })),
      isStudentSubmissionEnabled,
      isTeacherEvaluationEnabled,
      isWorksheet,
    })
);

export const SUBMISSION_OPTIONS = [
  "SUBMISSION_PENDING",
  "OVERDUE",
  "TURNED_IN_ON_TIME",
  "TURNED_IN_LATE",
  "REQUEST_RESUBMISSION",
  "REQUEST_RESUBMISSION_OVERDUE",
];

const _getStudentTypeOptions = params => {
  const {
    t,
    assignedStudents,
    isStudentSubmissionEnabled,
    isTeacherEvaluationEnabled,
    isWorksheet,
  } = params;

  const totalStudents = _.size(assignedStudents);

  let studentAssignmentOptions = [];

  if (isStudentSubmissionEnabled) {
    studentAssignmentOptions = [
      ...studentAssignmentOptions,
      ...(!isWorksheet ? SUBMISSION_OPTIONS_V2 : SUBMISSION_OPTIONS),
    ];
  }

  if (isTeacherEvaluationEnabled) {
    const turnedInIndex = _.findIndex(
      studentAssignmentOptions,
      item => item == "TURNED_IN"
    );
    if (turnedInIndex > -1) {
      studentAssignmentOptions = update(studentAssignmentOptions, {
        $splice: [[turnedInIndex, 1]],
      });
    }
    studentAssignmentOptions = [
      ...studentAssignmentOptions,
      "EVALUATION_PENDING",
      "EVALUATED",
      "EVALUATED_SHARED",
      "EVALUATION_NOT_APPLICABLE",
    ];
  } else {
    studentAssignmentOptions = [...studentAssignmentOptions, "COMPLETED"];
  }

  const isEnabledExcusedStatusInAssignment = getIsEnabledExcusedStatusInAssignment();

  const studentTypeOptions = [
    {
      label: `${t("common:allStudents")} (${totalStudents})`,
      key: "ALL_STUDENTS",
      disabled: !totalStudents,
    },
    ..._.map(studentAssignmentOptions, status => {
      let studentAssignmentStatus = getAssignmentStatusLabel({ status, t });
      const statusCount = _.get(
        _.filter(assignedStudents, student => {
          if (
            isEnabledExcusedStatusInAssignment &&
            status === "EVALUATION_NOT_APPLICABLE"
          ) {
            return !_.get(student, "isEvaluationApplicable", false);
          }
          if (_.includes(SUBMISSION_OPTIONS_V2, status)) {
            return _.get(student, "submission.statusV2") === status;
          } else {
            return _.get(student, "status") === status;
          }
        }),
        "length",
        0
      );
      if (
        status === "EVALUATION_NOT_APPLICABLE" &&
        isEnabledExcusedStatusInAssignment
      ) {
        studentAssignmentStatus = t("classRoom:excused");
      }

      return {
        label: `${studentAssignmentStatus} (${statusCount})`,
        key: status,
        disabled: !statusCount,
      };
    }),
  ];

  return studentTypeOptions;
};

export const getActiveAndArchiveStudents = _.memoize(
  params => _getActiveAndArchiveStudents(params),
  params => JSON.stringify(params)
);

const _getActiveAndArchiveStudents = ({ assignedStudents }) => {
  const activeStudents = _.filter(assignedStudents, ({ student }) => {
    const isArchived = getUserArchivalStatus(student);
    return !isArchived;
  });

  const archivedStudents = _.filter(assignedStudents, ({ student }) => {
    const isArchived = getUserArchivalStatus(student);
    return isArchived;
  });

  return {
    activeStudents,
    archivedStudents,
    combinedActiveAndArchivedStudents: _.concat(
      activeStudents,
      archivedStudents
    ),
  };
};

export const getMediaManagerDropdownOptions = params => {
  const {
    currentStudentData,
    t,
    isTeacherEvaluationEnabled,
    isCurrentAcademicYearSelected,
    isArchivedClass,
    contentType,
    someToolsHaveEval,
    isPrivate,
    isStudentSubmissionEnabled,
    isUsingScore,
    isLearningGoalsEvaluationEnabled,
    isTimedTestEnabled,
    assessmentType,
    taskTypeGroup,
  } = params;

  const isEnabledExcusedStatusInAssignment = getIsEnabledExcusedStatusInAssignment();

  const {
    isEvaluationApplicable,
    isEvaluated,
    isSharedWithStudent,
    student = {},
    status,
    isSubmitted,
    lockingState = {},
  } = currentStudentData;
  const { isArchived } = student;

  const showMarkEvaluatedShareButton =
    contentType === "ASSESSMENT" &&
    isTeacherEvaluationEnabled &&
    (someToolsHaveEval || isUsingScore || isLearningGoalsEvaluationEnabled) &&
    !isEvaluated;

  const hideEditButton =
    isPrivate ||
    isSharedWithStudent ||
    (getIsEvaluationApplicable(isEvaluationApplicable) &&
      isEvaluated &&
      !isTeacherEvaluationEnabled);

  let shareLabel = "";
  if (!isEvaluated && !isSharedWithStudent) {
    shareLabel = t(
      "assessmentEvaluation:mark_as_evaluated_share_with_student_and_family"
    );
  } else {
    shareLabel = t(
      "assessmentEvaluation:label_evaluation_with_student_and_family",
      {
        label: t("common:share"),
      }
    );
  }

  const isAITutor =
    assessmentType == ASSESSMENT_TYPE_AI_TUTOR ||
    taskTypeGroup == TASK_TYPE_AI_TUTOR;
  const isWorksheet =
    assessmentType == ASSESSMENT_TYPE_WORKSHEET ||
    taskTypeGroup == TASK_TYPE_WORKSHEET;

  const checkForLockSubmissionAfterEvaluation = !isAITutor && !isWorksheet;

  const options = [];

  if (!isEvaluated && !getIsEvaluationApplicable(isEvaluationApplicable)) {
    const disabled =
      !isCurrentAcademicYearSelected ||
      !getIsEvaluationApplicable(isEvaluationApplicable) ||
      isArchived ||
      isArchivedClass;
    options.push({
      label: isTeacherEvaluationEnabled
        ? t("assessmentEvaluation:mark_as_evaluated")
        : t("assessmentEvaluation:mark_as_completed"),
      icon: <StudentShareOutlined disabled={disabled} />,
      key: "evaluate",
      disabled,
    });
  }

  if (isEvaluated && !hideEditButton) {
    const disabled = !isCurrentAcademicYearSelected;
    options.push({
      label: isTeacherEvaluationEnabled
        ? t("assessmentEvaluation:edit_evaluation")
        : t("common:edit"),
      icon: <PencilLineOutlined disabled={disabled} />,
      key: "edit_evaluation",
      disabled,
    });
  }

  if (showMarkEvaluatedShareButton && !isPrivate) {
    const disabled =
      !getIsEvaluationApplicable(isEvaluationApplicable) ||
      (isEvaluated && isSharedWithStudent) ||
      !isCurrentAcademicYearSelected ||
      isPrivate;
    options.push({
      label: shareLabel,
      icon: <StudentShareOutlined disabled={disabled} />,
      key: !isEvaluated && !isSharedWithStudent ? "evaluate_share" : "share",
      disabled,
    });
  }

  if (isTeacherEvaluationEnabled) {
    const disabled = isEvaluated || !isCurrentAcademicYearSelected;
    if (isEvaluationApplicable) {
      options.push(
        isEnabledExcusedStatusInAssignment
          ? {
              label: t("classRoom:mark_as_excused"),
              icon: <EvaluationNotApplicableOutlined disabled={disabled} />,
              key: "mark_as_excused",
              disabled,
            }
          : {
              label: t("assessmentEvaluation:evaluation_not_applicable"),
              icon: <EvaluationNotApplicableOutlined disabled={disabled} />,
              key: "evaluation_not_applicable",
              disabled,
            }
      );
    } else {
      options.push(
        isEnabledExcusedStatusInAssignment
          ? {
              label: t("classRoom:remove_excused_status"),
              icon: <DashedCircleMinusOutlined disabled={disabled} />,
              key: "remove_excused_status",
              disabled,
            }
          : {
              label: t("assessmentEvaluation:enable_evaluation"),
              icon: <AssessmentApplicableOutlined disabled={disabled} />,
              key: "enable_evaluation",
              disabled,
            }
      );
    }
  }
  // TODO: check if need to update
  if (isStudentSubmissionEnabled) {
    const disabled =
      status === "RETURNED" ||
      isEvaluated ||
      !isSubmitted ||
      !isCurrentAcademicYearSelected ||
      isArchived ||
      isArchivedClass ||
      isPrivate ||
      isTimedTestEnabled;
    if (!isAITutor) {
      options.push({
        label: t("assessmentEvaluation:request_resubmission"),
        icon: <ReSubmissionRequestOutlined disabled={disabled} />,
        key: "request_resubmission",
        disabled,
      });
    }
  }

  if (
    isStudentSubmissionEnabled &&
    !isTimedTestEnabled &&
    !isPrivate &&
    (checkForLockSubmissionAfterEvaluation || !isEvaluated)
  ) {
    const isSubmissionLocked = _.get(lockingState, "state", "") === "LOCKED";
    const disabled =
      !isCurrentAcademicYearSelected || isArchived || isArchivedClass;

    if (isSubmissionLocked) {
      options.push({
        label: t("classRoom:open_for_submissions"),
        icon: <LockOpenOutlined disabled={disabled} />,
        key: "open_for_submissions",
        disabled,
      });
    } else {
      options.push({
        label: t("classRoom:close_for_submissions"),
        icon: <LockOutlined disabled={disabled} />,
        key: "close_for_submissions",
        disabled,
      });
    }
  }

  return options;
};

export const getDistinctTurnInCount = _.memoize(
  params => _getDistinctTurnInCount(params),
  ({ assignedStudents }) =>
    JSON.stringify(
      _.map(assignedStudents, student => ({
        isEvaluated: _.get(student, "isEvaluated", false),
        submission: {
          status: _.get(student, "submission.status"),
          statusV2: _.get(student, "submission.statusV2"),
          isDraftSubmission: _.get(
            student,
            "submission.isDraftSubmission",
            false
          ),
        },
        unreadMessageCounts: _.get(
          student,
          "conversation.unreadMessageCounts",
          []
        ),
      }))
    )
);

const _getDistinctTurnInCount = ({ assignedStudents }) => {
  return _.reduce(
    assignedStudents,
    (result, student) => {
      const isEvaluated = _.get(student, "isEvaluated", false);
      const { isSubmitted } = getSubmissionStatus({
        submission: _.get(student, "submission", {}),
      });
      const conversation = _.get(student, "conversation", {});
      const unreadMessageCounts = _.get(
        conversation,
        "unreadMessageCounts",
        []
      );
      const count = getStudentSubmissionUnreadMessageCounts({
        unreadMessageCounts,
      });

      const distinctTurnInCount =
        isSubmitted && count > 0 && !isEvaluated ? 1 : 0;

      return (result += distinctTurnInCount);
    },
    0
  );
};

export const getAllowAddLEToJournal = _.memoize(
  params => _getAllowAddLEToJournal(params),
  ({
    response,
    toolResponses: toolResponsesData,
    attachmentGroups,
    ibPYPElementRatings = [],
    elementRemarks = [],
  }) => {
    return JSON.stringify({
      hasResponses: _.size(response),
      attachmentGroupIds: _.map(attachmentGroups, "id"),
      toolResponsesData: _.map(toolResponsesData, toolResponse => ({
        toolId: toolResponse?.toolId,
        hasResponses: !_.isEmpty(toolResponse?.toolResponses),
      })),
      elementRatingIds: _.map(ibPYPElementRatings, rating => ({
        id: rating?.id,
        type: rating?.ibPYPElementType,
      })),
      staffRemarkIds: _.map(
        _.filter(elementRemarks, { creatorType: "STAFF" }),
        "id"
      ),
    });
  }
);

const _getAllowAddLEToJournal = params => {
  const {
    response,
    toolResponses: toolResponsesData,
    attachmentGroups,
    ibPYPElementRatings = [],
    elementRemarks = [],
  } = params;

  const someToolsHasResponse = _.some(
    toolResponsesData,
    ({ toolResponses }) => {
      return !_.isEmpty(toolResponses);
    }
  );

  const isResponseAdded = !_.isEmpty(response) || !_.isEmpty(attachmentGroups);

  let filteredIBPYPElementRatings = ibPYPElementRatings;

  if (!showNewTheatreMode()) {
    filteredIBPYPElementRatings = _.filter(ibPYPElementRatings, rating => {
      const ibPYPElementType = _.get(rating, "ibPYPElementType");
      return (
        ibPYPElementType !== SCORE &&
        !getIsIBGradeScaleTool({
          assessmentToolType: ibPYPElementType,
        })
      );
    });
  }

  return (
    isResponseAdded ||
    someToolsHasResponse ||
    !_.isEmpty(filteredIBPYPElementRatings) ||
    !_.isEmpty(getStaffElementRemarkMessage(elementRemarks))
  );
};

export const getAssessmentToolText = ({
  t,
  assessmentTool = {},
  assessmentToolType,
  showLabelAsIBGrade = false,
  isCustomWeights = false,
  sourceFrom,
}) => {
  const assessmentToolData = _.find(
    ASSESSMENT_TOOLS,
    ({ type }) => type == assessmentToolType
  );

  const assessmentToolText = t(_.get(assessmentToolData, "locale", ""));

  const toolText = {
    assessmentToolText,
    type: assessmentTool?.type,
  };

  switch (assessmentToolType) {
    case COMMENT:
      return {
        ...toolText,
        assessmentToolText: t("common:final_remarks"),
      };
    case DP_ASSESSMENT_RUBRIC: {
      const subtext = getDPCriteriaRubricHeaderSubtext({
        t,
        assessmentTool,
        showLabel: false,
      });

      if (!_.isEmpty(assessmentTool)) {
        return {
          ...toolText,
          assessmentToolText: _.get(assessmentTool, "label", ""),
          subtext,
        };
      } else {
        return {
          ...toolText,
          subtext,
        };
      }
    }
    case SCORE: {
      if (isCustomWeights) {
        return {
          ...toolText,
          assessmentToolText: t("classRoom:maximum_score_and_task_weight"),
        };
      } else {
        return toolText;
      }
    }
    case ASSESSMENT_GRADE_BOUNDARY: {
      return {
        ...toolText,
        subtext: t("classRoom:grade_manually"),
      };
    }
    case ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY: {
      return {
        ...toolText,
        assessmentToolText: showLabelAsIBGrade
          ? t("common:ib_grade")
          : _.get(toolText, "assessmentToolText"),
        subtext: `${t(
          "classRoom:automated_grading"
        )} - ${getAutoEvaluateIBGradeToolTypeName({ t, assessmentToolType })}`,
      };
    }
    case ANALYSIS: {
      return {
        ...toolText,
        assessmentToolText:
          sourceFrom === "STUDENT_CLASS_STREAM"
            ? t("academicSetup:scale")
            : assessmentToolText,
      };
    }

    case GRADE_SCALE_TOOL: {
      if (sourceFrom === "STUDENT_ASSIGNMENT") {
        const displayName = _.get(assessmentTool, "gradeScale.displayName");

        return {
          ...toolText,
          assessmentToolText: displayName,
        };
      }
    }
  }

  return toolText;
};

export const getIsCurrentDateSelected = _.memoize(
  params => _getIsCurrentDateSelected(params),
  params => JSON.stringify(params)
);

const _getIsCurrentDateSelected = ({ date }) => {
  if (_.isEmpty(date)) return false;
  return moment().isSame(moment(date, "YYYY-MM-DD"), "day");
};

export const getTemplateArrayMemoize = _.memoize(
  params => getTemplateArray(params),
  params => JSON.stringify(params)
);

const getTemplateArray = params => _.filter(params, param => !_.isEmpty(param));

const _getscheduleOrDeadlineTime = params => {
  const {
    date,
    minuteStep = 15,
    is24HourFormat = true,
    defaultStartTime = "00:00",
  } = params;

  const isCurrentDateSelected = getIsCurrentDateSelected({
    date,
  });

  const startTime = isCurrentDateSelected
    ? moment().format("HH:mm")
    : defaultStartTime;

  const timelineLabels = getTimelineLabels({
    interval: minuteStep,
    period: "m",
    startTime,
    minuteDifference: 0,
  });

  const minTime = _.first(timelineLabels)?.value;

  if (is24HourFormat) {
    const minTimeIn24HourFormat = moment(minTime, "hh:mm a").format("HH:mm");

    return {
      time: minTimeIn24HourFormat,
      isCurrentDateSelected,
      startTime,
    };
  } else {
    return { time: minTime, isCurrentDateSelected, startTime };
  }
};

export const getScheduleOrDeadlineTime = getMemoizedItemsFunction({
  fn: _getscheduleOrDeadlineTime,
  items: ["TIMEZONE"],
});

const evaluationColumnsHeaderStyle = {
  textAlign: "center",
  marginLeft: 0,
};

const assessmentToolEvaluationStyle = {
  display: "flex",
  justifyContent: "space-between",
};

const getAllSubmissionsColumnsArray = ({
  showEditEvaluationIcon,
  isGradingPeriodUnlocked,
  canPerformActionsInAssignment,
}) => [
  {
    id: "student",
    localeKey: "classRoom:student_name",
  },
  {
    id: "aiAnalysis",
    localeKey: "ai:ai_analysis",
  },
  {
    id: "attachments",
    localeKey: "classRoom:student_work",
  },
  {
    id: "assessmentTool",
    localeKey: "common:le_assessmentTools_label",
    icon: <ClipboardPencilLinesOutlined size={"xxx-small"} />,
    showIcon: showEditEvaluationIcon && canPerformActionsInAssignment,
    iconTextLocaleKey: "common:edit",
    style: assessmentToolEvaluationStyle,
    disabled: !isGradingPeriodUnlocked,
    disabledTooltip:
      "classRoom:you_cannot_edit_the_evaluation_as_grading_period_locked",
  },
  {
    id: "screenAbsenceTracker",
    localeKey: "classRoom:screen_absence_tracker",
  },
  { id: "timeTaken", localeKey: "common:time_taken", isCenterAligned: true },
  {
    id: "submission",
    localeKey: "classRoom:turned_in",
    style: evaluationColumnsHeaderStyle,
    isCenterAligned: true,
  },
  {
    id: "evaluation",
    localeKey: "common:evaluation",
    style: evaluationColumnsHeaderStyle,
    isCenterAligned: true,
  },
  {
    id: "complete",
    localeKey: "common:complete",
    style: evaluationColumnsHeaderStyle,
    isCenterAligned: true,
  },
  {
    id: "shared",
    localeKey: "common:shared",
    style: evaluationColumnsHeaderStyle,
    isCenterAligned: true,
  },
  {
    id: "actions",
    localeKey: "",
  },
];

export const getIsOnlyLearningGoalsAvailable = ({
  someToolsHaveEval,
  leHasPypEvaluation,
  isUsingScoreAssessment,
}) => {
  return leHasPypEvaluation && !someToolsHaveEval && !isUsingScoreAssessment;
};

const getAllSubmissionsColumns = ({
  isPrivate,
  canEvaluate,
  isOnlyLearningGoalsAvailable,
  isStudentSubmissionEnabled,
  showActionsColumn,
  someToolsHaveEval,
  assessmentType,
  isTimedTestEnabled,
  isLockScreenEnabled,
  isSafeBrowserEnabled,
  isGradingPeriodUnlocked,
  canPerformActionsInAssignment = true,
  isTeacherEvaluationEnabled,
}) => {
  const isWorksheet = assessmentType === ASSESSMENT_TYPE_WORKSHEET;
  const isAITutor = assessmentType == ASSESSMENT_TYPE_AI_TUTOR;
  const showEditEvaluationIcon =
    (someToolsHaveEval || isOnlyLearningGoalsAvailable) &&
    isTeacherEvaluationEnabled;
  let columns = getAllSubmissionsColumnsArray({
    showEditEvaluationIcon,
    isGradingPeriodUnlocked,
    canPerformActionsInAssignment,
  });
  const isEvaluation = canEvaluate && isTeacherEvaluationEnabled;

  // in case of private post hide shared section
  if (isPrivate) {
    columns = _.filter(columns, ({ id }) => id !== "shared");
  }

  return _.filter(columns, column => {
    switch (column?.id) {
      case "assessmentTool":
        return canEvaluate;
      case "evaluation":
      case "shared":
        return isEvaluation;
      case "complete":
        return !isEvaluation;
      case "attachments":
        return isWorksheet || isAITutor ? false : isStudentSubmissionEnabled;
      case "aiAnalysis":
        return isAITutor;
      case "submission":
        return isStudentSubmissionEnabled;
      case "actions":
        return showActionsColumn;
      case "screenAbsenceTracker":
        return (
          isWorksheet &&
          isTimedTestEnabled &&
          (isLockScreenEnabled || isSafeBrowserEnabled)
        );
      case "timeTaken":
        return isWorksheet && isTimedTestEnabled;
      default:
        return true;
    }
  });
};

export const getAllSubmissionsColumnsMemoized = _.memoize(
  getAllSubmissionsColumns,
  params => JSON.stringify(params)
);

export const getAllSubmissionsStatusRevamp = params => {
  const {
    columnId,
    t,
    isTeacherEvaluationEnabled = false,
    isEvaluated = false,
    isSharedWithStudent = false,
    isPrivate = false,
    isEvaluationApplicable,
    omitKeys = [],
    submission,
    isBackdateAssignment,
    status,
  } = params;

  let statusTooltip = "";
  const statusTagState = {
    showTag: true,
    tagIcon: <ClockTimerOutlined variant={"subtle"} size={"xx-small"} />,
    tagColor: "neutral",
    tagLabel: t("common:pending"),
    tagTooltip: t("classRoom:submission_pending"),
  };

  const extraParams = {};

  const { returnedAt, statusV2: submissionStatus, submittedAt } =
    submission || {};
  const { isSubmissionStatusOverridden } = getSubmissionStatus({ submission });
  const displaySubmittedAt = isSubmissionStatusOverridden ? null : submittedAt;

  const formattedSubmissionDate = displaySubmittedAt
    ? formatDate({
        date: displaySubmittedAt,
        format: "hh:mm a, Do MMMM YYYY",
      })
    : null;

  const formattedReturnedDate = returnedAt
    ? moment(returnedAt).format("hh:mm a, Do MMMM YYYY")
    : null;
  const isResubmissionTagRevampEnabled = getIsSubmissionStatusOverrideEnabled();

  switch (columnId) {
    case "submission":
      switch (submissionStatus) {
        case "REQUEST_RESUBMISSION":
          statusTagState.tagColor = "neutral";
          if (isResubmissionTagRevampEnabled) {
            statusTagState.tagLabel = t("common:pending");
            statusTagState.tagIcon = (
              <ClockTimerOutlined variant={"subtle"} size={"xx-small"} />
            );
            statusTagState.tagTooltip = t("common:pending");
            extraParams.isResubmission = true;
            extraParams.resubmissionTooltip = t(
              "classRoom:resubmission_requested_on_label",
              {
                label: formattedReturnedDate,
              }
            );
          } else {
            statusTagState.tagLabel = t("classRoom:request_resubmission");
            statusTagState.tagIcon = (
              <ReSubmissionRequestOutlined
                variant={"subtle"}
                size={"xx-small"}
              />
            );
            statusTagState.tagTooltip = t(
              "classRoom:resubmission_requested_on_label",
              {
                label: formattedReturnedDate,
              }
            );
          }
          break;
        case "REQUEST_RESUBMISSION_OVERDUE":
          statusTagState.tagColor = "yellow";
          if (isResubmissionTagRevampEnabled) {
            statusTagState.tagLabel = t("classRoom:overdue");
            statusTagState.tagIcon = (
              <ClockOutlined variant="warning" size="xx-small" />
            );
            statusTagState.tagTooltip = t("classRoom:overdue");
            extraParams.isResubmission = true;
            extraParams.resubmissionTooltip = t(
              "classRoom:resubmission_requested_on_label",
              {
                label: formattedReturnedDate,
              }
            );
          } else {
            statusTagState.tagLabel = t("classRoom:resubmission_overdue");
            statusTagState.tagIcon = (
              <ReSubmissionRequestOutlined variant="warning" size="xx-small" />
            );
            statusTagState.tagTooltip = t(
              "classRoom:resubmission_requested_on_label",
              {
                label: formattedReturnedDate,
              }
            );
            extraParams.tagLabelStyle = {
              whiteSpace: "pre-wrap",
            };
            extraParams.tagWrapperStyle = {
              display: "flex",
              alignItems: "flex-start",
            };
          }
          break;
        case "TURNED_IN_LATE":
          statusTagState.tagColor = "blue";
          statusTagState.tagLabel = t("common:late_with_label", {
            label: t("classRoom:turned_in"),
          });
          statusTagState.tagIcon = (
            <ApprovalTickOutlined variant="link" size="xx-small" />
          );
          statusTagState.tagTooltip = formattedSubmissionDate
            ? t("classRoom:turned_in_late_at_label", {
                label: formattedSubmissionDate,
              })
            : t("classRoom:turned_in_late");
          break;
        case "TURNED_IN_ON_TIME":
          statusTagState.tagColor = "teal";
          statusTagState.tagLabel = t("classRoom:turned_in");
          statusTagState.tagIcon = (
            <TickSmallOutlined variant="success" size="xx-small" />
          );
          if (isBackdateAssignment) {
            statusTagState.tagTooltip = formattedSubmissionDate
              ? t("classRoom:turned_in_at_label", {
                  label: formattedSubmissionDate,
                })
              : t("classRoom:turned_in");
          } else {
            statusTagState.tagTooltip = formattedSubmissionDate
              ? t("classRoom:turned_in_on_time_at_label", {
                  label: formattedSubmissionDate,
                })
              : t("classRoom:turned_in_on_time");
          }
          break;
        case "OVERDUE":
          statusTagState.tagColor = "yellow";
          statusTagState.tagLabel = t("classRoom:overdue");
          statusTagState.tagIcon = (
            <ClockOutlined variant="warning" size="xx-small" />
          );
          statusTagState.tagTooltip = t("classRoom:submission_overdue");
          break;
        case "NOT_SUBMITTED":
          statusTagState.tagColor = "red";
          statusTagState.tagLabel = t("classRoom:not_submitted");
          statusTagState.tagIcon = (
            <CloseCircleOutlined variant="critical" size="xx-small" />
          );
          statusTagState.tagTooltip = t("classRoom:not_submitted");
          break;
        case "RESUBMISSION_NOT_SUBMITTED":
          statusTagState.tagColor = "red";
          if (isResubmissionTagRevampEnabled) {
            statusTagState.tagLabel = t("classRoom:not_submitted");
            statusTagState.tagIcon = (
              <CloseCircleOutlined variant="critical" size="xx-small" />
            );
            statusTagState.tagTooltip = t("classRoom:not_submitted");
            extraParams.isResubmission = true;
            extraParams.resubmissionTooltip = t(
              "classRoom:resubmission_requested_on_label",
              {
                label: formattedReturnedDate,
              }
            );
          } else {
            statusTagState.tagLabel = t("classRoom:resubmission_not_submitted");
            statusTagState.tagIcon = (
              <CloseCircleOutlined variant="critical" size="xx-small" />
            );
            statusTagState.tagTooltip = t(
              "classRoom:resubmission_requested_on_label",
              {
                label: formattedReturnedDate,
              }
            );
          }
          break;
      }
      break;
    case "evaluation":
      if (isTeacherEvaluationEnabled && isEvaluated) {
        statusTagState.tagColor = "teal";
        statusTagState.tagLabel = t("classRoom:evaluated");
        statusTagState.tagIcon = (
          <TickSmallOutlined variant="success" size="xx-small" />
        );
        statusTagState.tagTooltip = t("classRoom:evaluation_complete");
      } else {
        statusTagState.tagColor = "neutral";
        statusTagState.tagLabel = t("common:pending");
        statusTagState.tagIcon = (
          <ClockTimerOutlined variant={"subtle"} size={"xx-small"} />
        );
        statusTagState.tagTooltip = t("classRoom:evaluation_pending");
      }
      break;
    case "complete":
      if (isEvaluated) {
        statusTagState.tagColor = "teal";
        statusTagState.tagLabel = t("classRoom:completed");
        statusTagState.tagIcon = (
          <TickSmallOutlined variant="success" size="xx-small" />
        );
        statusTagState.tagTooltip = t(
          "assessmentEvaluation:marked_as_complete"
        );
      } else {
        statusTagState.tagColor = "neutral";
        statusTagState.tagLabel = t("common:pending");
        statusTagState.tagIcon = (
          <ClockTimerOutlined variant={"subtle"} size={"xx-small"} />
        );
        statusTagState.tagTooltip = t("common:pending");
      }

      break;
    case "shared":
      if (isSharedWithStudent && !isPrivate) {
        statusTagState.tagColor = "teal";
        statusTagState.tagLabel = t("classRoom:shared");
        statusTagState.tagIcon = (
          <TickSmallOutlined variant="success" size="xx-small" />
        );
        statusTagState.tagTooltip = t(
          "assessmentEvaluation:evaluation_shared_with_students_and_parents"
        );
      } else {
        statusTagState.tagColor = "neutral";
        statusTagState.tagLabel = t("common:pending");
        statusTagState.tagIcon = (
          <ClockTimerOutlined variant={"subtle"} size={"xx-small"} />
        );
        statusTagState.tagTooltip = t(
          "assessmentEvaluation:evaluation_not_shared_with_students_and_parents"
        );
      }
      break;
    default:
      statusTooltip = "";
      break;
  }
  return {
    statusTooltip,
    statusTagState: _.omit(statusTagState, omitKeys),
    showStatusIcon:
      isEvaluationApplicable ||
      (columnId === "submission" &&
        getIsEnabledExcusedStatusInAssignment() &&
        status === "EVALUATION_NOT_APPLICABLE" &&
        _.includes(
          ["TURNED_IN", "TURNED_IN_ON_TIME", "TURNED_IN_LATE"],
          submissionStatus
        )),
    ...extraParams,
  };
};

const getAllSubmissionsStatus = params => {
  const {
    columnId,
    t,
    isSubmittedVal = false,
    isTeacherEvaluationEnabled = false,
    isStudentEvaluationEnabled = false,
    isEvaluated = false,
    isSharedWithStudent = false,
    toolResponses = [],
    isEvaluationApplicable = false,
    isOverdue = false,
    isLateSubmission = false,
    submissionDate,
    isResubmissionRequested = false,
    teacherEvaluationTickClass,
    isPrivate = false,
    isMediaCard = false,
  } = params;

  if (!isMediaCard) return getAllSubmissionsStatusRevamp(params);

  let statusTooltip = "";
  let statusIcon = null;
  let showStatusIcon =
    isEvaluationApplicable ||
    (getIsEnabledExcusedStatusInAssignment() && columnId === "submission");
  const statusTagState = {
    showTag: false,
    tagIcon: null,
    tagColor: "neutral",
    tagLabel: null,
    tagTooltip: null,
  };
  const isStudentEvaluationDone = getIsEvaluationDone({
    toolResponses,
    creatorType: "STUDENT",
  });
  const formattedSubmissionDate = moment(submissionDate).format(
    "hh:mma, Do MMMM YYYY"
  );

  switch (columnId) {
    case "submission":
      if (isLateSubmission && submissionDate) {
        statusTagState.tagTooltip = t("classRoom:handed_in_at_time", {
          time: formattedSubmissionDate,
        });
      }
      statusTooltip = isSubmittedVal
        ? t("assessmentEvaluation:submission_turned_in")
        : t("classRoom:submission_pending");
      statusIcon = isSubmittedVal ? (
        <TickSmallOutlined variant="success" size="xx-small" />
      ) : (
        <WarningCircleOutlined disabled size="xxx-small" />
      );
      statusTagState.showTag =
        (isSubmittedVal && isLateSubmission) ||
        (!isSubmittedVal && (isOverdue || isResubmissionRequested));
      statusTagState.tagColor = isOverdue
        ? "yellow"
        : isLateSubmission
        ? "blue"
        : "neutral";
      statusTagState.tagLabel = isOverdue
        ? t("classRoom:overdue")
        : isLateSubmission
        ? t("classRoom:late")
        : t("classRoom:resubmission");
      statusTagState.tagIcon = isOverdue ? (
        <ClockTimerOutlined size="xxxx-small" variant="warning" />
      ) : isLateSubmission ? (
        <ClockOutlined size="xxxx-small" />
      ) : (
        <ReSubmissionRequestOutlined size="xxxx-small" />
      );
      break;
    case "evaluation":
      statusTooltip =
        (isStudentEvaluationEnabled && isStudentEvaluationDone) ||
        (isTeacherEvaluationEnabled && isEvaluated) ? (
          <>
            {isStudentEvaluationEnabled && (
              <>
                {t("assessmentEvaluation:name_evaluation_with_label", {
                  name: t("common:student"),
                  label: isStudentEvaluationDone
                    ? t("common:complete")
                    : t("common:pending"),
                })}
                <br />
              </>
            )}
            {isTeacherEvaluationEnabled &&
              t("assessmentEvaluation:name_evaluation_with_label", {
                name: t("common:teacher"),
                label: isEvaluated ? t("common:complete") : t("common:pending"),
              })}
          </>
        ) : (
          t("classRoom:evaluation_pending")
        );
      statusIcon =
        (isStudentEvaluationEnabled && isStudentEvaluationDone) ||
        (isTeacherEvaluationEnabled && isEvaluated) ? (
          <>
            {isStudentEvaluationEnabled && (
              <TickSmallOutlined
                variant="default"
                disabled={!isStudentEvaluationDone}
                size={"xxx-small"}
              />
            )}

            {isTeacherEvaluationEnabled && (
              <TickSmallOutlined
                variant="success"
                disabled={!isEvaluated}
                size={"xxx-small"}
                className={teacherEvaluationTickClass}
              />
            )}
          </>
        ) : (
          <WarningCircleOutlined disabled size="xxx-small" />
        );
      break;
    case "complete":
      statusTooltip = isEvaluated
        ? t("assessmentEvaluation:marked_as_complete")
        : t("common:pending");
      statusIcon = isEvaluated ? (
        <TickSmallOutlined variant="success" size="xx-small" />
      ) : (
        <WarningCircleOutlined disabled size="xxx-small" />
      );
      showStatusIcon = true;
      break;
    case "shared":
      statusTooltip =
        isSharedWithStudent && !isPrivate
          ? t(
              "assessmentEvaluation:evaluation_shared_with_students_and_parents"
            )
          : t(
              "assessmentEvaluation:evaluation_not_shared_with_students_and_parents"
            );
      statusIcon =
        isSharedWithStudent && !isPrivate ? (
          <TickSmallOutlined variant="success" size="xx-small" />
        ) : (
          <WarningCircleOutlined disabled size="xxx-small" />
        );
      break;
    default:
      statusTooltip = "";
      break;
  }
  return {
    statusTooltip,
    statusIcon,
    statusTagState,
    showStatusIcon,
  };
};

export const getAllSubmissionsStatusMemoized = _.memoize(
  getAllSubmissionsStatus,
  params => JSON.stringify(params)
);

const getAllSubmissionsFilterIds = ({
  selectedSubmissionsCount,
  selectedStudentsSubmissions,
  assignedStudents,
}) => {
  const sortedAssignedStudents =
    selectedSubmissionsCount > 0
      ? selectedStudentsSubmissions
      : assignedStudents;

  const submissionsCanBeReturned = _.map(
    _.filter(
      sortedAssignedStudents,
      item =>
        getSubmissionStatus({ submission: _.get(item, "submission", {}) })
          ?.isSubmitted &&
        !_.get(item, "isEvaluated", false) &&
        _.get(item, "isSubmitted", false)
    ),
    submission => submission?.id
  );

  const submissionsCanBeShared = _.map(
    _.filter(
      sortedAssignedStudents,
      item =>
        getIsEvaluationApplicable(
          _.get(item, "isEvaluationApplicable", false)
        ) &&
        _.get(item, "isEvaluated", false) &&
        !_.get(item, "isSharedWithStudent", false)
    ),
    submission => submission?.id
  );

  const submissionsCanBeUnshared = _.map(
    _.filter(
      sortedAssignedStudents,
      item =>
        getIsEvaluationApplicable(
          _.get(item, "isEvaluationApplicable", false)
        ) &&
        _.get(item, "isEvaluated", false) &&
        _.get(item, "isSharedWithStudent", false)
    ),
    submission => submission?.id
  );

  const notSharedWithStudents = _.map(
    _.filter(
      sortedAssignedStudents,
      item => !_.get(item, "isSharedWithStudent", false)
    ),
    submission => submission?.id
  );

  const notSubmittedCount = _.get(
    _.filter(
      sortedAssignedStudents,
      item => !_.get(item, "isSubmitted", false)
    ),
    "length",
    0
  );

  const notEvaluatedStudents = _.map(
    _.filter(
      sortedAssignedStudents,
      item => !_.get(item, "isEvaluated", false)
    ),
    submission => submission?.id
  );

  const evaluationNotApplicableStudents = _.map(
    _.filter(
      sortedAssignedStudents,
      item => !_.get(item, "isEvaluationApplicable", false)
    ),
    submission => submission?.id
  );

  const closedSubmissions = _.map(
    _.filter(sortedAssignedStudents, ({ lockingState } = {}) => {
      const state = _.get(lockingState, "state", "");
      return state === "LOCKED";
    }),
    submission => submission?.id
  );

  const openSubmissions = _.map(
    _.filter(sortedAssignedStudents, ({ lockingState } = {}) => {
      const state = _.get(lockingState, "state", "");
      return state !== "LOCKED";
    }),
    submission => submission?.id
  );

  const draftSubmissionsCount = _.size(
    _.filter(
      sortedAssignedStudents,
      item =>
        getSubmissionStatus({ submission: _.get(item, "submission", {}) })
          ?.isDraftSubmission
    )
  );

  return {
    submissionsCanBeReturned,
    submissionsCanBeShared,
    submissionsCanBeUnshared,
    notSharedWithStudents,
    notSubmittedCount,
    notEvaluatedStudents,
    evaluationNotApplicableStudents,
    closedSubmissions,
    openSubmissions,
    draftSubmissionsCount,
  };
};

export const getAllSubmissionsFilterIdsMemoized = _.memoize(
  getAllSubmissionsFilterIds,
  params => JSON.stringify(params)
);

export const getSomeToolsHaveEval = ({ assessmentTools }) => {
  return _.some(assessmentTools?.edges, ({ node }) => {
    const assessmentToolType = _.get(node, "assessmentToolType", "");
    return _.get(
      _.find(ASSESSMENT_TOOLS, ({ type }) => type === assessmentToolType),
      "hasEvaluation",
      false
    );
  });
};

const _getAllowTeacherAndStudentEval = ({ assessmentToolType }) => {
  const toolHasEval = _.get(
    _.find(ASSESSMENT_TOOLS, ({ type }) => type === assessmentToolType),
    "hasEvaluation",
    false
  );

  switch (assessmentToolType) {
    case SCORE:
    case COMMENT:
    case DP_ASSESSMENT_RUBRIC:
    case ASSESSMENT_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY:
      return {
        allowTeacherEval: true,
        allowStudentEval: false,
        toolHasEval,
      };
    default: {
      if (toolHasEval) {
        return {
          allowTeacherEval: true,
          allowStudentEval: true,
          toolHasEval,
        };
      } else {
        return {
          allowTeacherEval: false,
          allowStudentEval: false,
          toolHasEval,
        };
      }
    }
  }
};

export const getAllowTeacherAndStudentEval = _.memoize(
  params => _getAllowTeacherAndStudentEval(params),
  params => JSON.stringify(params)
);

const _getIsAssessmentEmpty = params => {
  const { assessmentTool, assessmentToolType } = params;

  switch (assessmentToolType) {
    case "RUBRIC": {
      const isDescriptorsEmpty = _.every(
        assessmentTool?.descriptors,
        descriptor => {
          const label = _.get(descriptor, "label", "");
          return _.isEmpty(label);
        }
      );

      const isIndicatorsEmpty = _.every(
        assessmentTool?.indicators,
        indicator => {
          const label = _.get(indicator, "label", "");
          return _.isEmpty(label);
        }
      );

      return isDescriptorsEmpty && isIndicatorsEmpty;
    }

    case "SINGLE_POINT_RUBRIC":
      return _.every(assessmentTool?.standards, standard => {
        const title = _.get(standard, "title", "");
        const subTitle = _.get(standard, "subTitle", "");
        return _.isEmpty(title) && _.isEmpty(subTitle);
      });
    case "CHECKLIST":
      return _.every(assessmentTool?.checklistItems, item => {
        const label = _.get(item, "label", "");
        return _.isEmpty(label);
      });

    case MYP_OBJECTIVE_RUBRIC:
    case MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC:
      return _.isEmpty(assessmentTool?.descriptors);
    default:
      _.isEmpty(assessmentTool);
  }
};

export const getIsAssessmentToolEmpty = _.memoize(
  params => _getIsAssessmentEmpty(params),
  params => JSON.stringify(params)
);

const getMediaManagerAssessmentToolProps = params => {
  const { t, assessmentTool, scores = {}, assessmentToolType } = params;

  const toolLocale = t(
    _.find(ASSESSMENT_TOOLS, ({ type }) => {
      return type === assessmentToolType;
    })?.locale
  );

  switch (assessmentToolType) {
    case SCORE:
      return {
        name: toolLocale,
        type: _.replace("SCORE_BASED_ASSESSMENT", /_/g, " "),
        subtext: t("classRoom:max_score_label", {
          label: _.get(scores, `${assessmentToolType}`),
        }),
      };
    case DP_ASSESSMENT_RUBRIC:
      return {
        name: _.get(assessmentTool, "label"),
        type: _.replace(assessmentToolType, /_/g, " "),
        subtext: t("classRoom:max_marks", {
          marks: _.get(scores, `${assessmentToolType}`),
        }),
      };
    case ASSESSMENT_GRADE_BOUNDARY:
      return {
        name: t("common:ib_grade"),
        type: assessmentToolType,
        icon: <SortOutlined />,
        subtext: t("classRoom:manually_graded"),
      };
    case ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY: {
      return {
        name: t("common:ib_grade"),
        type: assessmentToolType,
        icon: <SortOutlined />,
        subtext: t("classRoom:automatically_graded"),
      };
    }
    case MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC: {
      return {
        name: toolLocale,
        type: _.replace(assessmentToolType, /_/g, " "),
        subtext: null,
        icon: <SinglePointRubricOutlined />,
      };
    }
  }

  return {
    name: toolLocale,
    type: _.replace(assessmentToolType, /_/g, " "),
    subtext: null,
    icon: null,
  };
};

export const getAssessmentToolTypeForMediaCard = params => {
  const { t, subtext = "", sourceFrom } = params;
  let { assessmentToolType } = params;

  switch (sourceFrom) {
    case "MEDIA_MANAGER":
      return getMediaManagerAssessmentToolProps(params);
    default: {
      const toolLocale = t(
        _.find(ASSESSMENT_TOOLS, ({ type }) => {
          return type === assessmentToolType;
        })?.locale
      );

      switch (assessmentToolType) {
        case SCORE:
          {
            assessmentToolType = "SCORE_BASED_ASSESSMENT";

            if (!_.isEmpty(subtext)) {
              return {
                type: _.replace(assessmentToolType, /_/g, " "),
                subtext,
              };
            }
          }
          break;
        case DP_ASSESSMENT_RUBRIC:
          {
            if (!_.isEmpty(subtext)) {
              return {
                type: _.replace(assessmentToolType, /_/g, " "),
                subtext,
              };
            }
          }
          break;
        case ASSESSMENT_GRADE_BOUNDARY:
        case ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY:
        case ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY:
        case ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY: {
          return {
            type: assessmentToolType,
            icon: <SortOutlined />,
            subtext: t?.("common:ib_grade"),
          };
        }
        case ANALYSIS:
        case MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC: {
          return {
            type: _.replace(assessmentToolType, /_/g, " "),
            subtext: toolLocale,
            icon: <SinglePointRubricOutlined />,
          };
        }
        case SCORE_BASED_RUBRIC:
        case STANDARD_BASED_RUBRIC: {
          return {
            type: _.replace(assessmentToolType, /_/g, " "),
            subtext: toolLocale,
            icon: <RubricOutlined />,
          };
        }

        case GRADE_SCALE_TOOL: {
          return {
            type: _.replace(assessmentToolType, /_/g, " "),
            subtext: toolLocale,
            icon: <BadgeStarOutlined />,
          };
        }
      }

      if (ACLStore.can("FeatureFlag:EnableAssessmentGradebookDataGrid")) {
        switch (assessmentToolType) {
          case SINGLE_POINT_RUBRIC: {
            return {
              type: _.replace(assessmentToolType, /_/g, " "),
              subtext: toolLocale,
              icon: <ConfigureColumnsOutlined />,
            };
          }
          case CHECKLIST: {
            return {
              type: assessmentToolType,
              subtext: toolLocale,
              icon: <HamburgerOutlined />,
            };
          }
        }
      }

      return {
        type: _.replace(assessmentToolType, /_/g, " "),
        subtext: toolLocale,
        icon: null,
      };
    }
  }
};

const _getPendingEvaluationCount = ({
  toolResponses: toolResponsesData,
  creatorType = "STUDENT",
  assessmentTools = [],
}) => {
  return _.reduce(
    toolResponsesData,
    (result, { toolResponses, toolId, toolType }) => {
      const { allowStudentEval } =
        getAllowTeacherAndStudentEval({ assessmentToolType: toolType }) || {};

      const currentAssessmentTool = _.find(
        assessmentTools?.edges || assessmentTools,
        ({ node }) => {
          return _.get(node, "assessmentToolItem.id") === toolId;
        }
      );

      const isStudentEvaluationEnable = _.get(
        currentAssessmentTool,
        "node.isStudentEvaluationEnable",
        false
      );

      const hasAddedToolResponse = !_.isEmpty(
        _.find(
          toolResponses,
          toolResponse => _.get(toolResponse, "creatorType") === creatorType
        )
      );

      const hasAddedResponse =
        isStudentEvaluationEnable && !hasAddedToolResponse && allowStudentEval;

      return (result += hasAddedResponse ? 1 : 0);
    },
    0
  );
};

export const getPendingEvaluationCount = _.memoize(
  params => _getPendingEvaluationCount(params),
  params => JSON.stringify(params)
);

export const getCurrentStudentData = ({
  assignedStudents,
  studentAssignmentId,
}) => {
  return _.find(assignedStudents, { id: studentAssignmentId }) || {};
};

const _reorderTools = ({
  assessmentTools,
  hasEdges = true,
  addMYPCriteria = false,
  hasEvaluation = false,
  customOrder = [],
  excludeAssessmentToolTypes = [],
}) => {
  const _assessmentTools = hasEdges ? assessmentTools?.edges : assessmentTools;

  const scoreTool = [];
  const scoreBasedRubricTool = [];
  const standardBasedRubricTool = [];
  const commentTool = [];
  const ibGradeScaleTool = [];
  const gradeScaleTool = [];
  const remainingTools = [];

  _.forEach(_assessmentTools, ({ node }) => {
    const assessmentToolType = _.get(node, "assessmentToolType");

    switch (assessmentToolType) {
      case SCORE:
        scoreTool.push({ node });
        break;
      case SCORE_BASED_RUBRIC:
        scoreBasedRubricTool.push({ node });
        break;
      case STANDARD_BASED_RUBRIC:
        standardBasedRubricTool.push({ node });
        break;
      case GRADE_SCALE_TOOL:
        gradeScaleTool.push({ node });
        break;
      case COMMENT:
        commentTool.push({ node });
        break;
      case ASSESSMENT_GRADE_BOUNDARY:
      case ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY:
      case ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY:
      case ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY:
        ibGradeScaleTool.push({ node });
        break;
      case MYP_OBJECTIVE_RUBRIC:
      case MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC:
        {
          if (addMYPCriteria) {
            const criteriaNode = {
              id: `${node?.id}_CRITERIA`,
              assessmentToolType: "CRITERIA",
              parentAssessmentToolType: assessmentToolType,
              assessmentToolItem: {},
              isTeacherEvaluationEnable: node?.isTeacherEvaluationEnable,
              isStudentEvaluationEnable: node?.isStudentEvaluationEnable,
            };

            remainingTools.push({ node: criteriaNode });
            remainingTools.push({ node });
          } else {
            remainingTools.push({ node });
          }
        }
        break;
      default:
        remainingTools.push({ node });
    }
  });

  let allTools = [];
  // New order: SCORE, SCORE_BASED_RUBRIC, STANDARD_BASED_RUBRIC, GRADE_SCALE_TOOL, IB_GRADE_SCALE, COMMENT, REMAINING_TOOLS
  const defaultOrder = [
    SCORE,
    SCORE_BASED_RUBRIC,
    STANDARD_BASED_RUBRIC,
    GRADE_SCALE_TOOL,
    "IB_GRADE_SCALE",
    COMMENT,
    "REMAINING_TOOLS",
  ];
  const toolsOrder = !_.isEmpty(customOrder) ? customOrder : defaultOrder;

  _.map(toolsOrder, toolType => {
    switch (toolType) {
      case SCORE:
        allTools.push(...scoreTool);
        break;
      case SCORE_BASED_RUBRIC:
        allTools.push(...scoreBasedRubricTool);
        break;
      case STANDARD_BASED_RUBRIC:
        allTools.push(...standardBasedRubricTool);
        break;
      case GRADE_SCALE_TOOL:
        allTools.push(...gradeScaleTool);
        break;
      case COMMENT:
        allTools.push(...commentTool);
        break;
      case "IB_GRADE_SCALE":
        allTools.push(...ibGradeScaleTool);
        break;
      case "REMAINING_TOOLS":
        allTools.push(...remainingTools);
        break;
    }
  });

  if (!_.isEmpty(excludeAssessmentToolTypes)) {
    allTools = _.filter(allTools, ({ node }) => {
      return !_.includes(excludeAssessmentToolTypes, node?.assessmentToolType);
    });
  }

  if (hasEvaluation) {
    allTools = _.filter(allTools, ({ node }) => {
      const assessmentToolType = _.get(node, "assessmentToolType");

      const _hasEvaluation = _.get(
        _.find(ASSESSMENT_TOOLS, ({ type }) => type === assessmentToolType),
        "hasEvaluation",
        false
      );

      return addMYPCriteria || _hasEvaluation;
    });
  }

  return allTools;
};

export const reorderTools = _.memoize(
  params => _reorderTools(params),
  params => JSON.stringify(params)
);

const genericRatingOptions = ["1", "2", "3", "4", "5", "6", "7"];
const tokRatingOptions = ["A", "B", "C", "D", "E"];

const _getCategoriesForGradeBoundaryTool = params => {
  const {
    subjectType,
    type = ASSESSMENT_GRADE_BOUNDARY,
    gradeBoundary,
    subjectLevelGenericTags = [],
  } = params || {};

  if (type === ASSESSMENT_GRADE_BOUNDARY) {
    const isTOK = subjectType === "TOK";
    const options = isTOK ? tokRatingOptions : genericRatingOptions;

    return _.map(options, (option, index) => {
      return { label: option, displaySequence: index + 1 };
    });
  }

  return _.map(gradeBoundary, (boundary, index) => {
    const grade = _.get(boundary, "grade", "");

    const tags = !_.isEmpty(subjectLevelGenericTags)
      ? subjectLevelGenericTags
      : [{ label: "SL" }];

    return {
      label: _.toString(grade),
      values: _.map(tags, tag => {
        const tagLabel = _.get(tag, "label", "");
        const scoreRange = _.get(boundary, tagLabel, {});

        return {
          minValue: _.toNumber(_.get(scoreRange, "minValue", "")),
          maxValue: _.toNumber(_.get(scoreRange, "maxValue", "")),
          genericTagId: _.get(tag, "id", null),
          valueType: "RANGE",
          weightageType: "NUMBER",
        };
      }),
      displaySequence: index + 1,
    };
  });
};

export const getCategoriesForGradeBoundaryTool = _.memoize(
  params => _getCategoriesForGradeBoundaryTool(params),
  params => JSON.stringify(params)
);

export const getCurrentButtonActionObject = ({
  t,
  isEvaluationApplicable,
  isSharedWithStudent,
  isEvaluated,
  isPrivate,
  isTeacherEvaluationEnabled,
  onClickMarkEvaluatedBtn,
  onClickEditEvaluationBtn,
  onClickEvaluationApplicableBtn,
  onClickShareWithStudentBtn,
}) => {
  // first check if evaluation is not applicable
  // then check if the evaluation is shared with the student
  // then check if it is evaluated by the teacher
  // and finally check if the teacher evaluation is enabled
  if (!isEvaluationApplicable) {
    return {
      buttonText: getIsEnabledExcusedStatusInAssignment()
        ? t("classRoom:remove_excused_status")
        : t("assessmentEvaluation:enable_evaluation"),
      onClick: onClickEvaluationApplicableBtn,
    };
  } else if (isSharedWithStudent) {
    return {
      buttonText: t("assessmentEvaluation:edit_evaluation"),
      onClick: onClickEditEvaluationBtn,
    };
  } else if (isEvaluated) {
    if (isTeacherEvaluationEnabled && !isPrivate) {
      return {
        buttonText: t(
          "assessmentEvaluation:label_evaluation_with_student_and_family",
          {
            label: t("common:share"),
          }
        ),
        onClick: onClickShareWithStudentBtn,
      };
    } else {
      return {
        buttonText:
          isPrivate && isTeacherEvaluationEnabled
            ? t("assessmentEvaluation:edit_evaluation")
            : t("common:edit"),
        onClick: onClickEditEvaluationBtn,
      };
    }
  } else if (isTeacherEvaluationEnabled) {
    return {
      buttonText: t("assessmentEvaluation:mark_as_evaluated"),
      onClick: onClickMarkEvaluatedBtn,
    };
  } else {
    return {
      buttonText: t("assessmentEvaluation:mark_as_completed"),
      onClick: onClickMarkEvaluatedBtn,
    };
  }
};

const _getDPCriteriaRatedScore = params => {
  const {
    assessmentTool = {},
    ibPYPElementRatings = [],
    ratedCriteria: ratedCriteriaParam,
  } = params || {};

  const criteria = _.get(assessmentTool, "criteria", []);
  const criteriaIds = _.map(criteria, "id");

  let ratedCriteria;
  if (!_.isEmpty(ratedCriteriaParam)) {
    ratedCriteria = ratedCriteriaParam;
  } else {
    ratedCriteria = _.filter(ibPYPElementRatings, rating => {
      return (
        _.get(rating, "ibPYPElementType") === "DP_CRITERIA" &&
        _.includes(criteriaIds, _.get(rating, "ibPYPElementId")) &&
        (!_.has(rating, "isDeleted") || !_.get(rating, "isDeleted"))
      );
    });

    ratedCriteria = _.map(ratedCriteria, rating => {
      return {
        ibPYPElementId: rating?.ibPYPElementId,
        value: rating?.value,
      };
    });
  }

  const totalScore = getTotalScoreMemoized({
    criterionIds: [],
    criteria,
  });

  const { value: totalRatedScore, showDash } = getRatedScoreMemoized({
    criterionIds: [],
    ratedCriteria,
  });

  return {
    totalScore,
    totalRatedScore,
    showDash,
  };
};

export const getDPCriteriaRatedScore = _.memoize(
  params => _getDPCriteriaRatedScore(params),
  params => JSON.stringify(params)
);

const getEditAssessmentLabel = type => {
  switch (type) {
    case "fmt":
      return "common:formative_assessment";
    case "smt":
      return "common:summative_assessment";
    case "le":
      return "community:learning_experience";
    case "qt":
      return "common:quick_task";
    case ASSESSMENT_TYPE_WORKSHEET:
      return "common:worksheet";
  }
};

// Used for create assignment flow from COURSE_FLOW in new course stup
export const getCreateAssignmentModalData = ({
  t,
  key,
  ubdAssessmentTypes,
  currentAssessmentTypes,
}) => {
  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();
  const assignmentModalData = {
    mode: "create",
    creationMode: key,
    initialStep: getInitialStep({
      creationMode: key,
      shouldCreateAssessment: false,
    }),
    contentType: "ASSESSMENT",
  };

  if (isAssessmentTypeConfigurationEnabled) {
    const { localeLabel = "", label = "" } =
      currentAssessmentTypes?.[key] || {};
    const assessmentTypeLabel = localeLabel ? t(localeLabel) : label;

    assignmentModalData["steps"] = [
      {
        label: t("common:create_with_label", {
          label: t("common:lowercase", {
            text: t("common:assessment"),
          }),
        }),
        value: "ASSESSMENT_CREATION",
        heading:
          ("common:create_with_label",
          {
            label: t("common:lowercase", {
              text: t("common:assessment"),
            }),
          }),
      },
      {
        label: t("classRoom:post_settings"),
        value: "SETTINGS",
        heading: t("classRoom:post_settings"),
        subHeading: t("classRoom:classes_discussion_shared_with"),
      },
    ];
    assignmentModalData["createHeader"] =
      assessmentTypeLabel || t("classRoom:create_assessment_classroom");
    assignmentModalData["assessmentType"] =
      key || _.get(_.keys(ubdAssessmentTypes), "[0]", "pt");

    return assignmentModalData;
  }

  switch (key) {
    case "CREATE_LE": {
      assignmentModalData["steps"] = [
        {
          label: t("classRoom:assessment_details", {
            label: t("common:le_label"),
          }),
          value: "LE_CREATION",
          heading: t("classRoom:assessment_details", {
            label: t("common:le_label"),
          }),
        },
        {
          label: t("classRoom:post_settings"),
          value: "SETTINGS",
          heading: t("classRoom:post_settings"),
          subHeading: t("classRoom:classes_discussion_shared_with"),
        },
      ];
      assignmentModalData["createHeader"] = t("classRoom:create_le");
      assignmentModalData["assessmentType"] = "le";

      return assignmentModalData;
    }

    case "CREATE_FA": {
      assignmentModalData["steps"] = [
        {
          label: t("classRoom:assessment_details", {
            label: t("common:formative_assessment"),
          }),
          value: "FMT_CREATION",
          heading: t("classRoom:assessment_details", {
            label: t("common:formative_assessment"),
          }),
        },
        {
          label: t("classRoom:post_settings"),
          value: "SETTINGS",
          heading: t("classRoom:post_settings"),
          subHeading: t("classRoom:classes_discussion_shared_with"),
        },
      ];
      assignmentModalData["createHeader"] = t("classRoom:create_fa");
      assignmentModalData["assessmentType"] = "fmt";

      return assignmentModalData;
    }

    case "CREATE_SA": {
      assignmentModalData["steps"] = [
        {
          label: t("classRoom:assessment_details", {
            label: t("common:summative_assessment"),
          }),
          value: "SMT_CREATION",
          heading: t("classRoom:assessment_details", {
            label: t("common:summative_assessment"),
          }),
        },
        {
          label: t("classRoom:post_settings"),
          value: "SETTINGS",
          heading: t("classRoom:post_settings"),
          subHeading: t("classRoom:classes_discussion_shared_with"),
        },
      ];
      assignmentModalData["createHeader"] = t("classRoom:create_sa");
      assignmentModalData["assessmentType"] = "smt";

      return assignmentModalData;
    }

    case "CREATE_ASSESSMENT": {
      assignmentModalData["steps"] = [
        {
          label: t("common:create_with_label", {
            label: t("common:lowercase", {
              text: t("common:assessment"),
            }),
          }),
          value: "ASSESSMENT_CREATION",
          heading:
            ("common:create_with_label",
            {
              label: t("common:lowercase", {
                text: t("common:assessment"),
              }),
            }),
        },
        {
          label: t("classRoom:post_settings"),
          value: "SETTINGS",
          heading: t("classRoom:post_settings"),
          subHeading: t("classRoom:classes_discussion_shared_with"),
        },
      ];
      assignmentModalData["createHeader"] = t(
        "classRoom:create_assessment_classroom"
      );
      assignmentModalData["assessmentType"] = _.get(
        _.keys(ubdAssessmentTypes),
        "[0]",
        "pt"
      );

      return assignmentModalData;
    }

    case "CREATE_WORKSHEET": {
      assignmentModalData["steps"] = [
        {
          label: t("common:details"),
          value: "WORKSHEET_QUESTION_CREATION",
          heading: t("classRoom:share_resources"),
          subHeading: t("classRoom:placeholder_for_subtext"),
        },
        {
          label: t("worksheet:questions"),
          value: "QUESTION_CREATION",
          heading: t("worksheet:questions"),
          subHeading: t("classRoom:classes_discussion_shared_with"),
        },
        {
          label: t("classRoom:assign_settings"),
          value: "SETTINGS",
          heading: t("classRoom:assign_settings"),
          subHeading: t("classRoom:classes_discussion_shared_with"),
        },
      ];
      assignmentModalData["createHeader"] = t("common:worksheet");
      assignmentModalData["assessmentType"] = ASSESSMENT_TYPE_WORKSHEET;

      return assignmentModalData;
    }
    case "CREATE_QUICK_TASK": {
      assignmentModalData["steps"] = [
        {
          label: t("common:description"),
          value: "QT_CREATION",
          heading: t("classRoom:share_resources"),
          subHeading: t("classRoom:placeholder_for_subtext"),
        },
        {
          label: t("classRoom:post_settings"),
          value: "SETTINGS",
          heading: t("classRoom:post_settings"),
          subHeading: t("classRoom:classes_discussion_shared_with"),
        },
      ];
      assignmentModalData["createHeader"] = t("classRoom:create_a_quick_task");
      assignmentModalData["assessmentType"] = "qt";

      return assignmentModalData;
    }

    case CREATE_AI_TUTOR: {
      assignmentModalData["steps"] = [
        {
          label: t("classRoom:assessment_details", {
            label: t("common:ai_tutor"),
          }),
          value: AI_TUTOR_CREATION,
          heading: t("classRoom:assessment_details", {
            label: t("common:ai_tutor"),
          }),
        },
      ];
      assignmentModalData["createHeader"] = t("classRoom:create_an_ai_tutor");
      assignmentModalData["assessmentType"] = ASSESSMENT_TYPE_AI_TUTOR;

      return assignmentModalData;
    }

    default:
      return {};
  }
};

export const getEditAssignmentModalDataBasedOnAssessmentType = ({
  t,
  content,
  courseId,
  currentAssessmentTypes,
  assessmentLabel,
  icon,
}) => {
  const assessmentType = _.get(content, "assessmentType.value");
  const { localeLabel = "", label = "" } =
    currentAssessmentTypes?.[assessmentType] || {};
  const assessmentTypeLabel = localeLabel ? t(localeLabel) : label;

  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();

  const assignmentModalData = {
    editHeaderText: isAssessmentTypeConfigurationEnabled
      ? assessmentLabel
      : t(`common:edit_with_label`, {
          label: t(`common:lowercase`, {
            text: assessmentType ? assessmentTypeLabel : t(`common:classwork`),
          }),
        }),
    courseId,
    assessmentType,
  };

  if (isAssessmentTypeConfigurationEnabled && icon) {
    assignmentModalData["icon"] = icon;
  }

  switch (assessmentType) {
    case ASSESSMENT_TYPE_WORKSHEET:
      assignmentModalData["steps"] = [
        {
          label: t("common:edit_with_label", {
            label: t(getEditAssessmentLabel(assessmentType)).toLowerCase(),
          }),
          value: "WORKSHEET_QUESTION_CREATION",
        },
        {
          label: t("worksheet:questions"),
          value: "QUESTION_CREATION",
          heading: t("worksheet:questions"),
          subHeading: t("classRoom:classes_discussion_shared_with"),
        },
        {
          label: t("classRoom:assign_settings"),
          value: "SETTINGS",
          heading: t("classRoom:assign_settings"),
        },
      ];
      break;

    case DP_EXPERIMENTAL_PROGRAMME:
    case DP_PRACTICAL_ACTIVITY:
      assignmentModalData["steps"] = [
        {
          label: t("common:details"),
          value: "ASSESSMENT_DETAILS",
        },
        {
          label: t("common:settings"),
          value: "SETTINGS",
          heading: t("common:settings"),
        },
      ];
      assignmentModalData["editHeaderText"] = t(`common:edit_with_label`, {
        label: t(`common:lowercase`, {
          text: t(`project:practical_activity`),
        }),
      });
      assignmentModalData["cancelBtnText"] = t("common:discard");
      assignmentModalData["assessmentType"] = assessmentType;
      break;
    case ASSESSMENT_TYPE_AI_TUTOR:
      assignmentModalData["steps"] = [
        {
          label: t("common:edit_with_label", {
            label: t(getEditAssessmentLabel(assessmentType)).toLowerCase(),
          }),
          value: AI_TUTOR_CREATION,
        },
      ];
      break;
    default:
      assignmentModalData["steps"] = [
        {
          label: t("common:edit_with_label", {
            label: t(getEditAssessmentLabel(assessmentType)).toLowerCase(),
          }),
          value: "ASSESSMENT_DETAILS",
        },
        {
          label: t("classRoom:post_settings"),
          value: "SETTINGS",
          heading: t("classRoom:post_settings"),
        },
      ];
  }

  return assignmentModalData;
};

export const getEditAssignmentModalData = ({
  t,
  assignment,
  courseId,
  currentAssessmentTypes,
  assessmentLabel,
  icon,
}) => {
  const assignmentModalData = {};

  const { contentType, content } = assignment || {};

  switch (contentType) {
    case "ASSESSMENT":
      return getEditAssignmentModalDataBasedOnAssessmentType({
        t,
        content,
        courseId,
        currentAssessmentTypes,
        assessmentLabel,
        icon,
      });
    case "ASSIGNMENT_RESOURCE":
    case "ASSIGNMENT_DISCUSSION":
      assignmentModalData["steps"] = [
        {
          label: t("common:description"),
          value: "DISCUSSION_CREATION",
          heading: t("classRoom:initiate_a_classroom_discussion"),
          subHeading: t("classRoom:student_response_to_discussion_prompts"),
        },
        {
          label: t("classRoom:post_settings"),
          value: "SETTINGS",
          heading: t("classRoom:select_classes_for_discussion"),
          subHeading: t("classRoom:discussion_will_happen_within_class_group"),
        },
      ];
      break;
  }

  return assignmentModalData;
};

export const getStudentTags = _.memoize(
  ({ studentCourseTags, studentId }) => {
    const courseMap = _.get(
      _.find(studentCourseTags, item => _.get(item, "id") === studentId),
      "courseMap",
      []
    );
    return _.get(_.first(courseMap, {}), "tags", []);
  },
  params => JSON.stringify(params)
);

// to skip getAssessmentToolNodeDetailsQuery for these tools

export const SKIP_ASSESSMENT_TOOL_NODE_TOOLS = [
  COMMENT,
  SCORE,
  ASSESSMENT_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
];

const _getStudentsSortedBySubjectLevel = params => {
  const { students = [], curriculumType, sortOrder = ["SL", "HL"] } =
    params || {};

  if (curriculumType === "IB_DP") {
    return students?.sort((student1, student2) => {
      const { tag: tag1 = {} } = student1 || {};
      const { tag: tag2 = {} } = student2 || {};

      return sortOrder?.indexOf(tag1?.label) - sortOrder?.indexOf(tag2?.label);
    });
  }

  return students;
};

export const getStudentsSortedBySubjectLevel = _.memoize(
  params => _getStudentsSortedBySubjectLevel(params),
  params => JSON.stringify(params)
);

const getScoreValueForIBGradeScale = ({ scoreValues, genericTagId }) => {
  // Priority 1: Find by generic tag ID (Exact match - student is SL then use SL boundary, HL then use HL boundary)
  const scoreValueByTagId = _.find(
    scoreValues,
    scoreValue => _.get(scoreValue, "genericTag.id") === genericTagId
  );

  if (scoreValueByTagId) {
    return scoreValueByTagId;
  }

  // Priority 2: Find by 'SL' label (in case of custom subject level use SL as default)
  const scoreValueBySLLabel = _.find(
    scoreValues,
    scoreValue => _.get(scoreValue, "genericTag.label") === "SL"
  );

  if (scoreValueBySLLabel) {
    return scoreValueBySLLabel;
  }

  // Priority 3: Fall back to the first available scoreValue.
  // V2 grade scale 2.0 uses dynamic level labels (e.g. "CL", "FL") instead of
  // the hardcoded "SL". For no-level assignments where the student has no level
  // tag (genericTagId=undefined), both Priority 1 and 2 fail. Using the first
  // scoreValue ensures auto-calculate works regardless of level label naming.
  const firstScoreValue = _.first(scoreValues);
  if (firstScoreValue) {
    return firstScoreValue;
  }

  return {};
};

export const getGradeBoundaryMaxVal = ({
  academicCriteriaValues,
  genericTagId,
}) => {
  return _.reduce(
    academicCriteriaValues,
    (result, value) => {
      const { scoreValues } = value || {};
      const { maxValue } = getScoreValueForIBGradeScale({
        scoreValues,
        genericTagId,
      });

      if (maxValue > result) {
        result = maxValue;
        return result;
      }

      return result;
    },
    0
  );
};

export const getIBGradeScaleRatingFromScore = params => {
  const {
    studentId,
    maxScore,
    studentCourseTags,
    assessmentTools,
    ibPYPElementRatings = [],
    scoreValue,
  } = params;

  const {
    node: { assessmentToolItem: assessmentTool, assessmentToolType } = {},
  } =
    _.find(assessmentTools?.edges, ({ node }) => {
      return getIsIBGradeScaleTool({
        assessmentToolType: _.get(node, "assessmentToolType"),
        checkForManual: false,
      });
    }) || {};

  if (_.isEmpty(assessmentTool)) return {};

  if (_.isEmpty(_.toString(scoreValue))) {
    return {
      gradeScaleRating: scoreValue,
      assessmentTool,
      assessmentToolType,
    };
  }
  const assessmentToolId = _.get(assessmentTool, "id");
  const academicCriteriaValues = _.get(
    assessmentTool,
    "academicCriteriaValues"
  );

  const selectedCriteria = _.find(ibPYPElementRatings, rating => {
    return (
      _.get(rating, "ibPYPElementId") === assessmentToolId &&
      !_.get(rating, "isDeleted")
    );
  });

  const tags = getStudentTags({ studentCourseTags, studentId });
  const genericTagId = _.get(tags, "0.id");

  const gradeBoundaryMaxValue = getGradeBoundaryMaxVal({
    academicCriteriaValues,
    genericTagId,
  });

  const scaledValue = compareInScaledRange({
    value: scoreValue,
    fromRange: {
      min: 0,
      max: _.toNumber(maxScore),
    },
    toRange: {
      min: 0,
      max: gradeBoundaryMaxValue,
    },
  });

  // sort based on minValue to compare with scaledValue
  const sortedAcademicCriteriaValues = _.orderBy(
    academicCriteriaValues,
    [
      value => {
        const { scoreValues } = value || {};
        const scoreValue = getScoreValueForIBGradeScale({
          scoreValues,
          genericTagId,
        });

        return _.get(scoreValue, "minValue", 0);
      },
    ],
    ["desc"]
  );

  const criteriaValue = _.find(sortedAcademicCriteriaValues, value => {
    const { scoreValues } = value || {};
    const { minValue } = getScoreValueForIBGradeScale({
      scoreValues,
      genericTagId,
    });

    return minValue <= scaledValue;
  });

  const criteriaId = _.get(criteriaValue, "id");
  const score = _.get(criteriaValue, "label");

  if (
    criteriaId === selectedCriteria?.academicCriteriaValue?.id &&
    !_.includes(selectedCriteria?.id, "NEW")
  ) {
    return {};
  }

  if (studentId && score && criteriaId) {
    return {
      gradeScaleRating: score,
      valueId: criteriaId,
      assessmentTool,
      assessmentToolType,
    };
  }
};

export const getIsIBGradeScaleTool = ({
  assessmentToolType,
  checkForManual = true,
}) => {
  const tools = [
    ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
    ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
    ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
  ];

  if (checkForManual) {
    tools.push(ASSESSMENT_GRADE_BOUNDARY);
  }

  return _.includes(tools, assessmentToolType);
};

// Get assessment templates id based on curriculum ID and task type ID
export const getTemplateIdFromTaskType = (
  taskTypeId,
  gradeId,
  curriculumId,
  isGradeWiseAssessment = false
) => {
  const data = getAssessmentTemplatesFromCache(curriculumId);

  if (_.isEmpty(data)) {
    return null;
  }

  const taskTypes = _.get(data, "taskTypes", []);

  const taskType = _.find(taskTypes, { id: taskTypeId });

  if (_.isEmpty(taskType)) {
    return null;
  }

  const templates = _.get(taskType, "templates", []);

  // Filter templates by grade if grade-wise assessment is enabled and gradeId is provided
  if (isGradeWiseAssessment && gradeId) {
    const filteredTemplates = _.filter(templates, template => {
      const templateGrades = _.get(template, "grades", []);
      return _.some(templateGrades, grade => grade.id === gradeId);
    });

    if (_.isEmpty(filteredTemplates)) {
      return _.get(_.first(templates), "id", null);
    } else {
      return _.get(_.first(filteredTemplates), "id", null);
    }
  }

  // When not filtering by grade, return the first template
  return _.get(_.first(templates), "id", null);
};

// Get dynamic assessment type options based on curriculum and grade
export const getDynamicAssessmentTypeOptions = ({ curriculumId, gradeId }) => {
  const data = getAssessmentTemplatesFromCache(curriculumId);

  if (_.isEmpty(data)) {
    return [];
  }

  const taskTypes = _.get(data, "taskTypes", []);

  const isGradeWiseAssessment = ACLStore.can(ENABLE_GRADE_WISE_ASSESSMENT);
  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();

  // Map task types to create options
  const createOptions = _.map(taskTypes, taskType => {
    const taskTypeValue = _.get(taskType, "type", "");
    const taskTypeLabel = _.get(taskType, "label", "");
    const taskTypeId = _.get(taskType, "id", "");
    const color = _.get(taskType, "color", "");

    const templateId = getTemplateIdFromTaskType(
      taskTypeId,
      gradeId,
      curriculumId,
      isGradeWiseAssessment
    );

    const avatarName = getTaskTypeAvatarName({
      type: taskTypeValue,
      label: taskTypeLabel,
      isAssessmentTypeConfigurationEnabled,
    });

    return {
      taskTypeId,
      label: taskTypeLabel,
      key: taskTypeId,
      value: taskTypeId,
      taskType: taskTypeValue,
      templateId,
      color,
      icon: (
        <Avatar
          shape="square"
          size="large"
          name={avatarName}
          color={color}
          dsVersion="2.0"
        />
      ),
      hasTermDependency: true,
      noTermsDisabledTooltip:
        "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      ...(taskTypeValue === TASK_TYPE_WORKSHEET
        ? { perm: "FeatureFlag:ClassroomWorksheet" }
        : {}),
    };
  });

  return createOptions;
};

export const getAssignmentDropdownOptions = ({
  curriculumType,
  globalGradeUid,
  filterOptions = ["SCHEDULE_VIDEO_CALL"],
  curriculumId,
  subjectType,
}) => {
  let options = [];

  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();

  if (isAssessmentTypeConfigurationEnabled) {
    // Use new assessment type options for create section
    const createOptions = [
      {
        label: "common:create",
        key: "create",
        isItemGroup: true,
        options: getDynamicAssessmentTypeOptions({
          curriculumId,
          gradeId: globalGradeUid,
        }),
      },
    ];

    // Use existing import options based on curriculum type
    let importOptionsGroup;
    switch (curriculumType) {
      case CURRICULUM_TYPE_UBD:
        importOptionsGroup = UBD_IMPORT_OPTIONS_GROUP;
        break;
      case CURRICULUM_TYPE_MYP:
        importOptionsGroup = MYP_IMPORT_OPTIONS_GROUP;
        break;
      case CURRICULUM_TYPE_DP:
        importOptionsGroup = DP_IMPORT_OPTIONS_GROUP;
        break;
      default:
        importOptionsGroup = PYP_IMPORT_OPTIONS_GROUP;
    }
    options = _.isArray(importOptionsGroup)
      ? [...createOptions, ...importOptionsGroup]
      : [...createOptions, importOptionsGroup];
  } else {
    switch (curriculumType) {
      case CURRICULUM_TYPE_UBD:
        options = UBD_ASSIGNMENT_OPTIONS_NEW;
        break;
      case CURRICULUM_TYPE_MYP:
        options = MYP_ASSIGNMENT_OPTIONS_NEW;
        break;
      case CURRICULUM_TYPE_DP:
        options = DP_ASSIGNMENT_OPTIONS_NEW;
        if (subjectType === SUBJECT_TYPE_EE && getIsAITutorInEEEnabled()) {
          // Filter import from unit and library
          options = _.filter(options, ({ key }) => key === "create");
          const allowedKeys = [CREATE_QUICK_TASK, CREATE_AI_TUTOR];

          options = _.map(options, option => {
            if (option?.key === "create") {
              const filteredOptions = _.filter(option?.options, ({ key }) =>
                allowedKeys.includes(key)
              );

              return {
                ...option,
                options: filteredOptions,
              };
            }

            return option;
          });
        }
        break;
      default:
        options = ASSIGNMENT_CREATE_OPTIONS_NEW;
    }
  }

  // If toddle library is enabled, hide community flow
  if (
    isToddleLibraryEnabled() &&
    _.isEqual(curriculumType, CURRICULUM_TYPE_PYP)
  ) {
    filterOptions.push("IMPORT_LE_FROM_COMMUNITY");
  }

  if (
    _.isEqual(CURRICULUM_TYPE_DP, curriculumType) &&
    !isToddleLibraryEnabledForWorksheets({
      curriculumType,
      globalGradeUid,
    })
  ) {
    filterOptions.push("IMPORT_FROM_TODDLE_LIBRARY");
  }

  // Check if tutor marketing and AI tutor both are disabled, then hide AI tutor

  const isTutorAndMarketingBothDisabled =
    !getIsAITutorEnabled() && !isAITutorMarketingEnabled();

  if (isTutorAndMarketingBothDisabled) {
    filterOptions.push(CREATE_AI_TUTOR);
  }

  const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

  if (isLearningCoursesEnabled) {
    filterOptions.push("UNIT", "IMPORT_LE");
  }

  if (!_.isEmpty(filterOptions)) {
    return _.map(options, option => {
      const innerOptions = _.get(option, "options", []);
      const filteredInnerOptions = _.filter(innerOptions, innerOption => {
        return !_.includes(filterOptions, innerOption?.key);
      });

      return {
        ...option,
        options: filteredInnerOptions,
      };
    });
  }

  return options;
};

export const getSortedStudentsByTags = params => {
  const { assignedStudents, curriculumType } = params || {};

  if (curriculumType === CURRICULUM_TYPE_DP) {
    return _.orderBy(
      assignedStudents,
      [
        assignedStudent =>
          _.get(assignedStudent, "student.courseMap.0.tags.0.label"),
      ],
      "desc"
    );
  }

  return assignedStudents;
};

export const mergeAssignedStudentsWithTags = params => {
  const { assignedStudents = [], studentCourseTags = [] } = params || {};

  return _.map(assignedStudents, assignedStudent => {
    const { courseMap = {} } =
      _.find(
        studentCourseTags,
        student => student?.id === assignedStudent?.student?.id
      ) || {};

    return {
      ...assignedStudent,
      student: {
        ..._.get(assignedStudent, "student", {}),
        courseMap,
      },
    };
  });
};

export const getAutoEvaluateIBGradeToolTypeName = ({
  t,
  assessmentToolType,
}) => {
  let label = "";
  switch (assessmentToolType) {
    case ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY:
      label = t("classRoom:category_grade_boundary");
      break;
    case ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY:
      label = t("classRoom:term_grade_boundary");
      break;
    case ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY:
      label = t("classRoom:custom_grade_boundary");
      break;
    default:
      label = t("academicSetup:grade_boundary");
  }

  return t("classRoom:using_with_label", { label });
};

export const getSubjectLevelLabel = params => {
  const {
    fields = [],
    genericTags = [],
    showColoredTags = false,
    showDsTags = false,
  } = params || {};

  const subjectLevelField = _.find(fields, { uid: "subjectLevel" }) || {};
  const subjectLevelValue = _.get(subjectLevelField, "value", []);

  const subjectLevel = !_.isEmpty(subjectLevelField)
    ? _.filter(genericTags, tag => {
        const tagId = _.get(tag, "id", "");
        return _.includes(subjectLevelValue, tagId);
      })
    : [];

  const style = { display: "flex", alignItems: "center", gap: "4px" };

  if (showColoredTags) {
    return _.map(subjectLevel, (level, index) => {
      const isLast = _.size(subjectLevel) - 1 === index;

      const label = _.get(level, "label");
      const { textColor, color } = _.get(GENERIC_TAGS_INFO, `${label}`) || {};

      return (
        <>
          <div style={{ color: textColor || color }}>{label}</div>
          {!isLast ? (
            <span>
              {","}
              &nbsp;
            </span>
          ) : null}
        </>
      );
    });
  } else if (showDsTags) {
    return (
      <div style={style}>
        {_.map(subjectLevel, (level, index) => {
          const label = _.get(level, "label");
          const { color } = _.get(GENERIC_TAGS_INFO, `${label}`) || {};

          return (
            <Tag dsVersion="2.0" size="small" color={color}>
              {label}
            </Tag>
          );
        })}
      </div>
    );
  } else {
    const subjectLevelLabelList = _.map(subjectLevel, level =>
      _.get(level, "label")
    );

    const subjectLevelLabel = !_.isEmpty(subjectLevelLabelList)
      ? _.join(subjectLevelLabelList, ", ")
      : null;

    return subjectLevelLabel;
  }
};
const _getAllSubmissionsSortDropdownOptions = ({ t }) => {
  const optionList = [
    {
      key: "1",
      label: t("common:first_name_az"),
      type: "FIRST_NAME",
    },
    {
      key: "2",
      label: t("common:first_name_za"),
      type: "FIRST_NAME",
    },
    {
      key: "3",
      label: t("common:middle_name_az"),
      type: "MIDDLE_NAME",
    },
    {
      key: "4",
      label: t("common:middle_name_za"),
      type: "MIDDLE_NAME",
    },
    {
      key: "5",
      label: t("common:last_name_az"),
      type: "LAST_NAME",
    },
    {
      key: "6",
      label: t("common:last_name_za"),
      type: "LAST_NAME",
    },
    {
      key: "7",
      label: t("common:full_name_az"),
      type: "FULL_NAME",
    },
    {
      key: "8",
      label: t("common:full_name_za"),
      type: "FULL_NAME",
    },
  ];
  return [
    {
      isItemGroup: true,
      key: "1",
      label: t("common:sort_by"),
      options: getStudentSortByList({
        sortList: optionList,
        keyToMap: "type",
      }),
    },
  ];
};

export const getAllSubmissionsSortDropdownOptions = _.memoize(
  _getAllSubmissionsSortDropdownOptions,
  params => JSON.stringify(params)
);

export const getAllSubmissionsSortOptions = ({
  params,
  columnId,
  sortOptions,
  defaultSortOptions,
}) => {
  switch (columnId) {
    case "student":
      switch (_.get(params, "key", "")) {
        case "1":
          return {
            value: "FIRST_NAME",
            order: "asc",
          };
        case "2":
          return {
            value: "FIRST_NAME",
            order: "desc",
          };
        case "3":
          return {
            value: "MIDDLE_NAME",
            order: "asc",
          };
        case "4":
          return {
            value: "MIDDLE_NAME",
            order: "desc",
          };
        case "5":
          return {
            value: "LAST_NAME",
            order: "asc",
          };
        case "6":
          return {
            value: "LAST_NAME",
            order: "desc",
          };
        case "7":
          return {
            value: "FULL_NAME",
            order: "asc",
          };
        case "8":
          return {
            value: "FULL_NAME",
            order: "desc",
          };
        default:
          return defaultSortOptions;
      }
    case "submission":
    case "shared":
    case "complete":
    case "evaluation": {
      const { value, order } = sortOptions;
      switch (`${value}.${order}`) {
        case `${columnId}.asc`:
          return {
            value: columnId,
            order: "desc",
          };
        case `${columnId}.desc`:
          return defaultSortOptions;
        default:
          return {
            value: columnId,
            order: "asc",
          };
      }
    }
  }
};

const _getAllSubmissionsSortOrder = ({ assignedStudent, sortOptions }) => {
  const { value } = sortOptions;
  switch (value) {
    case "FIRST_NAME":
    case "LAST_NAME":
    case "MIDDLE_NAME":
      return _.toLower(
        _.get(assignedStudent, `student.${_.camelCase(value)}`, "")
      );
    case "submission": {
      const { submissionStatus } = getSubmissionStatus({
        submission: _.get(assignedStudent, "submission", {}),
      });
      switch (submissionStatus) {
        case "TURNED_IN_ON_TIME":
          return 0;
        case "TURNED_IN_LATE":
          return 1;
        case "RETURNED":
        case "REQUEST_RESUBMISSION":
        case "REQUEST_RESUBMISSION_OVERDUE":
          return 2;
        case "DRAFT":
        case "SUBMISSION_PENDING":
          return 3;
        default:
          return 4;
      }
    }
    case "shared":
      return _.get(assignedStudent, "isSharedWithStudent") ? 0 : 1;
    case "complete":
      return _.get(assignedStudent, "status", "") === "COMPLETED" ? 0 : 1;
    case "evaluation":
      return _.get(assignedStudent, "isEvaluated", false) ? 0 : 1;
    default:
      return 5;
  }
};

export const getAllSubmissionsSortOrder = _.memoize(
  _getAllSubmissionsSortOrder,
  ({ assignedStudent, sortOptions }) =>
    JSON.stringify({
      statusV2: _.get(assignedStudent, "submission.statusV2", ""),
      isSharedWithStudent: _.get(assignedStudent, "isSharedWithStudent"),
      status: _.get(assignedStudent, "status", ""),
      isEvaluated: _.get(assignedStudent, "isEvaluated", false),
      name: _.get(assignedStudent, "student", {}),
      sortOptionsValue: _.get(sortOptions, "value", ""),
    })
);

const _getAllSubmissionsSortButtonIcon = ({ sortOptions, columnId }) => {
  const { value, order } = sortOptions;
  switch (`${value}.${order}`) {
    case `${columnId}.asc`:
      return <DownArrowOutlined />;
    case `${columnId}.desc`:
      return <UpArrowOutlined />;
    default:
      return <UpDownArrowOutlined />;
  }
};

export const getAllSubmissionsSortButtonIcon = _.memoize(
  _getAllSubmissionsSortButtonIcon,
  params => JSON.stringify(params)
);

export const getAllSubmissionsSortDropdownValue = ({ sortOptions }) => {
  const { value, order } = sortOptions;
  switch (`${value}.${order}`) {
    case "FIRST_NAME.asc":
      return "1";
    case "FIRST_NAME.desc":
      return "2";
    case "MIDDLE_NAME.asc":
      return "3";
    case "MIDDLE_NAME.desc":
      return "4";
    case "LAST_NAME.asc":
      return "5";
    case "LAST_NAME.desc":
      return "6";
    case "FULL_NAME.asc":
      return "7";
    case "FULL_NAME.desc":
      return "8";
    default:
      return "";
  }
};

export const getAllSubmissionsNameFormatOrder = ({
  sortOptions,
  defaultStudentNameSortPreference,
}) => {
  return _.includes(
    ["FIRST_NAME", "MIDDLE_NAME", "LAST_NAME"],
    sortOptions?.value
  )
    ? sortOptions?.value
    : defaultStudentNameSortPreference;
};

const _getDPCriteriaRubricHeaderSubtext = ({
  assessmentTool,
  t,
  showLabel = true,
}) => {
  const genericTags = _.isEmpty(_.get(assessmentTool, "genericTags", []))
    ? _.get(assessmentTool, "presetRubric.genericTags", [])
    : _.get(assessmentTool, "genericTags", []);
  const levelTags = _.join(
    _.map(genericTags, tag => _.get(tag, "label", "")),
    ", "
  );
  const type = _.get(assessmentTool, "presetRubric.subType", "");
  const typeLabel =
    type === "INTERNAL"
      ? t("project:internal_assessment")
      : type === "EXTERNAL"
      ? t("project:external_assessment")
      : "";

  const subtextItems = [levelTags, typeLabel];

  if (showLabel) {
    subtextItems.unshift(_.get(assessmentTool, "label", ""));
  }

  return _.join(
    _.filter(subtextItems, item => !_.isEmpty(item)),
    " • "
  );
};

export const getDPCriteriaRubricHeaderSubtext = _.memoize(
  _getDPCriteriaRubricHeaderSubtext,
  params => JSON.stringify(params)
);

const _getAssessmentToolSubtext = ({ assessmentTool, t }) => {
  return _.get(assessmentTool, "presetRubric.subType", "") === "INTERNAL"
    ? t("project:internal_assessment")
    : _.get(assessmentTool, "presetRubric.subType", "") === "EXTERNAL"
    ? t("project:external_assessment")
    : "";
};

export const getAssessmentToolSubtext = _.memoize(
  _getAssessmentToolSubtext,
  params => JSON.stringify(params)
);

export const isNullJSONString = str => {
  try {
    return _.isNil(JSON.parse(str));
  } catch (e) {
    return false;
  }
};

export const getMediaCardRatings = params => {
  const {
    key,
    toolResponses,
    ibPYPElementRatings,
    assessmentToolType,
    elementRemarks,
    assessmentTools,
    course,
    curriculumProgramType,
  } = params || {};

  if (key === "LEARNING_GOALS") {
    const elements =
      EVALUATE_PLANNER_ELEMENTS_BY_CURRICULUM?.[curriculumProgramType];

    const elementValues = _.map(elements, element => {
      return pypElementMapping?.[element?.value];
    });

    const learningGoalsRating = _.filter(
      ibPYPElementRatings,
      rating =>
        _.includes(elementValues, _.get(rating, "ibPYPElementType")) &&
        _.get(rating, "isDeleted") === false
    );

    return { isResponseAdded: !_.isEmpty(learningGoalsRating) };
  }

  const toolResponsesData = _.map(toolResponses, toolResponse => {
    return {
      ...toolResponse,
      toolResponses: _.filter(toolResponse?.toolResponses, response => {
        return _.get(response, "isDeleted") === false;
      }),
    };
  });

  const isResponseAdded = getIsResponseAdded({
    toolResponsesData,
    ibPYPElementRatings,
    assessmentToolType,
    elementRemarks,
  });

  switch (assessmentToolType) {
    case SCORE: {
      const score = _.get(
        _.find(
          ibPYPElementRatings,
          rating =>
            _.get(rating, "ibPYPElementType") === assessmentToolType &&
            _.get(rating, "isDeleted") === false
        ),
        "value"
      );

      const { maxScore } = getScoreDetailsMemoize({
        assessmentTools,
      });

      return { score, maxScore, isResponseAdded, showDash: false };
    }

    case DP_ASSESSMENT_RUBRIC: {
      const assessmentTool = _.find(assessmentTools?.edges, ({ node }) => {
        return _.get(node, "assessmentToolType") === DP_ASSESSMENT_RUBRIC;
      })?.node?.assessmentToolItem;

      const criteria = _.get(assessmentTool, "criteria", {});
      const criteriaIds = _.map(criteria, "id");

      let ratedCriteria = _.filter(ibPYPElementRatings, rating => {
        return (
          _.get(rating, "ibPYPElementType") === "DP_CRITERIA" &&
          _.includes(criteriaIds, _.get(rating, "ibPYPElementId")) &&
          _.get(rating, "isDeleted") === false
        );
      });

      ratedCriteria = _.map(ratedCriteria, rating => {
        return {
          ibPYPElementId: rating?.ibPYPElementId,
          value: rating?.value,
        };
      });

      const maxScore = getTotalScoreMemoized({
        criterionIds: [],
        criteria,
      });

      const { value: score, showDash } = getRatedScoreMemoized({
        criterionIds: [],
        ratedCriteria,
      });

      return { score, maxScore, showDash, isResponseAdded };
    }

    case ASSESSMENT_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY: {
      const ibGradeScaleObj = getStudentScore({
        assessmentToolType,
        ibPYPElementRatings,
      });

      const score = _.get(ibGradeScaleObj, "value", "");

      const academicCriteriaValues = _.find(
        assessmentTools?.edges,
        ({ node }) => {
          const assessmentToolType = _.get(node, "assessmentToolType");
          return getIsIBGradeScaleTool({ assessmentToolType });
        }
      )?.node?.assessmentToolItem?.academicCriteriaValues;

      const maxScore = _.size(academicCriteriaValues);

      // TOK has rating A to E so only show the rated alphabet
      const isTOK = _.get(course, "subjects.0.type") === "TOK";

      return { score, maxScore, showMaxScore: !isTOK, isResponseAdded };
    }
    case SCORE_BASED_RUBRIC:
    case STANDARD_BASED_RUBRIC: {
      const scoreBasedRubricTool = _.find(
        assessmentTools?.edges,
        ({ node }) => node?.assessmentToolType === assessmentToolType
      );

      const maxScore = _.get(
        scoreBasedRubricTool,
        "node.assessmentToolItem.associateScoreTool.scoreToolData.maxScore"
      );

      // standard based rubric with alpha scale grading scale case
      if (_.isEmpty(maxScore)) return { isResponseAdded };

      const score = _.get(
        _.find(
          ibPYPElementRatings,
          rating =>
            _.get(rating, "ibPYPElementType") === SCORE &&
            _.get(rating, "isDeleted") === false
        ),
        "value"
      );

      return {
        score,
        maxScore,
        isResponseAdded: isResponseAdded && score,
        showDash: false,
      };
    }

    case GRADE_SCALE_TOOL: {
      const score = _.get(
        _.find(
          ibPYPElementRatings,
          rating =>
            _.get(rating, "ibPYPElementType") === assessmentToolType &&
            _.get(rating, "isDeleted") === false
        ),
        "academicCriteriaValue.abbreviation"
      );

      return { score, isResponseAdded, showMaxScore: false };
    }

    default: {
      return { isResponseAdded };
    }
  }
};

export const getIsLessonPlanningEnabled = (
  assessmentType = "qt",
  taskTypeGroup
) => {
  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();
  if (isAssessmentTypeConfigurationEnabled) {
    return (
      !_.includes(
        [ASSESSMENT_TYPE_QUICK_TASK, TASK_TYPE_WORKSHEET, TASK_TYPE_AI_TUTOR],
        taskTypeGroup
      ) && ACLStore.can("FeatureFlag:AILessonPlanning")
    );
  }
  return (
    !_.includes(
      [
        ASSIGNMENT_TYPE_QUICK_TASK,
        ASSESSMENT_TYPE_WORKSHEET,
        ASSESSMENT_TYPE_AI_TUTOR,
      ],
      assessmentType
    ) && ACLStore.can("FeatureFlag:AILessonPlanning")
  );
};

export const getShowLessonPlanningAIByDefault = () => {
  return ACLStore.can("Common:ShowLessonPlanningAIByDefault");
};

export const getIsUnitPlanUpdateModalEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableUnitPlanUpdateModalInAssessment");
};

export const getSubmissionStatus = params => {
  const { submission, isWorksheet = false, isAITutor = false } = params;
  const { status, statusV2, systemStatus, isDraftSubmission = false } =
    submission || {};

  // Gate the override-aware `isSubmitted` derivation behind the submission-
  // status-override FF so the ACL can be flipped off per-org without a code
  // revert if the wider semantic change causes regressions in staging/prod.
  const isOverrideEnabled = getIsSubmissionStatusOverrideEnabled({
    isWorksheet,
    isAITutor,
  });

  return {
    submissionStatus: statusV2,
    status: statusV2,
    isSubmissionStatusOverridden:
      !_.isNil(systemStatus) && statusV2 !== systemStatus,
    isSubmitted:
      isOverrideEnabled && statusV2 !== "SUBMISSION_NOT_REQUIRED"
        ? DONE_STATUSES.includes(statusV2)
        : status === "SUBMITTED",
    isLateSubmission: statusV2 === "TURNED_IN_LATE",
    isOverdue: statusV2 === "OVERDUE",
    isResubmissionRequested: isOverrideEnabled
      ? RESUBMISSION_STATUSES.includes(statusV2)
      : status === "RETURNED",
    isStatusRevamp: true,
    isDraftSubmission,
  };
};

export const getRethumb = ({ cardDimensions }) => {
  return imageUrl => {
    const rethumpUrl = imageUrl
      ? getRethumbUrl({
          width: cardDimensions.width,
          height: cardDimensions.height,
          imageUrl: imageUrl,
          fitIn: true,
        })
      : "";
    return `url(${rethumpUrl})`;
  };
};

export const getAddToJournalTooltip = params => {
  const {
    isEvaluated,
    allowAddLEToJournal,
    isLTIAttachmentPresent,
    isWorksheet = false,
  } = params;

  if (isEvaluated && !allowAddLEToJournal && !isWorksheet) {
    return "journal:empty_responses_can_not_be_added";
  } else {
    if (isEvaluated) {
      if (isLTIAttachmentPresent) {
        return "classRoom:disabled_add_to_portfolio_external_tool";
      } else return "classRoom:add_response_to_portfolio";
    } else {
      return "classRoom:only_completed_evaluated_responses_can_be_added";
    }
  }
};

export const getAssessmentToolRevampedViewModeStyles = (params = {}) => {
  const { rubricCellMinWidth = "140px", rubricCellMaxWidth = "164px" } = params;
  const border = "1px solid var(--border-secondary)";

  const rubricStyles = {
    textAreaContainerStyle: {
      flexShrink: 1,
    },
    textAreaCustomStyles: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
      padding: "8px",
    },
    textAreaCustomHeaderStyles: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
      ...fontStyles.demiBold,
    },
    rowStyle: {
      minHeight: "56px",
      gap: "0px",
    },
    cellStyle: {
      borderRadius: "0px",
      border: "none",
      borderBottom: border,
      borderRight: border,
      maxWidth: rubricCellMaxWidth,
      minWidth: rubricCellMinWidth,
    },
    rowHeaderCellStyle: {
      backgroundColor: "var(--violet-950)",
      borderRadius: "0px",
      border,
      borderLeft: "none",
      maxWidth: rubricCellMaxWidth,
      minWidth: rubricCellMinWidth,
      height: "40px",
    },
    firstColumnCellStyle: {
      backgroundColor: "var(--violet-950)",
      border: "none",
      borderRadius: "0px",
      borderBottom: border,
      borderLeft: border,
      maxWidth: rubricCellMaxWidth,
      minWidth: rubricCellMinWidth,
    },
    emptyFirstCellColumnStyle: {
      backgroundColor: "var(--violet-950)",
      border,
      borderLeft: "none",
      padding: "8px",
      fontSize: "1.4rem",
      color: "var(--text-primary)",
      ...fontStyles.demiBold,
      height: "40px",
      borderRadius: "8px 0 0 0",
    },
    innerConStyle: {
      gap: "0px",
    },
    headerRowStyle: {
      gap: "0px",
    },
    bottomLeftContainerStyle: {
      gap: "0px",
    },
    topLeftCellStyle: {
      borderRadius: "8px 0 0 0",
    },
    topRightCellStyle: {
      borderRadius: "0 8px 0 0",
    },
    bottomLeftCellStyle: {
      borderRadius: "0 0 0 8px",
    },
    bottomRightCellStyle: {
      borderRadius: "0 0 8px 0",
    },
  };

  const singlePointRubricStyles = {
    containerStyle: {
      gap: "0px",
      border: "none",
      overflow: "hidden",
    },
    evaluationCellContainerStyle: {
      height: "100%",
    },
    rowStyle: {
      gap: "0px",
      minHeight: "auto",
    },
    cellStyle: {
      padding: "8px",
      minHeight: "auto",
      borderRadius: "0px",
      border,
      borderLeft: "none",
      borderTop: "none",
    },
    rowHeaderCellStyle: {
      backgroundColor: "var(--violet-950)",
      borderTop: border,
    },
    headerCellTitleStyle: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
      ...fontStyles.demiBold,
    },
    headerSubCellTitleStyle: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
    },
    headerRowStyle: {
      minHeight: "auto",
      gap: "0px",
    },
    subtitleContainerStyleV2: {
      marginTop: 0,
    },
    criteriaCellStyle: {
      backgroundColor: "var(--violet-950)",
    },
    nonCriteriaCellStyle: {
      backgroundColor: "var(--surface-primary-enabled)",
    },
    firstColumnCellStyle: {
      borderLeft: "1px solid var(--border-secondary)",
    },
    criteriaCellTitleStyle: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
      ...fontStyles.demiBold,
    },
    criteriaCellSubTitleStyle: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
    },
    topLeftCellStyle: {
      borderRadius: "8px 0 0 0",
      borderLeft: "1px solid var(--border-secondary)",
    },
    topRightCellStyle: {
      borderRadius: "0 8px 0 0",
    },
    bottomLeftCellStyle: {
      borderRadius: "0 0 0 8px",
    },
    bottomRightCellStyle: {
      borderRadius: "0 0 8px 0",
    },
  };

  const checklistStyles = {
    toolStyles: {
      checkListContainerStyle: {
        marginBottom: "0px",
        overflow: "auto",
        gap: "0px",
        border: "none",
      },
      rowStyle: {
        gap: "0px",
      },
      labelContainerStyle: {
        border: "none",
        minWidth: "240px",
        borderRadius: "0px",
        backgroundColor: "var(--violet-950)",
        borderBottom: border,
        borderRight: border,
        borderLeft: border,
      },
      topLeftCellStyle: {
        border,
        borderRadius: "8px 0 0 0",
      },
      optionContainerStyle: {
        gap: "0",
      },
      optionStyle: {
        borderRadius: "0px",
        border: "none",
        borderBottom: border,
        borderRight: border,
        padding: "8px",
        alignItems: "flex-start",
      },
      optionHeaderStyle: {
        borderBottom: border,
        borderTop: border,
        borderRadius: "0px",
        backgroundColor: "var(--violet-950)",
        color: "var(--text-primary)",
        fontSize: "1.4rem",
        ...fontStyles.demiBold,
        padding: "8px",
      },
      optionHeaderContainerStyle: {
        gap: "0px",
      },
      tableTextStyle: {
        color: "var(--text-primary)",
        fontSize: "1.4rem",
      },
      firstColumnTextStyle: {
        fontSize: "1.4rem",
        color: "var(--text-primary)",
        ...fontStyles.demiBold,
      },
      borderLeftContainerStyle: {
        gap: "0px",
      },
      containerStyle: {
        minHeight: "auto",
      },
      topRightCellStyle: {
        borderRadius: "0 8px 0 0",
        borderRight: border,
      },
      bottomLeftCellStyle: {
        borderRadius: "0 0 0 8px",
      },
      bottomRightCellStyle: {
        borderRadius: "0 0 8px 0",
      },
    },
    containerStyle: {
      width: "100%",
    },
  };

  const mypObjectiveRubricStyles = {
    cellStyle: {
      padding: "8px",
    },
    rubricHeaderRowCellStyle: {
      padding: "8px",
      backgroundColor: "var(--violet-950)",
      verticalAlign: "middle",
      ...fontStyles.demiBold,
      color: "var(--text-primary)",
    },
    textAreaContainerStyle: {
      flexShrink: 1,
    },
    textAreaCustomStyles: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
    },
    headerColumnCellStyles: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
      padding: "8px",
      backgroundColor: "var(--violet-950)",
      position: "unset",
    },
    lastRowCellStyles: {
      borderBottom: "none",
      borderRadius: "0 0 0 8px",
    },
    rubricRatingContainerStyle: {
      margin: "0",
    },
    subjectLabelStyle: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
      ...fontStyles.demiBold,
    },
  };

  const dpRubricStyles = {
    leafNodLabelStyles: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
    },
    accordianHeaderStyle: {
      padding: "16px 0",
    },
  };

  const standardRubricStyles = {
    containerStyle: {
      borderRadius: "8px",
      overflow: "auto",
    },
    criteriaCellStyle: {
      backgroundColor: "var(--violet-950)",
    },
  };

  return {
    rubricStyles,
    singlePointRubricStyles,
    checklistStyles,
    mypObjectiveRubricStyles,
    dpRubricStyles,
    standardRubricStyles,
  };
};

export const getAssessmentToolStyles = params => {
  const { uiType = "DEFAULT" } = params || {};

  switch (uiType) {
    case "COMPACT": {
      return {
        rubricStyles: {
          textAreaCustomStyles: {
            height: "unset",
            fontSize: "1.4rem",
            color: colors.textDefault,
            ...fontStyles.medium,
            padding: "8px 32px 8px 8px",
          },
          textAreaCustomHeaderStyles: {
            height: "unset",
            fontSize: "1.4rem",
            color: colors.textDefault,
            ...fontStyles.demiBold,
          },
          rowStyle: {
            minHeight: "56px",
            gap: "0px",
          },
          cellStyle: {
            borderRadius: "0px",
            border: "none",
            borderBottom: `1px solid ${colors.borderSubtle}`,
          },
          bottomContainerStyle: {
            marginTop: "8px",
          },
          rowHeaderCellStyle: {
            backgroundColor: colors.decorativeSurfaceTwoL,
            borderRadius: "0px",
            border: "none",
            borderBottom: `1px solid ${colors.borderSubtle}`,
            borderTop: `1px solid ${colors.borderSubtle}`,
          },
          firstColumnCellStyle: {
            backgroundColor: colors.decorativeSurfaceTwoL,
            border: "none",
            fontSize: "1.4rem",
            ...fontStyles.demiBold,
            color: colors.textDefault,
            padding: "0px",
            borderRadius: "0px",
            borderBottom: `1px solid ${colors.borderSubtle}`,
          },
          firstColumnRowsCellStyle: {
            backgroundColor: colors.decorativeSurfaceTwoL,
          },
          innerConStyle: {
            gap: "0px",
          },
          headerRowStyle: {
            gap: "0px",
          },
          bottomLeftContainerStyle: {
            gap: "0px",
          },
          emptyFirstCellColumnStyle: {
            backgroundColor: colors.decorativeSurfaceTwoL,
            border: "none",
            fontSize: "1.4rem",
            ...fontStyles.demiBold,
            color: colors.textDefault,
            padding: "8px",
            borderRadius: "0px",
            borderBottom: `1px solid ${colors.borderSubtle}`,
            borderTop: `1px solid ${colors.borderSubtle}`,
          },
        },
        checklistStyles: {
          toolStyles: {
            checkListContainerStyle: {
              marginBottom: "8px",
              overflow: "auto",
              gap: "0px",
              border: "none",
            },
            rowStyle: {
              gap: "0px",
            },
            optionContainerStyle: {
              gap: "0px",
              borderBottom: `1px solid ${colors.borderSubtle}`,
            },
            labelContainerStyle: {
              border: "none",
              minWidth: "240px",
              borderRadius: "0px",
              backgroundColor: colors.decorativeSurfaceTwoL,
              borderBottom: `1px solid ${colors.borderSubtle}`,
            },
            optionStyle: {
              borderRadius: "0px",
              border: "none",
              backgroundColor: colors.surfaceWhite,
            },
            textAreaStyles: {
              borderRadius: "0px",
              fontSize: "1.4rem",
            },
            optionHeaderStyle: {
              border: "none",
              borderRadius: "0px",
              backgroundColor: colors.decorativeSurfaceTwoL,
              color: colors.textDefault,
            },
            tableTextStyle: {
              color: colors.textDefault,
              fontSize: "1.4rem",
            },
            borderLeftContainerStyle: {
              gap: "0px",
            },
          },
        },
        singlePointRubricStyles: {
          containerStyle: {
            gap: "0px",
            border: "none",
            overflow: "hidden",
          },
          rowStyle: {
            gap: "0px",
            minHeight: "auto",
            borderBottom: `1px solid ${colors.borderSubtle}`,
          },
          cellStyle: {
            padding: "12px",
            minHeight: "auto",
            borderRadius: "0px",
            border: "none",
          },
          rowHeaderCellStyle: {
            backgroundColor: colors.decorativeSurfaceTwoL,
            borderBottom: `1px solid ${colors.borderSubtle}`,
          },
          headerCellTitleStyle: {
            color: colors.textDefault,
          },
          headerSubCellTitleStyle: {
            color: colors.textSubtle,
          },
          subtitleContainerStyle: {
            margin: "0px",
          },
          headerRowStyle: {
            minHeight: "auto",
            gap: "0px",
          },
          bottomContainerStyle: {
            marginTop: "8px",
          },
        },

        standardRubricStyles: {
          criteriaCellStyle: {
            backgroundColor: "var(--violet-950)",
          },
        },
      };
    }
    default:
      return {};
  }
};

export const getAssessmentToolSelfEvaluationModeStyles = (params = {}) => {
  const { rubricCellMinWidth = "140px", rubricCellMaxWidth = "164px" } = params;

  const border = "1px solid var(--border-secondary)";

  const rubricStyles = {
    textAreaContainerStyle: {
      flexShrink: 1,
    },
    textAreaCustomStyles: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
      padding: "12px",
    },
    textAreaCustomHeaderStyles: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
      ...fontStyles.demiBold,
    },
    headerRowStyle: {
      padding: "0",
    },
    rowStyle: {
      minHeight: "56px",
      padding: "0",
    },
    cellStyle: {
      borderRadius: "8px",
      border,
      maxWidth: rubricCellMaxWidth,
      minWidth: rubricCellMinWidth,
    },
    rowHeaderCellStyle: {
      backgroundColor: "var(--violet-950)",
      border: "none",
      maxWidth: rubricCellMaxWidth,
      minWidth: rubricCellMinWidth,
      height: "40px",
    },
    firstColumnCellStyle: {
      backgroundColor: "var(--violet-950)",
      border: "none",
      borderRadius: "8px",
      maxWidth: rubricCellMaxWidth,
      minWidth: rubricCellMinWidth,
    },
    topLeftCellStyle: {
      backgroundColor: "var(--violet-950)",
    },
    emptyFirstCellColumnStyle: {
      backgroundColor: "var(--violet-950)",
      padding: "12px",
      height: "40px",
      ...fontStyles.demiBold,
      fontSize: "1.4rem",
      color: "var(--text-primary)",
    },
  };

  const singlePointRubricStyles = {
    containerStyle: {
      border: "none",
      overflow: "hidden",
    },
    evaluationCellContainerStyle: {
      height: "100%",
    },
    rowStyle: {
      minHeight: "auto",
    },
    cellStyle: {
      padding: "8px",
      minHeight: "auto",
    },
    rowHeaderCellStyle: {
      backgroundColor: "var(--violet-950)",
      border: "none",
      borderRadius: "8px",
    },
    headerCellTitleStyle: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
      ...fontStyles.demiBold,
    },
    headerSubCellTitleStyle: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
    },
    headerRowStyle: {
      minHeight: "auto",
    },
    subtitleContainerStyleV2: {
      marginTop: 0,
    },
    criteriaCellStyle: {
      backgroundColor: "var(--violet-950)",
      border: "none",
    },
    nonCriteriaCellStyle: {
      border: "none",
      padding: "0",
    },
    criteriaCellTitleStyle: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
      ...fontStyles.demiBold,
    },
    criteriaCellSubTitleStyle: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
    },
  };

  const checklistStyles = {
    toolStyles: {
      checkListContainerStyle: {
        marginBottom: "0px",
        overflow: "auto",
        gap: "8px",
        border: "none",
      },
      rowStyle: {
        gap: "8px",
        padding: "0",
      },
      headerRowStyle: {
        gap: "8px",
        padding: "0px",
      },
      labelContainerStyle: {
        minWidth: "240px",
        borderRadius: "8px",
        backgroundColor: "var(--violet-950)",
      },
      topLeftCellStyle: {
        backgroundColor: "var(--violet-950)",
        border: "none",
        borderRadius: "8px",
      },
      optionContainerStyle: {
        gap: "8px",
      },
      optionStyle: {
        borderRadius: "8px",
        border,
        padding: "8px",
        alignItems: "flex-start",
      },
      optionHeaderStyle: {
        border: "none",
        backgroundColor: "var(--violet-950)",
        color: "var(--text-primary)",
        fontSize: "1.4rem",
        ...fontStyles.demiBold,
        padding: "8px",
      },
      optionHeaderContainerStyle: {
        gap: "0px",
      },
      tableTextStyle: {
        color: "var(--text-primary)",
        fontSize: "1.4rem",
      },
      firstColumnTextStyle: {
        fontSize: "1.4rem",
        color: "var(--text-primary)",
        ...fontStyles.demiBold,
      },
    },
    containerStyle: {
      width: "100%",
    },
  };

  const mypObjectiveRubricStyles = {
    innerContainerStyle: {
      height: "100%",
    },
    cellStyle: {
      padding: "8px",
      border,
      borderRadius: "8px",
    },
    rubricHeaderRowCellStyle: {
      padding: "8px",
      backgroundColor: "var(--violet-950)",
      verticalAlign: "middle",
      ...fontStyles.demiBold,
      color: "var(--text-primary)",
      border: "none",
      height: "44px",
      borderRadius: "8px",
    },
    textAreaContainerStyle: {
      flexShrink: 1,
    },
    textAreaCustomStyles: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
    },
    headerColumnCellStyles: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
      padding: "8px",
      borderRadius: "8px",
      backgroundColor: "var(--violet-950)",
      height: "100%",
      border: "none",
    },
  };

  const dpRubricStyles = {
    leafNodLabelStyles: {
      fontSize: "1.4rem",
      color: "var(--text-primary)",
    },
    accordianHeaderStyle: {
      padding: "16px 0",
    },
  };

  const standardRubricStyles = {
    criteriaCellStyle: {
      backgroundColor: "var(--violet-950)",
    },
  };

  return {
    rubricStyles,
    singlePointRubricStyles,
    checklistStyles,
    mypObjectiveRubricStyles,
    dpRubricStyles,
    standardRubricStyles,
  };
};

export const showUnitSelection = ({ creationMode }) => {
  return _.includes(["IMPORT_LE", "UNIT"], creationMode);
};

export const minutesToHoursAndMinutes = durationInMinutes => {
  if (_.isEmpty(durationInMinutes)) {
    return { hours: 1, minutes: 0 };
  }
  const hours = Math.floor(durationInMinutes / 60);
  const minutes = durationInMinutes % 60;
  return { hours, minutes };
};

export const registerTimeTrackingEventInLocalStorage = ({ events }) => {
  const updatedEvents = JSON.stringify([
    ...getTimeTrackingEventsFromLocalStorage(),
    ...events,
  ]);
  setEncryptedJsonItem({
    key: "STUDENT_ASSIGNMENT_EVENTS",
    value: updatedEvents,
  });
};

export const getLatestPauseEvent = ({ events, entityId }) => {
  const currentLocalPauseEvents = _.filter(
    getTimeTrackingEventsFromLocalStorage(entityId),
    ({ eventType }) => eventType === "PAUSE"
  );

  if (!_.isEmpty(currentLocalPauseEvents)) {
    return _.last(currentLocalPauseEvents);
  }

  const registeredPauseEvents = _.filter(
    events,
    ({ eventType }) => eventType === "PAUSE"
  );
  if (!_.isEmpty(registeredPauseEvents)) {
    return _.last(registeredPauseEvents);
  }

  return [];
};

export const getIsIncreaseStudentSubmissionAudioLimit = () => {
  return ACLStore.can("FeatureFlag:IncreaseStudentSubmissionAudioLimit");
};

export const getIsNewGradingSetupEnabled = () => {
  return getIsConfigurationEnabledForCPAY({
    configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
  });
};

export const getIsSubjectStandard = ({ type }) => {
  return _.includes(
    [
      "BENCHMARK",
      "DP_SUBJECT_STANDARD",
      "PYP_LEARNING_STANDARD",
      "UBD_LEARNING_STANDARD",
      "MYP_LEARNING_STANDARD",
    ],
    type
  );
};

export const getSubmissionWarningMsg = status => {
  switch (status) {
    case "DRAFT":
    case "SUBMISSION_PENDING":
      return "common:submission_pending";
    case "RETURNED":
    case "REQUEST_RESUBMISSION":
    case "REQUEST_RESUBMISSION_OVERDUE":
      return "common:request_resubmission";
    default:
      return "";
  }
};

export const getShowAssessmentTools = params => {
  const { assessmentTools = {}, content = {} } = params;

  if (_.isEmpty(assessmentTools?.edges)) return false;

  return _.some(assessmentTools?.edges, ({ node }) => {
    const assessmentTool = _.get(node, "assessmentToolItem", {});
    const assessmentToolType = _.get(node, "assessmentToolType", "");

    const isTeacherEvaluationEnable = _.get(
      node,
      "isTeacherEvaluationEnable",
      false
    );
    const isStudentEvaluationEnable = _.get(
      node,
      "isStudentEvaluationEnable",
      false
    );

    const showTool = getShowAssessmentTool({
      assessmentTool,
      assessmentToolType,
      allFields: _.get(content, "allFields", []),
    });

    return showTool && (isTeacherEvaluationEnable || isStudentEvaluationEnable);
  });
};

export const getStudentAssignmentDetailsQueryVariables = params => {
  const { studentAssignmentId, userType, academicYearId } = params;
  return {
    id: studentAssignmentId,
    showOnlySubmitted: false,
    userFilter: userType === "staff" ? "ALL" : "SELF",
    entityEventsFilter: {
      orderBy: "EVENT_TIME",
      orderByDir: "ASC",
    },
    userArchivedFilters: {
      academicYearId,
    },
  };
};

export const getAssignmentDetailsQueryVariables = params => {
  const {
    assignmentId,
    curriculumProgramType,
    userType,
    userId,
    childID,
    academicYearId,
  } = params;

  const taggablElements = getTaggableElements({ curriculumProgramType });
  const presetAssessmentUids = _.map(taggablElements, "value");

  const isAIDebugModeEnabled =
    ACLStore.can("IdentityAccess:EnableAIDebugMode") ||
    ACLStore.can("Common:EnableAIDebugMode");

  const fetchAiUsageMetrics = getIsAIGradingEnabled() && isAIDebugModeEnabled;

  return {
    id: assignmentId,
    presetAssessmentUids,
    showOnlySubmitted: false,
    studentIds:
      userType === "student"
        ? [userId]
        : userType === "parent"
        ? [childID]
        : null,
    userFilter: "ALL",
    unreadMessageCountFilters: {
      includeItemTypesV2: INCLUDE_ITEM_TYPES_FOR_UNREAD_MESSAGES_COUNT,
    },
    entityEventsFilter: {
      orderBy: "EVENT_TIME",
      orderByDir: "ASC",
    },
    organizationResourcesOrderBy: "SEQUENCE",
    organizationResourcesOrderByDirection: "ASC",
    organizationResourcesFirst: null,
    organizationResourceFilters: {
      types: ["PLANNER_RESOURCE"],
    },
    ...(academicYearId ? { userArchivedFilters: { academicYearId } } : {}),
    fetchAiUsageMetrics,
  };
};

export const getSubmissionUnlockState = ({
  isLockSubmissionEnabled,
  deadline,
}) => {
  return isLockSubmissionEnabled &&
    checkIsDateBefore({
      date1: getTodaysDate(),
      date2: deadline,
      key: "seconds",
    })
    ? "TO_BE_LOCKED"
    : "UNLOCKED";
};

export const getAssessmentCoverRethumb = url => {
  if (url) {
    return getRethumbUrl({
      width: 1024,
      height: 1024,
      imageUrl: url,
      fitIn: true,
    });
  }

  return null;
};

export const getIsCustomWeights = ({
  curriculumProgramId,
  curriculumProgramType,
}) => {
  const gradeCalculationMethodSettingName = getGradeCalculationMethodSetting({
    curriculumType: curriculumProgramType,
  });
  const gradeCalculationMethod = getSettingValue({
    name: gradeCalculationMethodSettingName,
    currentCurriculumProgramId: curriculumProgramId,
  });
  return _.isEqual(gradeCalculationMethod, CUSTOM_WEIGHTS);
};

// * for new grading setup
export const getIsCustomWeightsV2 = (gradingConfigurations = []) => {
  return _.some(_.castArray(gradingConfigurations), config =>
    _.some(
      config?.settings || [],
      setting =>
        setting?.uid === "assignmentContributionMethod" &&
        _.isEqual(setting?.value, CUSTOM_WEIGHTS)
    )
  );
};

export const sendMessagePayloadToMobile = (msg = "") => {
  if (window.ReactNativeWebView) {
    window?.ReactNativeWebView?.postMessage(msg);
  }
};

export const showSubmissionToBeLockedWarning = ({
  submissionLockingState,
  isSubmitted,
  assignmentState,
}) => {
  return (
    !isSubmitted &&
    submissionLockingState === "TO_BE_LOCKED" &&
    assignmentState !== "SCHEDULED"
  );
};

export const getShowAssessmentToolForStudent = params => {
  const {
    assessmentTools,
    allFields,
    elementRemarks,
    isSharedWithStudent,
    isTeacherEvaluationEnabled,
  } = params;

  return _.some(assessmentTools, ({ node }) => {
    const { assessmentToolType } = node || {};

    switch (assessmentToolType) {
      case SCORE: {
        const { isScoreEnabled, maxScore } = getScoreDetailsMemoize({
          assessmentTools,
        });

        return (
          isTeacherEvaluationEnabled && isScoreEnabled && !_.isEmpty(maxScore)
        );
      }
      case COMMENT: {
        const commentMessage = getStaffElementRemarkMessage(elementRemarks);

        return (
          isTeacherEvaluationEnabled &&
          !_.isEmpty(commentMessage) &&
          isSharedWithStudent
        );
      }
      default: {
        return (
          !_.isEmpty(assessmentTools) &&
          _.some(assessmentTools, ({ node }) => {
            const {
              isTeacherEvaluationEnable,
              isStudentEvaluationEnable,
              assessmentToolItem,
              assessmentToolType,
            } = node || {};

            const showAssessmentTool = getShowAssessmentTool({
              assessmentTool: assessmentToolItem,
              assessmentToolType,
              allFields,
            });

            return (
              showAssessmentTool &&
              (isTeacherEvaluationEnable || isStudentEvaluationEnable)
            );
          })
        );
      }
    }
  });
};

export const MAX_AUDIO_RECORD_LIMIT = 900000;

export const getAudioRecordLimitForStudentSubmission = () => {
  return getIsIncreaseStudentSubmissionAudioLimit()
    ? MAX_AUDIO_RECORD_LIMIT
    : undefined;
};

export const getToolResponseUserFilter = (userType, isSharedWithStudent) => {
  // REFERENCE TABLE for userFilter
  //  +────────+──────────────────────────────────+──────────────────────────────────+
  //  | staff  | student                          | parent                           |
  //  +────────+──────────────────────────────────+──────────────────────────────────+
  //  | ALL    | if(isSharedWithStudent) -> ALL   | if(isSharedWithStudent) -> ALL   |
  //  |        | else -> SELF                     | else -> STUDENT                  |
  //  +────────+──────────────────────────────────+──────────────────────────────────+
  if (userType === "staff" || isSharedWithStudent) {
    return "ALL";
  } else if (userType === "student") {
    return "SELF";
  } else {
    return "STUDENT";
  }
};

export const sortAssessmentTool = params => {
  const { tool = {}, type } = params || {};

  switch (type) {
    case "RUBRIC": {
      const criterias = _.orderBy(
        _.get(tool, "criterias", []),
        "displaySequence"
      );
      const indicators = _.orderBy(
        _.get(tool, "indicators", []),
        "displaySequence"
      );

      return {
        ...tool,
        criterias,
        indicators,
      };
    }
    case "CHECKLIST": {
      const checklistItems = _.orderBy(
        _.get(tool, "checklistItems", []),
        "displaySequence"
      );
      const checklistOptionItems = _.orderBy(
        _.get(tool, "checklistOptionItems", []),
        "displaySequence"
      );

      return {
        ...tool,
        checklistItems,
        checklistOptionItems,
      };
    }
    case "SINGLE_POINT_RUBRIC": {
      const standards = _.orderBy(
        _.get(tool, "standards", []),
        "displaySequence"
      );

      return {
        ...tool,
        standards,
      };
    }

    case SCORE_BASED_RUBRIC:
    case STANDARD_BASED_RUBRIC: {
      const criterias = _.orderBy(
        _.get(tool, "criterias", []),
        "displaySequence"
      );

      return {
        ...tool,
        criterias: _.map(criterias, criterion => {
          const descriptors = _.orderBy(
            _.get(criterion, "descriptors", []),
            "displaySequence"
          );

          return { ...criterion, descriptors };
        }),
      };
    }

    default:
      return tool;
  }
};

export const ALERT_TYPES = {
  ASSIGNMENT_SUBMISSION_OVERDUE_ALERT: "ASSIGNMENT_SUBMISSION_OVERDUE_ALERT",
  ASSIGNMENT_SUBMISSION_PENDING_ALERT: "ASSIGNMENT_SUBMISSION_PENDING_ALERT",
  ASSIGNMENT_DUE_DATE_APPROACHING_ALERT:
    "ASSIGNMENT_DUE_DATE_APPROACHING_ALERT",
  ASSIGNMENT_CUSTOM_ALERT: "ASSIGNMENT_CUSTOM_ALERT",
};

export const getSelectedStudentsForBulkReminder = sortedAssignedStudents =>
  _.filter(
    sortedAssignedStudents,
    student =>
      !_.get(student, "isSubmitted", false) &&
      !_.get(student, "isEvaluated", false) &&
      _.get(student, "lockingState.state", "UNLOCKED") !== "LOCKED" &&
      !_.get(student, "student.isArchived", false)
  );

export const getAlertTypeOptions = _.memoize(
  ({
    t,
    assignmentDeadline,
    isStudentSubmissionEnabled,
    sortedAssignedStudents,
    isBackdateAssignment = false,
  }) => {
    let dueDate = "";
    if (assignmentDeadline) {
      dueDate = formatDate({
        date: assignmentDeadline,
        format: DATE_TIME_CONSTANTS.Do_MMM_hh_mm_a,
      });
    }
    const alertTypeOptions = [
      {
        label: t("classRoom:approaching_due_date"),
        key: ALERT_TYPES.ASSIGNMENT_DUE_DATE_APPROACHING_ALERT,
        defaultMessage: t("classRoom:approaching_due_date_message", {
          dueDate,
        }),
      },
      {
        key: ALERT_TYPES.ASSIGNMENT_SUBMISSION_OVERDUE_ALERT,
        label: t("classRoom:submission_is_overdue"),
        defaultMessage: t("classRoom:submission_is_overdue_message"),
      },
      {
        key: ALERT_TYPES.ASSIGNMENT_SUBMISSION_PENDING_ALERT,
        label: t("classRoom:submission_is_pending"),
        defaultMessage: t("classRoom:submission_is_pending_message"),
      },
      {
        key: ALERT_TYPES.ASSIGNMENT_CUSTOM_ALERT,
        label: t("common:custom"),
      },
    ];

    if (
      !isStudentSubmissionEnabled ||
      _.every(
        sortedAssignedStudents,
        student =>
          _.get(student, "lockingState.state", false) === "LOCKED" ||
          _.get(student, "isSubmitted", false) ||
          _.get(student, "isEvaluated", false)
      )
    ) {
      return [alertTypeOptions[3]];
    }
    if (_.isEmpty(assignmentDeadline) || isBackdateAssignment) {
      _.pullAt(alertTypeOptions, [0, 1]);
    } else if (
      checkIsDateBefore({
        date1: assignmentDeadline,
        date2: moment(),
        key: "minutes",
      })
    ) {
      _.pullAt(alertTypeOptions, [0, 2]);
    } else {
      _.pullAt(alertTypeOptions, [1]);
    }
    return alertTypeOptions;
  },
  JSON.stringify
);

export const getIsSendAlertMessageEnabled = () => {
  return ACLStore.can(ENABLE_BULK_REMINDER);
};

export const getStudentSubmissionUnreadMessageCounts = ({
  unreadMessageCounts,
}) => {
  return _.reduce(
    unreadMessageCounts,
    (result, { count, itemTypeV2 }) => {
      if (
        _.includes(INCLUDE_ITEM_TYPES_FOR_UNREAD_MESSAGES_COUNT, itemTypeV2)
      ) {
        return result + count;
      }
      return result;
    },
    0
  );
};

export const getAssignmentAssignedUnreadMessageCounts = ({
  unreadMessageCounts,
}) => {
  return _.reduce(
    unreadMessageCounts,
    (result, { count, itemTypeV2 }) => {
      if (
        _.includes(
          INCLUDE_ITEM_TYPES_FOR_STUDENT_UNREAD_MESSAGES_COUNT,
          itemTypeV2
        )
      ) {
        return result + count;
      }
      return result;
    },
    0
  );
};

export const getIsAITutorEnabled = () => {
  return ACLStore.can(ENABLE_AI_TUTOR);
};

export const getStudentDetailsWithArchivedStatus = ({ studentArray }) => {
  const students = [];

  _.forEach(studentArray, item => {
    const name = getFormattedUserName({ user: item });

    const isStudentArchived = getUserArchivalStatus(item);

    students.push({ name, isArchived: isStudentArchived, id: item.id });
  });

  return students;
};

export const getIsBroadcastMessageEnabled = () => {
  return ACLStore.can(ENABLE_BROADCAST_MESSAGE);
};

export const insertElementInAssessmentTool = ({
  putAfterItemId,
  assessmentTool,
  elementToAdd,
}) => {
  let assessmentToolArray = _.cloneDeep(assessmentTool);
  assessmentToolArray = _.orderBy(
    assessmentToolArray,
    "displaySequence",
    "asc"
  );

  if (!assessmentToolArray) {
    assessmentToolArray = [];
  }
  if (_.isNil(putAfterItemId)) {
    assessmentToolArray = insertBeforeId(
      assessmentToolArray,
      _.first(assessmentToolArray)?.id,
      elementToAdd
    );
  } else {
    assessmentToolArray = insertAfterId(
      assessmentToolArray,
      putAfterItemId,
      elementToAdd
    );
  }

  assessmentToolArray = _.map(
    assessmentToolArray,
    (assessmentToolItem, index) => {
      return {
        ...assessmentToolItem,
        displaySequence: index + 1,
      };
    }
  );

  return assessmentToolArray;
};

export const getStaffElementRemarkMessage = (
  elementRemarks,
  isAiEvaluationEnabled
) => {
  const userType = getUserType();

  // First try to find STAFF comment
  const staffComment = _.find(elementRemarks, remark => {
    const { creatorType = "STAFF", ibPYPElementType } = remark || {};
    return creatorType === "STAFF" && ibPYPElementType === "STUDENT_ASSIGNMENT";
  });

  const isStudent = userType === "student";

  const staffCommentValue = _.trim(_.get(staffComment, "message", ""));

  if (isStudent && staffComment) {
    return staffCommentValue;
  }

  // If no STAFF comment found, look for AI comment
  const aiComment = _.find(elementRemarks, remark => {
    const { creatorType = "STAFF", ibPYPElementType, isDeleted } = remark || {};
    return (
      creatorType === "AI" &&
      ibPYPElementType === "STUDENT_ASSIGNMENT" &&
      !isDeleted
    );
  });

  const aiCommentValue = _.trim(_.get(aiComment, "message", ""));

  return isAiEvaluationEnabled
    ? aiCommentValue || staffCommentValue
    : staffCommentValue || aiCommentValue;
};

export const getProjectionLineData = ({
  overId,
  overRect,
  activeId,
  delta,
  translated,
  dragType,
  assessmentToolArray,
}) => {
  let newProjectedLineData = {};
  let projectedLineStyle = {};
  const { x: xCoordinate, y: yCoordinate } = delta;
  const borderStyle = `1px solid ${colors.blue500}`;
  const overIndex = _.findIndex(assessmentToolArray, { id: overId });
  if (dragType === "column") {
    const midPoint = (overRect?.left + overRect?.right) / 2;
    if (xCoordinate > 0) {
      if (overId === activeId) {
        projectedLineStyle = { borderLeft: borderStyle };
        if (_.size(assessmentToolArray) - 1 > overIndex)
          newProjectedLineData = {
            style: projectedLineStyle,
            id: assessmentToolArray[overIndex + 1]?.id,
          };
      } else {
        if (midPoint > translated?.right) {
          projectedLineStyle = { borderLeft: borderStyle };
        } else {
          projectedLineStyle = { borderRight: borderStyle };
        }
        newProjectedLineData = { style: projectedLineStyle, id: overId };
      }
    } else {
      if (overId === activeId) {
        projectedLineStyle = { borderRight: borderStyle };
        if (overIndex > 0) {
          newProjectedLineData = {
            style: projectedLineStyle,
            id: assessmentToolArray[overIndex - 1]?.id,
          };
        }
      } else {
        if (translated?.left > midPoint) {
          projectedLineStyle = { borderRight: borderStyle };
        } else {
          projectedLineStyle = { borderLeft: borderStyle };
        }
        newProjectedLineData = { style: projectedLineStyle, id: overId };
      }
    }
  } else {
    const midPoint = (overRect?.top + overRect?.bottom) / 2;
    if (yCoordinate > 0) {
      if (overId === activeId) {
        projectedLineStyle = { borderTop: borderStyle };
        if (_.size(assessmentToolArray) - 1 > overIndex)
          newProjectedLineData = {
            style: projectedLineStyle,
            id: assessmentToolArray[overIndex + 1]?.id,
          };
      } else {
        if (midPoint > translated?.top) {
          projectedLineStyle = { borderBottom: borderStyle };
        } else {
          projectedLineStyle = { borderTop: borderStyle };
        }
        newProjectedLineData = { style: projectedLineStyle, id: overId };
      }
    } else {
      if (overId === activeId) {
        projectedLineStyle = { borderBottom: borderStyle };
        if (overIndex > 0) {
          newProjectedLineData = {
            style: projectedLineStyle,
            id: assessmentToolArray[overIndex - 1]?.id,
          };
        }
      } else {
        if (translated?.bottom > midPoint) {
          projectedLineStyle = { borderTop: borderStyle };
        } else {
          projectedLineStyle = { borderBottom: borderStyle };
        }
        newProjectedLineData = { style: projectedLineStyle, id: overId };
      }
    }
  }
  return newProjectedLineData;
};

export const checkIsSubmissionPendingForAll = ({ assignedStudents }) => {
  return _.every(assignedStudents, ({ submission }) => {
    const { statusV2 } = submission || {};
    return _.includes(
      [
        "SUBMISSION_PENDING",
        "SUBMISSION_NOT_REQUIRED",
        "OVERDUE",
        "NOT_SUBMITTED",
        "DRAFT",
      ],
      statusV2
    );
  });
};

const getAssessmentTypeOptions = ({ getCurrentAssessmentTypes, t }) => {
  const currentAssessmentTypes = getCurrentAssessmentTypes();

  const assessmentTypeOptionsToShow = _.reduce(
    currentAssessmentTypes,
    (options, { localeLabel, label, isEnabled = false }, uid) => {
      const assessmentTypeLabel = localeLabel ? t(localeLabel) : label;
      if (isEnabled) {
        options.push({ value: uid, label: assessmentTypeLabel });
      }
      return options;
    },
    []
  );

  return assessmentTypeOptionsToShow;
};

export const getChangeTaskTypeOptions = ({
  curriculumType,
  getCurrentAssessmentTypes,
  t,
  pageType,
  restrictQtIfUnitTagged,
  curriculumId,
  gradeId,
}) => {
  let options = [];

  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();

  if (isAssessmentTypeConfigurationEnabled) {
    // Use dynamic assessment type options when FF is enabled
    options = getDynamicAssessmentTypeOptions({
      curriculumId,
      gradeId,
    });
  } else {
    // Use existing curriculum-based options when FF is disabled
    switch (curriculumType) {
      case CURRICULUM_TYPE_UBD:
        options = _.map(UBD_CREATE_OPTIONS[0].options, option => {
          if (option.value === LEARNING_ENGAGEMENT) {
            return { value: "le", key: CREATE_LE, label: option.label };
          } else if (option.value === ASSESSMENT_TYPE_QUICK_TASK) {
            return { value: "qt", key: CREATE_QUICK_TASK, label: option.label };
          } else return option;
        });
        break;
      case CURRICULUM_TYPE_MYP:
      case CURRICULUM_TYPE_DP:
        options = MYP_CREATE_OPTIONS[0].options;
        break;
      default:
        options = PYP_CREATE_OPTIONS[0].options;
    }
  }

  const filteredOptions = _.reduce(
    options,
    (result, option) => {
      const key = _.get(option, "key", "");
      const perm = _.get(option, "perm", null)
        ? ACLStore.can(_.get(option, "perm", null))
        : true;
      const taskType = _.get(option, "taskType", "");

      if (
        taskType === TASK_TYPE_AI_TUTOR ||
        taskType === TASK_TYPE_WORKSHEET ||
        key === "SCHEDULE_VIDEO_CALL" ||
        key === CREATE_AI_TUTOR ||
        key === CREATE_WORKSHEET ||
        !perm ||
        ((_.includes(
          ["UNIT_FLOW_MIDDLE_PANE", "UNIT_FLOW_RIGHT_PANE"],
          pageType
        ) ||
          restrictQtIfUnitTagged) &&
          (key === CREATE_QUICK_TASK ||
            taskType === ASSESSMENT_TYPE_QUICK_TASK))
      ) {
        return result;
      }

      if (
        !isAssessmentTypeConfigurationEnabled &&
        curriculumType === CURRICULUM_TYPE_UBD &&
        key === "CREATE_ASSESSMENT"
      ) {
        const assessmentOptions = getAssessmentTypeOptions({
          getCurrentAssessmentTypes,
          t,
        });
        result = [...result, ...assessmentOptions];
        return result;
      }

      result.push({
        value: option.value,
        label: isAssessmentTypeConfigurationEnabled
          ? option.label
          : t(option.label),
        templateId: _.get(option, "templateId", null),
      });
      return result;
    },
    []
  );

  return filteredOptions;
};

// this function only gets the templateId where gradewise assessment is not enabled
export const getTemplateIdFromOrgId = ({
  organizationId,
  curriculumProgramId,
  groupType,
  assessmentType,
}) => {
  const isGradeWiseAssessment =
    ACLStore.can(ENABLE_GRADE_WISE_ASSESSMENT) &&
    ["LEARNING_ENGAGEMENT", "ASSESSMENT"].includes(groupType);

  if (isGradeWiseAssessment) {
    return null;
  }

  const plannerTemplates = _.get(
    getOrganizationDetailsFromCache(organizationId),
    "templates",
    []
  );

  const templateId = _.get(
    _.find(plannerTemplates, template => {
      if (template.assessmentType) {
        return (
          template.type == groupType &&
          template.assessmentType == assessmentType &&
          _.some(template?.curriculumProgram, { id: curriculumProgramId })
        );
      } else {
        return (
          template.type == groupType &&
          _.some(template?.curriculumProgram, { id: curriculumProgramId })
        );
      }
    }),
    "id",
    null
  );

  return templateId;
};

export const getShowNoteValue = ({
  currentAssessmentTypeValue,
  selectedTaskType,
  curriculumType,
}) => {
  if (currentAssessmentTypeValue === "qt") return false;
  if (selectedTaskType === "qt") return true;

  switch (curriculumType) {
    case CURRICULUM_TYPE_PYP:
    case CURRICULUM_TYPE_DP:
      return currentAssessmentTypeValue === "le";
    case CURRICULUM_TYPE_MYP:
      return currentAssessmentTypeValue === "smt";
    default:
      return false;
  }
};

export const getIsChangeTaskTypeEnabled = () => {
  return ACLStore.can("FeatureFlag:ChangeTaskType");
};
export const getAITutorInitialFieldValues = () => {
  const fields = [
    {
      uid: "tutorLanguage",
      value: _.toString(_.find(AI_TRANSLATION_LANGUAGES, { code: "en" }).id),
    },
  ];

  if (getIsAITutorEnhancementsV2Enabled()) {
    fields.push(
      {
        uid: "studentCommunicationMode",
        value: _.first(STUDENT_COMMUNICATION_MODES).id,
      },
      {
        uid: "tutorCommunicationMode",
        value: _.first(TUTOR_COMMUNICATION_MODES).id,
      }
    );
  }

  return fields;
};

const _getSubmissionTemplateUploadStatus = groupAttachments => {
  const copyName = _.get(
    groupAttachments,
    "attachments[0].metadata.copyName",
    ""
  );

  const isStudentTemplateUploadFailed = !_.isEmpty(
    _.get(groupAttachments, "attachments[0].metadata.error", "")
  );
  const isStudentTemplateUploading =
    !_.isEmpty(copyName) && !_.includes(copyName, "[original]");
  return { isStudentTemplateUploadFailed, isStudentTemplateUploading };
};

export const getSubmissionTemplateUploadStatus = _.memoize(
  _getSubmissionTemplateUploadStatus,
  groupAttachments => {
    const attachment = _.get(groupAttachments, "attachments[0]", {});
    const copyName = _.get(attachment, "metadata.copyName", "");
    const error = _.get(attachment, "metadata.error", "");

    return `${copyName}|${error ? "error" : "no-error"}`;
  }
);

export const getIsEnabledOptimizedSubmissionTemplateDriveFLow = () => {
  return ACLStore.can("FeatureFlag:EnableSequentialCallForDriveAttachments");
};
export const getSubmissionClosesText = ({ t, closeSubmissionDate }) => {
  if (_.isEmpty(closeSubmissionDate)) {
    return "";
  }

  return t("common:closes_on_date", {
    date: formatDate({
      date: closeSubmissionDate,
      format: "Do MMM hh:mm a",
    }),
  });
};

export const getAIAnalysisItem = (assessmentDetails, item = "criterias") => {
  const assessmentTools = _.get(assessmentDetails, "assessmentTools.edges", []);
  return _.get(
    _.find(
      assessmentTools,
      ({ node }) => node?.assessmentToolType === ANALYSIS
    ),
    `node.assessmentToolItem.${item}`,
    {}
  );
};

export const getStudentProficiencyLevel = params => {
  const { aiConversation, assessmentTools } = params;

  const toolResponses = _.get(
    aiConversation,
    "analysisToolEvaluation.0.toolResponses",
    []
  );

  const analysisScaleTool = _.find(
    assessmentTools?.edges,
    ({ node }) => node?.assessmentToolType === ANALYSIS
  );

  const criteria = _.get(
    analysisScaleTool,
    "node.assessmentToolItem.criterias",
    []
  );

  const ratedCriterion = _.find(criteria, {
    id: _.first(toolResponses)?.rowId,
  });

  const { colorCode } = ratedCriterion?.metadata || {};
  const { tagVariant, color = "" } =
    _.find(AI_ANALYSIS_SCALE_MAPPING, { id: colorCode }) || {};
  const backgroundColor = hexToRgba(color, 0.2);

  const level = _.get(ratedCriterion, "label");

  return { level, color, tagVariant, backgroundColor };
};

export const getCheckBoxAlertMessage = ({ curriculumType, t }) => {
  switch (curriculumType) {
    case CURRICULUM_TYPE_MYP:
      return t("classRoom:change_task_type_checkbox_note_myp");
    case CURRICULUM_TYPE_DP:
      return t("classRoom:change_task_type_checkbox_note_dp");
    default:
      return t("classRoom:change_task_type_checkbox_note");
  }
};

export const getIsEnabledLTITools = () => {
  return ACLStore.can("FeatureFlag:EnableLTIToolsInAssignment");
};

export const getIsEnableLTIInSubmissionTemplate = () => {
  return ACLStore.can("FeatureFlag:EnableLTIToolsInSubmissionTemplate");
};

export const getShowCheckboxAlertMessage = ({
  curriculumType,
  isLearningGoalsEvaluationEnabled,
  assessmentTools,
}) => {
  if (!isLearningGoalsEvaluationEnabled && !_.size(assessmentTools) > 0)
    return false;
  else if (isLearningGoalsEvaluationEnabled) return true;

  switch (curriculumType) {
    case CURRICULUM_TYPE_PYP:
    case CURRICULUM_TYPE_UBD:
      return _.some(
        assessmentTools,
        asessmentTool =>
          _.get(asessmentTool, "node.assessmentToolType") === SCORE
      );
    case CURRICULUM_TYPE_MYP:
      return _.some(assessmentTools, asessmentTool => {
        const toolType = _.get(asessmentTool, "node.assessmentToolType");
        return (
          toolType === SCORE ||
          toolType === MYP_OBJECTIVE_RUBRIC ||
          toolType === MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC
        );
      });
    default:
      return _.size(assessmentTools) > 0;
  }
};

export const getIsLTIAttachmentPresent = assessmentFields => {
  const templateGroups = _.get(
    _.find(assessmentFields, {
      uid: "studentTemplate",
    }),
    "resolvedMinimalTree.attachmentGroups",
    []
  );

  const ltiTemplates =
    _.get(
      _.find(assessmentFields, {
        uid: "ltiTemplate",
      }),
      "resolvedMinimalTree.attachmentGroups",
      []
    ) || [];

  return (
    !_.isEmpty(ltiTemplates) ||
    _.chain(templateGroups)
      .flatMap("attachments")
      .some(attachment => _.get(attachment, "metadata.type") === "LTI_TOOL")
      .value()
  );
};

export const getLTIEmptyStateData = ({
  isParent,
  isLTIAttempted,
  allowStudentReportView,
  isSubmissionStateLocked,
  studentAssignment,
  isSharedWithStudent,
  viewResponseAfterSubmission,
  t,
}) => {
  let showLtiEmptyState = false;
  if (isParent) {
    showLtiEmptyState = true;
  } else {
    // For non-parents (students/teachers)
    if (studentAssignment?.state === "PUBLISHED") {
      showLtiEmptyState = false;
    } else {
      // For non-published assignments
      const reportNotAccessible = !allowStudentReportView;
      const submittedButNotShared =
        viewResponseAfterSubmission &&
        isSubmissionStateLocked &&
        !isSharedWithStudent;

      showLtiEmptyState = isLTIAttempted
        ? reportNotAccessible || submittedButNotShared
        : isSubmissionStateLocked;
    }
  }

  const showCompletedState =
    isLTIAttempted && !(viewResponseAfterSubmission && isSubmissionStateLocked);

  const ltiIllustration = showCompletedState
    ? AllCompletedIllustration
    : NoAccessIllustration;
  const ltiEmptyStateTitle = showCompletedState
    ? isParent
      ? t("classRoom:family_successfully_submitted_your_work", {
          studentName: _.get(studentAssignment, "student.firstName", ""),
        })
      : t("classRoom:student_successfully_submitted_your_work")
    : t("classRoom:submissions_for_this_assignment_are_now_locked");
  const ltiEmptyStateSubTitle = isLTIAttempted
    ? isParent
      ? t("classRoom:no_preview_family_end")
      : t("classRoom:no_preview_student_end")
    : null;
  return {
    showLtiEmptyState,
    ltiIllustration,
    ltiEmptyStateTitle,
    ltiEmptyStateSubTitle,
  };
};

export const ASSIGNMENTS_FEED_VIEW_OPTIONS = [
  {
    icon: <TableOutlined />,
    value: TABULAR_VIEW,
  },
  {
    icon: <SectionOutlined />,
    value: FEED_VIEW,
  },
];

export const getAssignmentTitleToDisplay = ({
  contentType,
  title,
  assignmentTitle,
}) => {
  let titleValue;
  switch (contentType) {
    case "ASSESSMENT":
      titleValue = _.get(title, "value");
      break;
    case "ASSIGNMENT_MEETING":
    case "ASSIGNMENT_RESOURCE":
      titleValue = assignmentTitle;
      break;
    default:
      titleValue = "";
      break;
  }
  return titleValue ? titleValue : "";
};

export const renderLockingIcon = ({
  totalCount,
  openSubmissionsCount,
  t,
  classes,
  isFeedView = true,
}) => {
  const tooltip =
    openSubmissionsCount > 0
      ? openSubmissionsCount === totalCount
        ? t("classRoom:task_is_open_for_submissions_for_all_students")
        : t("classRoom:task_is_open_for_submissions_for_count_students", {
            openSubmissionsCount,
            totalCount,
          })
      : t("classRoom:task_is_closed_for_submissions_for_all_students");

  const SubmissionLockingIcon =
    openSubmissionsCount > 0 ? LockOpenOutlined : LockFilled;
  const submissionLockingLabel =
    openSubmissionsCount > 0 ? t("common:open") : t("common:closed");

  return (
    <Tooltip tooltip={tooltip}>
      <div className={classes.lockingContainer}>
        <SubmissionLockingIcon
          variant={isFeedView ? "subtle" : "default"}
          size={"xxx-small"}
        />
        <div className={classes.lockingSubText}>{submissionLockingLabel}</div>
      </div>
    </Tooltip>
  );
};

const getDefaultDisplaySettingStructure = ({
  t,
  pageType,
  curriculumProgramType,
  isFeedView,
}) => {
  const defaultSettings = [
    {
      key: "ASSIGNMENT_DETAILS",
      label: t("classRoom:assignment_details"),
      isItemGroup: true,
      isDraggable: true,
      type: "checkbox",
      options: [
        {
          key: "CLASSES_OR_PROJECTS",
          label: t("common:class_plural"),
        },
        {
          key: "MESSAGE",
          label: t("common:message"),
        },
        {
          key: "SUBMISSION_OPEN_CLOSE",
          label: t("classRoom:submission_open_close"),
        },
        {
          key: "CREATED_ON",
          label: t("common:created_on"),
        },
        {
          key: "DUE_ON",
          label: t("common:due_on"),
        },
        {
          key: "CLOSES_ON",
          label: t("common:closes_on"),
        },
        {
          key: "OPENS_ON",
          label: t("common:opens_on"),
        },
        {
          key: "GRADING_PERIODS",
          label: t("common:grading_period"),
        },
        {
          key: "ADDED_BY",
          label: t("common:added_by"),
        },
        {
          key: "UNIT",
          label: t("classRoom:associated_unit"),
        },
        {
          key: "CATEGORY",
          label: t("common:category"),
        },
        {
          key: "SUBJECTS",
          label: t("common:subject_plural"),
        },
      ],
    },
    {
      key: "STATUS_COUNTS",
      label: t("classRoom:status_count"),
      isItemGroup: true,
      isDraggable: true,
      type: "checkbox",
      options: [
        {
          key: "ASSIGNED_COUNT",
          label: t("classRoom:assigned_count"),
        },
        {
          key: "PENDING_NOT_SUBMITTED_COUNT",
          label: t("classRoom:pending_not_submitted"),
        },
        {
          key: "TURNED_IN_COUNT",
          label: t("classRoom:turned_in_count"),
        },
        {
          key: "EVALUATED_COMPLETED_COUNT",
          label: t("classRoom:evaluated_completed_count"),
        },
        {
          key: "SHARED_COUNT",
          label: t("classRoom:shared_count"),
        },
      ],
    },
    {
      key: "SHOW_TAGS",
      label: t("classRoom:show_tags"),
      isItemGroup: true,
      type: "radio",
      options: [
        {
          key: "TAGS_IN_COLUMN",
          label: isFeedView
            ? t("classRoom:with_the_assignment_details")
            : t("classRoom:as_a_column"),
        },
        {
          key: "TAGS_IN_SIDEBAR",
          label: t("classRoom:in_side_navigation"),
        },
        {
          key: "HIDE_TAGS",
          label: t("classRoom:dont_show_tags_with_apostrophe"),
        },
      ],
    },
  ];

  // if curriculum is dp then add subject level setting also
  if (curriculumProgramType === CURRICULUM_TYPE_DP) {
    const subjectLevelObj = {
      key: "SUBJECT_LEVEL",
      label: t("common:subject_level"),
    };
    defaultSettings[0].options.splice(5, 0, subjectLevelObj);
  }

  // if page is teacher class room remove classes options else remove tags setting entirely since tags are not present in assignmet manager
  if (pageType === "teacherClassRoom") {
    defaultSettings[0].options = _.tail(defaultSettings[0].options);
    return defaultSettings;
  } else return _.dropRight(defaultSettings, 1);
};

export const getDefaultDisplaySettingStructureMemoized = getMemoizedLangFunction(
  getDefaultDisplaySettingStructure
);
export const getIsManageAssignmentsPermission = () => {
  return ACLStorage.getPermissionValue(ASSIGNMENTS_MANAGE_PERMISSION);
};

export const getIsPerformAssignmentActionsPermission = ({
  assessmentType,
  courseId,
  curriculumProgramId,
  gradeId,
  learningCourseId,
} = {}) => {
  const contexts = generateRnPContextsByLevel({
    level: "COURSE",
    courseId,
    curriculumProgramId,
    gradeId,
    learningCourseId,
  });
  const context = _.first(contexts);

  if (
    _.includes(
      [DP_EXPERIMENTAL_PROGRAMME, DP_PRACTICAL_ACTIVITY],
      assessmentType
    )
  ) {
    return ACLStorage.getPermissionValueByContext(
      PSOW_ROEP_MANAGE_PERMISSION,
      context
    );
  }

  const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

  return (
    ACLStorage.getPermissionValueByContext(
      ASSIGNMENTS_MANAGE_PERMISSION,
      context
    ) ||
    ACLStorage.getPermissionValueByContext(
      MANAGE_GRADEBOOK_PERMISSION,
      context
    ) ||
    (!isLearningCoursesEnabled
      ? ACLStorage.getPermissionValueByContext(
          CLASS_FLOW_EDIT_PERMISSION,
          context
        )
      : false)
  );
};

export const getIsAddResponseOnBehalfOfStudentsPermission = ({
  organizationId,
  courseId,
  curriculumProgramId,
  gradeId,
  learningCourseId,
}) => {
  if (ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION)) {
    const contexts = generateRnPContextsByLevel({
      level: "COURSE",
      courseId,
      curriculumProgramId,
      gradeId,
      learningCourseId,
    });
    const context = _.first(contexts);

    return (
      ACLStorage.getPermissionValueByContext(
        ASSIGNMENTS_ADD_RESPONSE_ON_BEHALF_OF_STUDENTS_PERMISSION,
        context
      ) &&
      getIsPerformAssignmentActionsPermission({
        courseId,
        curriculumProgramId,
        gradeId,
        learningCourseId,
      })
    );
  }

  return getSettingValue({
    name: "EnableAddResponseOfAssignmentByTeacher",
    organizationId,
  });
};

export const getIsAddToPortfolioPermission = ({
  courseId,
  curriculumProgramId,
  isPrivate = false,
  gradeId,
  learningCourseId,
}) => {
  const contexts = generateRnPContextsByLevel({
    level: "COURSE",
    courseId,
    curriculumProgramId,
    gradeId,
    learningCourseId,
  });
  const context = _.first(contexts);

  return (
    !isPrivate &&
    ACLStorage.getPermissionValueByContext(
      "Portfolio:CanCreateAndManagePortfolioPostsOfTheirClasses",
      context
    )
  );
};

export const getAITutorFlaggedMessagesCount = conversations => {
  if (_.isEmpty(conversations)) return 0;
  const conversationEdges = conversations?.edges || conversations;

  return _.reduce(
    conversationEdges,
    (acc, { node }) => {
      acc += _.get(node, "messages.totalCount", 0);
      return acc;
    },
    0
  );
};

export const ASSIGNMENT_CONSUMING_PARENT_MODULES_PERMISSION = {
  VIEW: [
    ASSIGNMENTS_ACCESS_PERMISSION,
    CLASS_FLOW_VIEW_PERMISSION,
    COURSE_GRADEBOOK_ACCESS_PERMISSION,
  ],
  MANAGE: [
    ASSIGNMENTS_MANAGE_PERMISSION,
    CLASS_FLOW_EDIT_PERMISSION,
    MANAGE_GRADEBOOK_PERMISSION,
  ],
};

// There is no class flow module in new course setup
export const ASSIGNMENT_CONSUMING_PARENT_MODULES_PERMISSION_V2 = {
  VIEW: [ASSIGNMENTS_ACCESS_PERMISSION, COURSE_GRADEBOOK_ACCESS_PERMISSION],
  MANAGE: [ASSIGNMENTS_MANAGE_PERMISSION, MANAGE_GRADEBOOK_PERMISSION],
};

export const getAssignmentConsumingParentModulesPermission = (
  mode = "VIEW"
) => {
  const mapping = getIsLearningCoursesEnabled()
    ? ASSIGNMENT_CONSUMING_PARENT_MODULES_PERMISSION_V2
    : ASSIGNMENT_CONSUMING_PARENT_MODULES_PERMISSION;

  return mapping[mode];
};

export const getFilteredCoursesBasedOnViewOrManagePermission = _.memoize(
  ({
    courses,
    permissionsToCheck = getAssignmentConsumingParentModulesPermission(
      "MANAGE"
    ),
  }) => {
    const isRnPEnabled = ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);

    if (isRnPEnabled) {
      if (_.isEmpty(permissionsToCheck)) return courses;

      return _.filter(courses, ({ aclControlParameters = [] } = {}) => {
        if (_.isEmpty(aclControlParameters)) {
          return false;
        }

        const isViewOrManageAccessInAnyConsumingModule = _.some(
          aclControlParameters,
          ({ permission, value }) =>
            _.includes(permissionsToCheck, permission) && value
        );
        return isViewOrManageAccessInAnyConsumingModule;
      });
    }

    const modulesToCheck = getIsLearningCoursesEnabled()
      ? [CLASS_STREAM]
      : [CLASS_STREAM, CLASS_FLOW];

    return _.filter(courses, ({ enabledModules = [] } = {}) => {
      return _.some(enabledModules, module =>
        _.includes(modulesToCheck, module)
      );
    });
  },
  JSON.stringify
);

export const filterCourseByCalendarMeetingCreatePermission = ({ courses }) => {
  const isRnPEnabled = ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);

  if (isRnPEnabled) {
    return _.filter(courses, ({ aclControlParameters }) =>
      _.some(
        aclControlParameters,
        ({ permission, value }) =>
          // Meeting permission was decided to get merged with assignment permission
          permission === ASSIGNMENTS_MANAGE_PERMISSION_IN_CALENDAR &&
          value === true
      )
    );
  } else {
    return courses;
  }
};

export const getAssignmentDateToDisplay = ({ date, prefix }) => {
  if (!date) return "-";
  const formattedDate = getDateTimeStringsBasedOnFormat({
    inputDateTimeString: date,
    dateTimeFormat: ASSIGNMENT_FEED_DATE_TIME_FORMAT,
  }).dateTimeString;
  return prefix ? `${prefix}: ${formattedDate}` : formattedDate;
};

export const SubjectNames = React.memo(({ subjects, classes, t }) => {
  const subjectNames = _.map(subjects, subject => _.get(subject, "name", ""));
  const size = _.size(subjectNames);
  return (
    <div className={classes.tagContainer}>
      <span>
        <Tooltip
          tooltip={subjectNames[0]}
          placement={"top"}
          onClick={e => e?.stopPropagation()}
          theme="dark"
          dsVersion="2.0"
          visible={
            size > 1
              ? _.size(subjectNames[0]) > 18
              : _.size(subjectNames[0]) > 25
          }
        >
          <div className={classes.subjectText}>
            {size > 1 ? `${subjectNames[0]},` : subjectNames[0]}
          </div>
        </Tooltip>
      </span>
      {size > 1 ? (
        <Tooltip
          tooltip={
            <div className={classes.toolTipTagsCon}>
              {_.map(_.tail(subjectNames), (subjectName, index) => (
                <div key={index}>{subjectName}</div>
              ))}
            </div>
          }
          placement={"right"}
          onClick={e => e?.stopPropagation()}
          theme="dark"
          dsVersion="2.0"
        >
          <div className={classes.tooltipLabel}>{`+${size - 1}${t(
            "common:more"
          )}`}</div>
        </Tooltip>
      ) : null}
    </div>
  );
});

SubjectNames.displayName = "SubjectNames";

export const TagsLabel = React.memo(({ folders, classes, t, isFeedView }) => {
  const size = _.size(folders);
  const firstFolder = _.first(folders);
  const firstFolderName = _.get(firstFolder, "name", "");

  const toolTipFolders = (
    <div className={classes.toolTipTagsCon}>
      {_.map(_.tail(folders), (folder, index) => (
        <div key={index} className={classes.tagContainer}>
          <CircleFilled
            style={{ color: _.get(folder, "color", "") }}
            size="xx-small"
          />
          {_.get(folder, "name")}
        </div>
      ))}
    </div>
  );

  const toolTipLabelClasses = classNames({
    [classes.tooltipLabel]: true,
    ["text-body-s"]: isFeedView,
  });

  return (
    <div className={classes.tagContainer}>
      <CircleFilled
        style={{ color: _.get(_.first(folders), "color", "") }}
        size={isFeedView ? "xxxx-small" : "xx-small"}
      />
      <ConditionalWrapper
        type={"wrapperAsElement"}
        condition={_.size(firstFolderName) >= 12}
        wrapper={
          <Tooltip
            dsVersion="2.0"
            tooltip={firstFolderName}
            placement={"top"}
          />
        }
      >
        <div className={isFeedView ? "text-body-s" : classes.ellipsisTags}>
          {size > 1 ? `${firstFolderName},` : firstFolderName}
        </div>
      </ConditionalWrapper>

      {size > 1 && (
        <Tooltip
          tooltip={toolTipFolders}
          trigger={["click"]}
          placement={"right"}
          onClick={e => e?.stopPropagation()}
          theme="dark"
          dsVersion="2.0"
        >
          <div className={toolTipLabelClasses}>{`+${size - 1}${t(
            "common:more"
          )}`}</div>
        </Tooltip>
      )}
    </div>
  );
});

TagsLabel.displayName = "TagsLabel";

export const UnreadMessageComp = React.memo(
  ({ messagesSummary, classes, t, isFeedView }) => {
    const { unreadMessages = [] } = messagesSummary;
    const unreadMessage = _.first(unreadMessages);
    const isLastMessageClassDiscussion =
      _.get(unreadMessage, "parentEntity.parentType") === "ASSIGNMENT";

    const { label = "", attachments = [], createdBy = {}, createdAt = "" } =
      unreadMessage || {};

    const name = getFormattedUserName({ user: createdBy });

    const labelToShow = label
      ? label
      : t("common:sent_attachment", { count: _.size(attachments) });

    const MessageIcon = !isLastMessageClassDiscussion
      ? CommentCircleRightOutlined
      : CommentMultipleOutlined;

    const isEnabledAssignmentImprovements = getIsEnabledAssignmentImprovements();

    return (
      <div className={classes.messageContainer}>
        <MessageIcon variant="subtle" size="xxx-small" />
        <div>
          <div
            className={classNames("text-body", classes.messageLabelContainer)}
          >
            <div>{`${name} :`}</div>
            {!_.isEmpty(attachments) ? (
              <AttachmentClipOutlined variant="subtle" size="xxx-small" />
            ) : null}
            <div className={classNames("text-body", classes.ellipsisMessage)}>
              {labelToShow}
            </div>
            {isFeedView && isEnabledAssignmentImprovements ? (
              <>
                <span className={classes.dotContainer} />
                <div className={classNames("text-body-s", classes.timeStamp)}>
                  {getFormattedTimeSinceV2(createdAt, t)}
                </div>
              </>
            ) : null}
          </div>
          {!isFeedView && isEnabledAssignmentImprovements ? (
            <div className={classNames("text-body-s", classes.timeStamp)}>
              {getFormattedTimeSinceV2(createdAt, t)}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
);

UnreadMessageComp.displayName = "UnreadMessageComp";

export const getAssignmentStatsFromSummaryCounts = summaryCounts => {
  const assignedCount = _.get(summaryCounts, "assigned", null);
  const evaluatedCount = _.get(summaryCounts, "evaluated", null);
  const turnedInCount = _.get(summaryCounts, "turnedIn", null);
  const newSubmissionsCount = _.get(summaryCounts, "newSubmissionsCount", null);
  const evaluationSharedCount = _.get(summaryCounts, "evaluationShared", null);
  const notSubmittedCount = assignedCount - turnedInCount;

  return {
    assignedCount,
    evaluatedCount,
    turnedInCount,
    notSubmittedCount,
    newSubmissionsCount,
    evaluationSharedCount,
  };
};

export const getAllAssignmentDataToShow = ({
  assignment,
  gradingPeriodOptions,
  t,
  classes,
  viewType,
  pageType,
  genericTags,
  curriculumProgramType,
  StudentList,
  currentCurriculumProgramId,
  academicYearId,
}) => {
  const {
    state: { state, publishedAt } = {},
    deadline,
    closeSubmissionDate,
    isStudentSubmissionEnabled,
    content,
    isTimedTestEnabled,
    createdAt,
    createdBy,
    folders,
    course = {},
    isTeacherEvaluationEnabled,
    id: assignmentId,
    summaryCounts,
    messagesSummary = {},
    classDiscussion = {},
  } = assignment || {};

  const {
    academicTerm: { id: academicTermId } = {},
    category = {},
    globalCategories = [],
    fields = [],
  } = content || {};

  const { profileImage } = createdBy || {};

  const isPrivate = _.get(assignment, "isPrivate", false);

  const courseName = _.get(course, "title", "-");
  const isFeedView = viewType === FEED_VIEW;
  const avatarSize = isFeedView ? "xxx-small" : "x-small";

  const isUsingNewGradingSetupInCourses = getIsConfigurationEnabledForCPAY({
    configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
    curriculumProgramId: currentCurriculumProgramId,
    academicYearId: academicYearId,
  });

  const openSubmissionsCount = _.get(
    summaryCounts,
    "unlockedSubmissions",
    null
  );

  const subjects = _.get(
    _.find(fields, { uid: "subjects" }),
    "resolvedMinimalTree.subjects",
    []
  );

  const unitPlanObj = _.get(
    _.find(fields, { uid: "unitPlan" }),
    "resolvedMinimalTree.unitPlan",
    []
  );

  const unitPlanTitle = _.get(unitPlanObj, "title.value", "");

  const {
    assignedCount,
    evaluatedCount,
    turnedInCount,
    notSubmittedCount,
    newSubmissionsCount,
    evaluationSharedCount,
  } = getAssignmentStatsFromSummaryCounts(summaryCounts);

  const createdByFullName = getFormattedUserName({ user: createdBy });

  const gradingPeriod = _.find(gradingPeriodOptions, { key: academicTermId });

  const subjectLevelLabel = getSubjectLevelLabel({
    fields: _.get(content, "fields", []),
    genericTags,
    showDsTags: !isFeedView,
  });

  const allDataObj = {
    SUBMISSION_OPEN_CLOSE: {
      key: "SUBMISSION_OPEN_CLOSE",
      value:
        !isPrivate &&
        !isTimedTestEnabled &&
        isStudentSubmissionEnabled &&
        state !== "DRAFT"
          ? renderLockingIcon({
              totalCount: assignedCount,
              openSubmissionsCount,
              t,
              classes,
              isFeedView,
            })
          : "-",
    },
    DUE_ON: {
      key: "DUE_ON",
      value: getAssignmentDateToDisplay({
        date: deadline,
        prefix: isFeedView ? t("classRoom:due_capital") : "",
      }),
    },
    CLOSES_ON: {
      key: "CLOSES_ON",
      value: getAssignmentDateToDisplay({
        date: closeSubmissionDate,
        prefix: isFeedView ? t("classRoom:closes_capital") : "",
      }),
    },
    ASSIGNED_COUNT: {
      key: "ASSIGNED_COUNT",
      value: (
        <StudentList
          count={assignedCount}
          label={
            isPrivate ? "classRoom:privately_assigned" : "classRoom:assigned"
          }
          isFeedView={isFeedView}
          classes={classes}
          t={t}
          assignmentId={assignmentId}
          type={"ASSIGNED_COUNT"}
        />
      ),
    },
    TURNED_IN_COUNT: {
      key: "TURNED_IN_COUNT",
      label: "classRoom:turned_in",
      value:
        isStudentSubmissionEnabled && state !== "SCHEDULED" ? (
          <StudentList
            count={turnedInCount}
            label={"classRoom:turned_in"}
            isFeedView={isFeedView}
            newSubmissionsCount={newSubmissionsCount}
            classes={classes}
            t={t}
            assignmentId={assignmentId}
            type={"TURNED_IN_COUNT"}
          />
        ) : (
          "-"
        ),
    },
    EVALUATED_COMPLETED_COUNT: {
      key: "EVALUATED_COMPLETED_COUNT",
      label: isTeacherEvaluationEnabled
        ? "classRoom:evaluated"
        : "common:completed",
      value:
        state !== "SCHEDULED" ? (
          <StudentList
            count={evaluatedCount}
            label={
              isTeacherEvaluationEnabled
                ? "classRoom:evaluated"
                : "common:completed"
            }
            isFeedView={isFeedView}
            classes={classes}
            t={t}
            assignmentId={assignmentId}
            type={"EVALUATED_COMPLETED_COUNT"}
          />
        ) : (
          "-"
        ),
    },
    PENDING_NOT_SUBMITTED_COUNT: {
      key: "PENDING_NOT_SUBMITTED_COUNT",
      value:
        isStudentSubmissionEnabled && state !== "SCHEDULED" ? (
          <StudentList
            count={notSubmittedCount}
            label={"common:pending"}
            isFeedView={isFeedView}
            classes={classes}
            t={t}
            assignmentId={assignmentId}
            type={"PENDING_NOT_SUBMITTED_COUNT"}
          />
        ) : (
          "-"
        ),
    },
    SHARED_COUNT: {
      key: "SHARED_COUNT",
      label: "classRoom:shared",
      value:
        !isPrivate && isTeacherEvaluationEnabled && state !== "SCHEDULED" ? (
          <StudentList
            count={evaluationSharedCount}
            label={"classRoom:shared"}
            isFeedView={isFeedView}
            classes={classes}
            t={t}
            assignmentId={assignmentId}
            type={"SHARED_COUNT"}
          />
        ) : (
          "-"
        ),
    },
    OPENS_ON: {
      key: "OPENS_ON",
      value: getAssignmentDateToDisplay({
        date: publishedAt,
        prefix: isFeedView ? t("classRoom:opens_capital") : "",
      }),
    },
    CREATED_ON: {
      key: "CREATED_ON",
      value: getAssignmentDateToDisplay({
        date: moment(createdAt).utc(true).toISOString(),
        prefix: isFeedView ? t("common:created_capital") : "",
      }),
    },
    ADDED_BY: {
      key: "ADDED_BY",
      value: (
        <div className={classes.addedByContainer}>
          <Avatar
            name={createdByFullName}
            size={avatarSize}
            color={"yellow"}
            src={profileImage}
            dsVersion="2.0"
          />
          <ConditionalWrapper
            type={"wrapperAsElement"}
            condition={_.size(createdByFullName) >= 20}
            wrapper={<Tooltip tooltip={createdByFullName} placement={"top"} />}
          >
            <div className={classes.ellipsisColumnText}>
              {createdByFullName}
            </div>
          </ConditionalWrapper>
        </div>
      ),
    },
    // use global category name if new grading setup is enabled else use assignment category label
    CATEGORY: {
      key: "CATEGORY",
      value: isUsingNewGradingSetupInCourses
        ? _.get(globalCategories, "[0].name", "-")
        : _.get(category, "label", "-"),
    },
    SUBJECTS: {
      key: "SUBJECTS",
      value: !_.isEmpty(subjects) ? (
        <SubjectNames subjects={subjects} classes={classes} t={t} />
      ) : (
        "-"
      ),
    },
    UNIT: {
      key: "UNIT",
      value: unitPlanTitle ? unitPlanTitle : "-",
    },
    GRADING_PERIODS: {
      key: "GRADING_PERIODS",
      value: _.get(gradingPeriod, "label", "-"),
    },
    TAGS_IN_COLUMN: {
      key: "TAGS_IN_COLUMN",
      value: !_.isEmpty(folders) ? (
        <TagsLabel
          isFeedView={isFeedView}
          folders={folders}
          classes={classes}
          t={t}
        />
      ) : (
        "-"
      ),
    },
    MESSAGE: {
      key: "MESSAGE",
      value: (
        <UnreadMessageComp
          messagesSummary={messagesSummary}
          classes={classes}
          t={t}
          isFeedView={isFeedView}
        />
      ),
    },
  };

  if (curriculumProgramType === CURRICULUM_TYPE_DP) {
    allDataObj.SUBJECT_LEVEL = {
      key: "SUBJECT_LEVEL",
      value: subjectLevelLabel,
    };
  }

  if (pageType === "assignmentManager") {
    allDataObj.CLASSES_OR_PROJECTS = {
      key: "CLASSES_OR_PROJECTS",
      value: courseName,
    };
  }
  return allDataObj;
};

export const getDefaultDisplaySettings = () => {
  const assignmentDetailsPreference = [
    {
      key: "CLASSES_OR_PROJECTS",
      isChecked: true,
    },
    {
      key: "SUBMISSION_OPEN_CLOSE",
      isChecked: true,
    },
    {
      key: "DUE_ON",
      isChecked: true,
    },
    {
      key: "CLOSES_ON",
      isChecked: false,
    },
    {
      key: "OPENS_ON",
      isChecked: false,
    },
    {
      key: "SUBJECT_LEVEL",
      isChecked: true,
    },
    {
      key: "CREATED_ON",
      isChecked: false,
    },
    {
      key: "GRADING_PERIODS",
      isChecked: false,
    },
    {
      key: "ADDED_BY",
      isChecked: false,
    },
    {
      key: "UNIT",
      isChecked: false,
    },
    {
      key: "CATEGORY",
      isChecked: true,
    },
    {
      key: "SUBJECTS",
      isChecked: false,
    },
  ];

  const statusCountPreference = [
    {
      key: "ASSIGNED_COUNT",
      isChecked: true,
    },
    {
      key: "PENDING_NOT_SUBMITTED_COUNT",
      isChecked: false,
    },
    {
      key: "TURNED_IN_COUNT",
      isChecked: true,
    },
    {
      key: "EVALUATED_COMPLETED_COUNT",
      isChecked: true,
    },
    {
      key: "SHARED_COUNT",
      isChecked: true,
    },
  ];

  return {
    PUBLISHED: {
      assignmentDetailsPreference,
      statusCountPreference,
      orderByPreference: "DUE_AT",
      orderByDirectionPreference: DESC,
    },
    ARCHIVED: {
      assignmentDetailsPreference,
      statusCountPreference,
      orderByPreference: "DUE_AT",
      orderByDirectionPreference: DESC,
    },
    SCHEDULED: {
      assignmentDetailsPreference: _.map(
        assignmentDetailsPreference,
        preference => {
          if (_.includes(["SUBMISSION_OPEN_CLOSE", "DUE_ON"], preference.key)) {
            return { ...preference, isChecked: false };
          }
          if (preference.key === "OPENS_ON") {
            return { ...preference, isChecked: true };
          }
          return preference;
        }
      ),
      statusCountPreference: [_.first(statusCountPreference)],
      orderByPreference: "PUBLISHED_AT",
      orderByDirectionPreference: DESC,
    },
    DRAFT: {
      assignmentDetailsPreference: _.compact(
        _.map(assignmentDetailsPreference, preference => {
          if (
            _.includes(
              ["SUBMISSION_OPEN_CLOSE", "DUE_ON", "OPENS_ON", "CLOSES_ON"],
              preference.key
            )
          ) {
            return null;
          }
          if (preference.key === "CREATED_ON") {
            return { ...preference, isChecked: true };
          }
          return preference;
        })
      ),
      statusCountPreference: [],
      orderByPreference: "CREATED_AT",
      orderByDirectionPreference: DESC,
    },
    UNREAD_MESSAGES: {
      assignmentDetailsPreference: [
        ..._.map(assignmentDetailsPreference, preference => {
          if (preference.key === "CLASSES_OR_PROJECTS") {
            return { ...preference, isChecked: true };
          } else {
            return { ...preference, isChecked: false };
          }
        }),
        { key: "MESSAGE", isChecked: true },
      ],
      statusCountPreference: _.map(statusCountPreference, preference => {
        return { ...preference, isChecked: false };
      }),
      orderByPreference: "LATEST_UNREAD_CONVERSATION",
      orderByDirectionPreference: DESC,
    },
    ALL_POSTS: {
      assignmentDetailsPreference: _.map(
        assignmentDetailsPreference,
        preference => {
          if (preference.key === "DUE_ON") {
            return { ...preference, isChecked: false };
          } else if (preference.key === "CREATED_ON") {
            return { ...preference, isChecked: true };
          } else return preference;
        }
      ),
      statusCountPreference,
      orderByPreference: "CREATED_AT",
      orderByDirectionPreference: DESC,
    },
    displayTagsPreference: "TAGS_IN_COLUMN",
    viewPreference: FEED_VIEW,
    isTableViewNotSeen: true,
  };
};

export const renderEmptyState = ({
  filters,
  isStudentAssignmentFeedRevampEnabled,
  t,
  userType,
  isClassStreamManager,
  assignmentStateTab,
}) => {
  const searchText = _.get(filters, "searchText", "");
  const emptyStateSubtitleStyle = {
    maxWidth: "456px",
    lineHeight: "24px",
  };

  if (isStudentAssignmentFeedRevampEnabled && userType !== "staff") {
    if (searchText) {
      return (
        <EmptyState
          illustration={NoSearchInFilterIllustration}
          title={t("common:noResultHeading")}
          subtitle={t("common:no_assignments_matching_your_search")}
          subtitleStyle={emptyStateSubtitleStyle}
        />
      );
    }

    const activeSidebarTab = _.get(filters, "activeSidebarTab", "");

    const tab =
      assignmentStateTab === "NOT_SUBMITTED"
        ? "NOT_SUBMITTED"
        : activeSidebarTab;
    const emptyStateConfig = _.get(STUDENT_EMPTY_STATE_MAPPING, tab, {});
    const { title, subTitle, illustration } = emptyStateConfig;

    const getSubtitle = () => {
      if (typeof subTitle === "object" && subTitle.key) {
        return t(subTitle.key, { label: t(subTitle.labelKey) });
      }
      return t(subTitle);
    };

    return (
      <EmptyState
        illustration={illustration}
        title={t(title)}
        subtitle={getSubtitle()}
        subtitleStyle={emptyStateSubtitleStyle}
      />
    );
  }

  if (userType !== "staff" || searchText) {
    return (
      <EmptyState
        illustration={NoSearchInFilterIllustration}
        title={t("common:noResultHeading")}
        subtitle={t("common:no_assignments_matching_your_search")}
        subtitleStyle={emptyStateSubtitleStyle}
      />
    );
  }

  let subTitle = "";
  const {
    title,
    subTitle: stateTabSubtitle,
    illustration = NoAssignmentIllustration,
  } = _.get(
    getAssignmentStateTabs(userType),
    `${assignmentStateTab}.emptyState`,
    {}
  );

  if (assignmentStateTab === "ALL_POSTS" && isClassStreamManager) {
    subTitle = "classRoom:assignment_manager_all_posts_empty_state_subtitle";
  } else {
    subTitle = stateTabSubtitle;
  }

  return (
    <EmptyState
      illustration={illustration}
      title={t(title)}
      subtitle={t(subTitle)}
      subtitleStyle={emptyStateSubtitleStyle}
    />
  );
};

export const getAssessmentTypeInitials = ({
  getAssessmentObj,
  t,
  curriculumType,
  assessmentValue,
  contentType,
  curriculumId,
}) => {
  const typeObj = getAssessmentObj({
    curriculumType,
    assessmentValue,
    contentType,
    curriculumId,
  });

  const { typeLabel, typeLabel2, nonLocalisedLabel } = typeObj || {};

  const assessmentTypeLabel = t(typeLabel2 || typeLabel);
  const assessmentTypeLabelInitials = getInitials({
    value: assessmentTypeLabel,
  });

  const isAssessmentTypeAITutor = assessmentValue === ASSESSMENT_TYPE_AI_TUTOR;

  const assessmentTypeInitials = isAssessmentTypeAITutor
    ? "AI"
    : assessmentValue === ASSESSMENT_TYPE_WORKSHEET
    ? "WS"
    : _.includes(["Ed"], assessmentTypeLabelInitials) && nonLocalisedLabel
    ? getInitials({ value: nonLocalisedLabel })
    : assessmentTypeLabelInitials;
  return _.upperCase(assessmentTypeInitials);
};

export const getIsStudentAssignmentRevampEnabled = () => {
  return ACLStore.can("FeatureFlag:StudentAssignmentRevamp");
};

export const getGradingPeriodData = _.memoize(academicYears => {
  const sortedAcademicYears = _.orderBy(academicYears, ["endDate"], ["asc"]);
  const gradingPeriodOptions = _.reduce(
    sortedAcademicYears,
    (result, academicYear) => {
      // For each academic year, extract its terms
      const yearTerms = _.get(academicYear, "terms", []);

      // Get the formatted academic year string
      const yearString = getYearDurationFormat({
        startDate: academicYear?.startDate,
        endDate: academicYear?.endDate,
      });

      // Process each term from this academic year
      _.forEach(yearTerms, term => {
        // Skip cumulative terms
        if (_.get(term, "type", "") === GRADING_PERIOD_CUMULATIVE) {
          return; // continue to next iteration
        }

        // Add the term with only the required fields to our result array
        result.push({
          id: _.get(term, "id", null),
          key: _.get(term, "id", null),
          label: _.get(term, "label", ""),
          year: yearString,
          startDate: _.get(term, "startDate", ""),
          endDate: _.get(term, "endDate", ""),
          academicYearId: _.get(academicYear, "id", ""),
        });
      });

      return result;
    },
    [] // Initial empty array
  );

  const currentGradingPeriod = getCurrentTerm({ terms: gradingPeriodOptions });

  const currentGradingPeriodOption = _.find(
    gradingPeriodOptions,
    ({ key }) => key === currentGradingPeriod?.id
  );

  return {
    currentGradingPeriodOption,
    gradingPeriodOptions,
    currentGradingPeriod,
  };
}, JSON.stringify);

export const getCurrentAndPreviousSubmissions = studentAssignmentData => {
  const submissionEdges = _.get(studentAssignmentData, "submissions.edges", []);
  return {
    currentSubmission:
      _.find(submissionEdges, { isArchived: false }) ||
      _.first(submissionEdges),
    previousSubmissions: _.filter(submissionEdges, { isArchived: true }) || [],
  };
};

export const getStudentListByType = ({ studentList, type }) => {
  return _.reduce(
    studentList,
    (acc, item) => {
      const { isSubmitted, isEvaluated, isSharedWithStudent } = item;
      const student = _.get(item, "student", {});
      const name = getFormattedUserName({ user: student });

      switch (type) {
        case "TURNED_IN_COUNT":
          if (isSubmitted) {
            acc.push({ name, ...student });
          }
          break;
        case "EVALUATED_COMPLETED_COUNT":
          if (isEvaluated) {
            acc.push({
              name,
              ...student,
            });
          }
          break;
        case "PENDING_NOT_SUBMITTED_COUNT":
          if (!isSubmitted) {
            acc.push({ name, ...student });
          }
          break;
        case "SHARED_COUNT":
          if (isSharedWithStudent) {
            acc.push({ name, ...student });
          }
          break;
        default:
          acc.push({ name, ...student });
      }

      return acc;
    },
    []
  );
};

export const getRevampedFeedGroupDateText = ({
  key,
  orderBy,
  areAllTasksInSameYear,
  t,
}) => {
  // key can contain text like "No due date" so if it is not a date then return it as it is
  if (!moment(key).isValid()) return key;

  const date = moment(key, "YYYY-MM-DD");
  const today = moment().startOf("day");
  const diffDays = date.diff(today, "days");

  const formattedDate = areAllTasksInSameYear
    ? date.format("DD MMM")
    : date.format("DD MMM, YY");

  let textToShow = "";

  const getSuffix = diffDays => {
    let suffix = "";
    switch (diffDays) {
      case 1:
        suffix = t("common:lowercase", { text: t("classRoom:tomorrow") });
        break;
      case -1:
        suffix = t("common:lowercase", { text: t("common:yesterday") });
        break;
      default:
        suffix = t("common:lowercase", { text: t("common:today") });
    }
    return suffix;
  };

  const onText = t("common:lower_case_on");

  switch (orderBy) {
    case "DUE_AT": {
      if (diffDays > 1) {
        textToShow = `${t("classRoom:due")} ${onText} ${formattedDate}`;
      } else {
        textToShow = `${t("classRoom:due")} ${getSuffix(
          diffDays
        )}, ${formattedDate}`;
      }
      break;
    }
    case "CREATED_AT": {
      if (diffDays < -1) {
        textToShow = `${t(
          "common:created_capital"
        )} ${onText} ${formattedDate}`;
      } else {
        textToShow = `${t("common:created_capital")} ${getSuffix(
          diffDays
        )}, ${formattedDate}`;
      }
      break;
    }
    case "PUBLISHED_AT":
      if (diffDays > 1) {
        textToShow = `${t(
          "classRoom:opens_capital"
        )} ${onText} ${formattedDate}`;
      } else {
        textToShow = `${t("classRoom:opens_capital")} ${getSuffix(
          diffDays
        )}, ${formattedDate}`;
      }
      break;
    case "CLOSES_AT":
      if (diffDays > 1) {
        textToShow = `${t(
          "classRoom:closes_capital"
        )} ${onText} ${formattedDate}`;
      } else {
        textToShow = `${t("classRoom:closes_capital")} ${getSuffix(
          diffDays
        )}, ${formattedDate}`;
      }
      break;
    case "LATEST_UNREAD_CONVERSATION":
      if (diffDays < -1) {
        textToShow = `${t("classRoom:messaged")} ${onText} ${formattedDate}`;
      } else {
        textToShow = `${t("classRoom:messaged")} ${getSuffix(
          diffDays
        )}, ${formattedDate}`;
      }
      break;
  }

  return textToShow;
};

export const getIsScoreBasedRubricEnabled = () => {
  return ACLStore.can("FeatureFlag:ScoreBasedRubric");
};

export const getMessageSummaryData = messagesSummary => {
  const { unreadMessagesCount = 0, unreadMessages = [] } = messagesSummary;
  const lastUnreadMessage = _.first(unreadMessages) || {};
  const isLastMessageClassDiscussion =
    _.get(lastUnreadMessage, "parentEntity.parentType") === "ASSIGNMENT";
  const studentAssignmentId = _.get(
    lastUnreadMessage,
    "parentEntity.parentEntity.id",
    ""
  );

  return {
    unreadMessagesCount,
    isLastMessageClassDiscussion,
    studentAssignmentId,
  };
};

export const getGroupedJustifications = ({
  indicators,
  criterias,
  toolEvaluationResponses,
}) => {
  const aiResponses = _.filter(toolEvaluationResponses, {
    creatorType: "AI",
  });

  return _.reduce(
    indicators,
    (result, indicator) => {
      const response = _.find(aiResponses, { rowId: indicator?.id });

      const responseCriteria =
        _.find(criterias, criteria => response?.columnId === criteria.id) ||
        _.find(indicator?.descriptors, { id: response?.columnId });

      const responseCriteriaLabel =
        responseCriteria?.label ||
        responseCriteria?.gradeScaleValue?.abbreviation;

      const justification = _.get(
        response,
        "evaluationJustification.message",
        ""
      );

      if (justification) {
        result.push({
          title:
            indicator?.label ||
            indicator?.standard?.label ||
            indicator?.benchmark?.title,
          justificationMsg: justification,
          responseCriteria: responseCriteriaLabel,
        });
      }

      return result;
    },
    []
  );
};

export const ASSESSMENT_TYPE_UID_CREATE_OPTION_MAPPING = {
  le: CREATE_LE,
  fmt: CREATE_FA,
  smt: CREATE_SA,
  [ASSESSMENT_TYPE_WORKSHEET]: CREATE_WORKSHEET,
  [ASSESSMENT_TYPE_AI_TUTOR]: CREATE_AI_TUTOR,
  qt: CREATE_QUICK_TASK,
};

export const getStaffCourseDetailsQueryVariables = params => {
  const {
    userId,
    portalType,
    coursesSearchText,
    courseId,
    subjectsField = {},
    grades: propsGrades,
    isDpPa,
    isDpEp,
    academicYearId,
    userType,
    curriculumType,
    learningCourseId,
    isPaginationEnabled,
    currentCurriculumProgramId,
    isSourceMeetingCreation,
    controlParameters,
    selectedGradeIds,
  } = params;

  let staffCourseFilter = {
    curriculumProgramIds: currentCurriculumProgramId
      ? [currentCurriculumProgramId]
      : undefined,
    archivalState: "ACTIVE",
    searchText: coursesSearchText,
    fetchOnlyMappedCourses: false,
    learningCourseIds:
      getIsLearningCoursesEnabled() && learningCourseId
        ? [learningCourseId]
        : undefined,
    controlParameters,
  };

  const courseGradeFilters = {
    academicYearId,
  };

  const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

  // For new course setup do not apply any grade or subject filter for now
  if (!isLearningCoursesEnabled) {
    const courseDetails = getCourseDetails({
      id: courseId,
      courseGradeFilters,
    });
    const grades = !_.isEmpty(propsGrades)
      ? propsGrades
      : _.get(courseDetails, "grades", []);
    const gradeIds = _.map(grades, grade => _.get(grade, "id"));
    const subjectIds = _.get(subjectsField, "value", []);

    switch (curriculumType) {
      case CURRICULUM_TYPE_DP:
        staffCourseFilter = {
          ...staffCourseFilter,
          subjectIds: !_.isEmpty(subjectIds) ? subjectIds : [],
          grades: gradeIds,
        };
        break;
      case CURRICULUM_TYPE_MYP:
      case CURRICULUM_TYPE_UBD:
        staffCourseFilter = {
          ...staffCourseFilter,
          subjectIds: !_.isEmpty(subjectIds) ? subjectIds : [],
        };
        break;
    }
    // User-selected grades override the default grade filter (e.g., DP course grades)
    if (!_.isEmpty(selectedGradeIds)) {
      staffCourseFilter = {
        ...staffCourseFilter,
        grades: selectedGradeIds,
      };
    }
  }

  return {
    id: userId,
    first: isPaginationEnabled ? 20 : undefined,
    filters: staffCourseFilter,
    portalType,
    areStudentsIncluded: true,
    courseGradeFilters,
    enabledModulesFilters: {
      moduleNames: isLearningCoursesEnabled
        ? [CLASS_STREAM]
        : [CLASS_STREAM, CLASS_FLOW],
      userType,
    },
    aclControlParameterFilter: ACLStore.can(
      ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION
    )
      ? {
          controlParameters: isSourceMeetingCreation
            ? ASSIGNMENTS_MANAGE_PERMISSION_IN_CALENDAR
            : isDpPa || isDpEp
            ? [PSOW_ROEP_MANAGE_PERMISSION]
            : getAssignmentConsumingParentModulesPermission("MANAGE"),
        }
      : undefined,
  };
};

export const getIsAIGradingEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableAIGrading");
};

export const getIsBenchmarkAIGradingEnabled = () => {
  return ACLStore.can("FeatureFlag:ShowBenchmarkAiGradings");
};

export const getAvatarData = ({ id, title, profileImageData = {} }) => {
  const { url = "", icon, color: _color, acronym: _acronym } =
    profileImageData || {};

  const color = _color || AVATAR_COLORS[hashString(id) % AVATAR_COLORS.length];

  const name = _acronym ? _.join(_.split(_acronym, ""), " ") : title;

  const AvatarIcon = getSelectedIcon(icon);

  const iconType = !_.isEmpty(_acronym) ? "" : icon ? "icon" : "";

  return { url, color, name, AvatarIcon, iconType };
};

export const getAIGradingProgressMessages = ({
  t,
  firstName,
  progressValue,
}) => {
  if (progressValue <= 25) {
    return {
      title: t("classRoom:analyzing_assignment_criteria"),
      message: t(
        "classRoom:identifying_key_learning_objectives_and_requirements"
      ),
    };
  } else if (progressValue <= 50) {
    return {
      title: t("classRoom:reading_submission", { label: firstName }),
      message: t(
        "classRoom:processing_student_work_and_identifying_key_concepts"
      ),
    };
  } else if (progressValue <= 75) {
    return {
      title: t("classRoom:generating_feedback_and_graded"),
      message: t("classRoom:evaluating_responses_against_criteria"),
    };
  } else {
    return {
      title: t("classRoom:preparing_justification"),
      message: t("classRoom:documenting_justification_for_grades_and_comments"),
    };
  }
};

export const getStandardRubricCalculatedScore = params => {
  const { assessmentTool, calculatedScore } = params;

  let score = _.toString(calculatedScore);

  const maxScore =
    _.get(assessmentTool, "associateScoreTool.scoreToolData.maxScore") || {};

  const rubricTotalScore = _.toString(
    _.sumBy(assessmentTool?.standardRubricCriterias, criterion => {
      const score = _.toNumber(criterion?.maxScore);
      return _.isNaN(score) ? 0 : score;
    })
  );

  if (maxScore !== rubricTotalScore) {
    const scaledValue = compareInScaledRange({
      value: score,
      fromRange: {
        min: 0,
        max: rubricTotalScore,
      },
      toRange: {
        min: 0,
        max: maxScore,
      },
    });

    score = _.toString(scaledValue);
  }

  return score;
};

export const getAssignmentFeedDisplaySettings = () => {
  let displaySettingsValue = getSettingValue({
    name: "AssignmentFeedDisplaySettings",
    readFromUserAndOrgLevel: true,
  });

  const shouldConsiderDefault =
    _.isEmpty(displaySettingsValue) ||
    _.some(_.keys(getAssignmentStateTabsForStaff()), tabKey => {
      return _.isEmpty(displaySettingsValue[tabKey]);
    });

  displaySettingsValue = shouldConsiderDefault
    ? getDefaultDisplaySettings()
    : displaySettingsValue;

  return displaySettingsValue;
};

export const getAllUniqueAcademicYears = courses => {
  // Use flatMap to extract and flatten all academicYears arrays
  // Then use uniqBy to ensure we have unique academic years based on their id
  return _.uniqBy(
    _.flatMap(courses, course => _.get(course, "academicYears", [])),
    "id"
  );
};

export const getAcademicTermOptions = ({ options, t }) => {
  const allOption = {
    key: "ALL",
    label: t("classRoom:all_terms"),
    value: "ALL",
  };
  const groupedByYear = _.groupBy(options, option => _.get(option, "year", ""));

  if (_.size(_.keys(groupedByYear)) < 2) {
    return [allOption, ...options];
  }

  let resultArray = [allOption]; // Start with the "ALL" option

  // Sort the years (keys) to ensure consistent ordering
  const sortedYears = _.orderBy(
    Object.keys(groupedByYear),
    year => year,
    "desc"
  );

  // Process each year group and add to the resultArray
  _.forEach(sortedYears, year => {
    // Add year subheader
    resultArray.push({
      key: `SUBHEADER_${year}`,
      label: year,
      value: "SUBHEADER",
      isSubHeader: true,
    });

    // Add all options for this year in their original order
    const yearOptions = groupedByYear[year];
    resultArray = resultArray.concat(yearOptions);
  });

  return resultArray;
};

export const getIsAiEvaluationEnabled = ({ assessmentFields }) => {
  return (
    getIsBenchmarkAIGradingEnabled() ||
    _.get(_.find(assessmentFields, { uid: "aiEvaluation" }), "value", false)
  );
};

export const getLtiToolInfoFromStudentTemplate = assignmentData => {
  const studentTemplate = _.find(_.get(assignmentData, "content.allFields"), {
    uid: "studentTemplate",
  });

  // Get attachmentGroups from resolvedMinimalTree
  const attachmentGroups = _.get(
    studentTemplate,
    "resolvedMinimalTree.attachmentGroups",
    []
  );

  // Find the attachment group that contains an LTI_TOOL attachment
  const ltiAttachmentGroup = _.find(
    attachmentGroups,
    item => _.get(item, "attachments[0].metadata.type") === "LTI_TOOL"
  );

  // Extract the needed information
  const attachmentId = _.get(ltiAttachmentGroup, "attachments[0].id", null);
  const ltiServiceName = _.get(
    ltiAttachmentGroup,
    "attachments[0].metadata.service",
    null
  );
  const resourceLinkId = _.get(assignmentData, "content.id", null);

  return {
    attachmentId,
    ltiServiceName,
    resourceLinkId,
  };
};

export const getIsStandardsUIRevampInAssignments = () => {
  return ACLStore.can("AdminPortal:StandardsV2");
};

export const getIsEvaluationApplicable = (isEvaluationApplicable = false) => {
  // Uncomment below line if we allow evaluation for excused assignments in future
  // return getIsEnabledExcusedStatusInAssignment() || isEvaluationApplicable;

  return isEvaluationApplicable;
};

export const renderAssignmentStatusChangeButton = ({
  assignmentStateTab,
  handleAssignmentStatusChange,
  t,
}) => {
  let tooltipText = "";
  let icon = null;
  if (assignmentStateTab === "PUBLISHED") {
    tooltipText = t("classRoom:move_assignment_to_reviewed");
    icon = <TickCircleOpenOutlined />;
  } else if (assignmentStateTab === "ARCHIVED") {
    tooltipText = t("classRoom:move_back_to_to_review");
    icon = <ClipboardArrowOutlined />;
  }
  return tooltipText && icon && getIsEnabledAssignmentImprovements() ? (
    <Tooltip
      tooltip={tooltipText}
      showArrow={true}
      dsVersion="2.0"
      placement={"bottom"}
    >
      <IconButton
        size="medium"
        variant="neutral"
        type="plain"
        icon={icon}
        onClick={handleAssignmentStatusChange}
        dsVersion="2.0"
      />
    </Tooltip>
  ) : null;
};

export const getIsAssessmentGradedScaleToolEnabled = () => {
  return ACLStore.can("FeatureFlag:AssessmentGradeScaleTool");
};

export const getAssignmentHasTeacherEvaluation = ({
  isLearningGoalsEvaluationEnabled,
  assessmentTools,
}) => {
  const assessmentToolsWithEval = _.filter(assessmentTools, ({ node }) => {
    const assessmentToolType = _.get(node, "assessmentToolType", "");
    return _.get(
      _.find(ASSESSMENT_TOOLS, ({ type }) => type === assessmentToolType),
      "hasEvaluation",
      false
    );
  });

  return (
    _.some(assessmentToolsWithEval, ({ node }) =>
      _.get(node, "isTeacherEvaluationEnable", false)
    ) || isLearningGoalsEvaluationEnabled
  );
};

export const validateStudentSubmissionForAIEvaluation = ({
  attachmentGroups,
  t,
}) => {
  const invalidAttachmentSet = new Set();

  _.forEach(attachmentGroups, attachment => {
    const submission = _.get(attachment, "attachments.0");
    const { metadata, type, childAttachments, mimeType } = submission || {};

    // Check for unsupported mime type
    if (
      mimeType &&
      type !== "LINK" &&
      !_.includes(VALID_STUDENT_SUBMISSION_TYPE, mimeType)
    ) {
      const isCodeBasedMimeType = _.includes(CODE_BASED_MIME_TYPES, mimeType);

      if (isCodeBasedMimeType) {
        invalidAttachmentSet.add("code based files");
      } else {
        const fileExtension = _.upperCase(
          getFileExtensionFromMimeType({ mimeType })
        );
        const resolvedFileExtension =
          fileExtension === "QT" ? "MOV" : fileExtension;

        invalidAttachmentSet.add(resolvedFileExtension);
      }
    }

    // Check for LINK without serviceType
    if (type === "LINK" && !_.has(metadata, "serviceType")) {
      invalidAttachmentSet.add("Links");
    }

    // Check for AUDIO or VIDEO inside workbook
    if (type === "WORKBOOK") {
      const hasInvalidChild = _.some(childAttachments, child =>
        ["AUDIO", "VIDEO"].includes(child?.type)
      );
      if (hasInvalidChild) {
        invalidAttachmentSet.add(t("ai:invalid_reason_workbook_media"));
      }
    }
  });

  if (_.size(invalidAttachmentSet) > 0) {
    const reasonList = Array.from(invalidAttachmentSet).join(", ");
    return {
      errorMessage: t("ai:invalid_student_submission_error_msg", {
        label: reasonList,
      }),
    };
  }

  return {};
};

export const getCommonFilterCountVariables = ({ orgId }) => {
  const {
    lastWeekStartDate,
    lastWeekEndDate,
    earlierEndDate,
    thisWeekStartDate,
    thisWeekEndDate,
  } = getDateList({ orgId });
  return {
    lastWeekStartDate,
    lastWeekEndDate,
    earlierEndDate,
    thisWeekStartDate,
    thisWeekEndDate,
  };
};
// this function determines the locked state to send with the evaluation action
// if we have checked the "Lock submission after evaluation" setting
// and the submission is not a worksheet or AI tutor, it will return "LOCKED"
// otherwise, it will return the unlock state based on the closeSubmissions flag
export const getLockedStateToSendWithEvaluationAction = ({
  closeSubmissions = true,
  isWorksheetOrAiTutor,
  isStudentSubmissionEnabled,
  isPrivate,
  isTimedTestEnabled,
}) => {
  if (!isStudentSubmissionEnabled || isPrivate || isTimedTestEnabled) {
    return undefined;
  }
  if (isWorksheetOrAiTutor) {
    return "LOCKED";
  }
  if (closeSubmissions) {
    return "LOCKED";
  }
  return getSubmissionUnlockState({
    isLockSubmissionEnabled: false,
  });
};

export const getIsAssessmentGradeScaleToolEnabled = () => {
  return (
    getIsNewGradingSetupEnabled() &&
    ACLStore.can("FeatureFlag:AssessmentGradeScaleTool")
  );
};

export const getFilterCountVariables = ({
  userId,
  childID,
  userType,
  organizationId,
  academicYearId,
  courseId,
  currentCurriculumProgramType,
  curriculumProgramId,
  userEntityType,
  searchText,
  academicYearSelected,
}) => {
  const organizationDetails = getOrganizationDetailsFromCache(organizationId);
  const courseDetails = getCourseDetailsFromCache({
    id: courseId,
    courseGradeFilters: academicYearId,
  });
  const allAcademicYears = _.get(organizationDetails, "academicYears", []);
  const grades = _.get(courseDetails, "grades", []);
  const globalGradeName = _.get(_.first(grades), "globalGrade.uid", null);
  const grade = globalGradeName === "Grade 12" ? DP_2 : DP_1;

  const {
    endDate: overDueEndDate,
    startDate: overDueStartDate,
  } = getDeadlineStartAndEndDate({
    grade,
    allAcademicYears,
    currentCurriculumProgramType,
    academicYearSelected,
  });

  const curriculumProgramIds = curriculumProgramId ? [curriculumProgramId] : [];

  return {
    ...getCommonFilterCountVariables({
      orgId: organizationId,
    }),
    userId,
    type: userEntityType,
    academicYearId,
    courseIds: courseId,
    entityTypes: ["STUDENT_ASSIGNMENT"],
    studentIds: userType === "parent" ? childID : undefined,
    excludedAssessmentTypes: EXCLUDED_ASSESSMENT_TYPES,
    searchText: searchText,
    overDueEndDate,
    overDueStartDate,
    curriculumProgramIds,
  };
};

export const getIsAtlSkill = ({ type }) => {
  return _.includes(["UBD_ATL", "PYP_ATL", "MYP_ATL", "DP_ATL"], type);
};

export const getIsElementForNewGradingSetup = ({ type }) => {
  return _.includes(
    [
      ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW,
      ELEMENT_TYPE_ALL_ASSESSMENTS,
      ELEMENT_TYPE_PYP_ATL,
      ELEMENT_TYPE_PYP_LEARNER_PROFILE,
      ELEMENT_TYPE_PYP_KEY_CONCEPT,
      STUDENT_STANDARDS_GRADEBOOK,
      ELEMENT_TYPE_MYP_ATL,
      ELEMENT_TYPE_MYP_LEARNER_PROFILE,
      ELEMENT_TYPE_UBD_ATL,
      ELEMENT_TYPE_DP_ATL,
      ELEMENT_TYPE_DP_OBJECTIVES,
      ELEMENT_TYPE_DP_LEARNER_PROFILE,
    ],
    type
  );
};
export const getGroupedStudentAssignments = ({
  orgId,
  activeSidebarTab,
  edges,
  t,
  folderTopic,
  classroomFolders = [],
  assignmentStateTab,
}) => {
  const {
    lastWeekStartDate,
    lastWeekEndDate,
    thisWeekStartDate,
    thisWeekEndDate,
    nextWeekEndDate,
    nextWeekStartDate,
  } = getDateList({ orgId });

  // Check if activeSidebarTab is a folder ID
  const isFolder = _.find(classroomFolders, { id: activeSidebarTab });

  const isStudentAssignmentFeedRevampEnabled = getIsStudentAssignmentFeedRevampEnabled();

  if ((isFolder && folderTopic) || activeSidebarTab === folderTopic) {
    // For folder-based filtering, group by a generic label or by time
    const folder = _.find(classroomFolders, { id: folderTopic });
    const folderName = _.get(folder, "name", t("common:all"));
    return _.size(edges) > 0
      ? {
          [folderName]: edges,
        }
      : {};
  }

  switch (activeSidebarTab) {
    case "UPCOMING": {
      const thisWeekTasks = [];
      const nextWeekTasks = [];
      const laterTasks = [];
      _.forEach(edges, edge => {
        if (
          moment(edge.orderDate).isBetween(
            thisWeekStartDate,
            thisWeekEndDate,
            undefined,
            "[]"
          )
        ) {
          thisWeekTasks.push(edge);
        } else if (
          moment(edge.orderDate).isBetween(
            nextWeekStartDate,
            nextWeekEndDate,
            undefined,
            "[]"
          )
        ) {
          nextWeekTasks.push(edge);
        } else {
          laterTasks.push(edge);
        }
      });
      const result = {};
      if (_.size(thisWeekTasks) > 0) {
        result[t("classRoom:this_week")] = thisWeekTasks;
      }
      if (_.size(nextWeekTasks) > 0) {
        result[t("classRoom:next_week")] = nextWeekTasks;
      }
      if (_.size(laterTasks) > 0) {
        result[t("classRoom:later")] = laterTasks;
      }
      return result;
    }
    case "OVERDUE": {
      const thisWeekTasks = [];
      const lastWeekTasks = [];
      const earlierTasks = [];
      _.forEach(edges, edge => {
        if (
          moment(edge.orderDate).isBetween(
            thisWeekStartDate,
            thisWeekEndDate,
            undefined,
            "[]"
          )
        ) {
          thisWeekTasks.push(edge);
        } else if (
          moment(edge.orderDate).isBetween(
            lastWeekStartDate,
            lastWeekEndDate,
            undefined,
            "[]"
          )
        ) {
          lastWeekTasks.push(edge);
        } else {
          earlierTasks.push(edge);
        }
      });
      const result = {};
      if (_.size(thisWeekTasks) > 0) {
        result[t("classRoom:this_week")] = thisWeekTasks;
      }
      if (_.size(lastWeekTasks) > 0) {
        result[t("classRoom:last_week")] = lastWeekTasks;
      }
      if (_.size(earlierTasks) > 0) {
        result[t("classRoom:earlier")] = earlierTasks;
      }
      return result;
    }
    case "NODUE": {
      return _.size(edges) > 0
        ? {
            [t("classRoom:no_due_date")]: edges,
            showHeading: isStudentAssignmentFeedRevampEnabled ? false : true,
          }
        : {};
    }
    case "THIS_WEEK": {
      return _.size(edges) > 0
        ? {
            [t("classRoom:done_this_week")]: edges,
          }
        : {};
    }
    case "LAST_WEEK": {
      return _.size(edges) > 0
        ? {
            [t("classRoom:done_last_week")]: edges,
          }
        : {};
    }
    case "EARLIER": {
      return _.size(edges) > 0
        ? {
            [t("classRoom:done_earlier")]: edges,
          }
        : {};
    }
    case "NOT_SUBMITTED": {
      return _.size(edges) > 0
        ? {
            [t("classRoom:not_submitted")]: edges,
            showHeading: isStudentAssignmentFeedRevampEnabled ? false : true,
          }
        : {};
    }
    case "SCHEDULED": {
      return _.size(edges) > 0
        ? {
            [t("classRoom:scheduled")]: edges,
            showHeading: isStudentAssignmentFeedRevampEnabled ? false : true,
          }
        : {};
    }
    default:
      return {};
  }
};

export const getUpdatedStudentTasks = ({ data }) => {
  const taskEdges = _.get(data, "tasks.edges", []);
  return _.map(taskEdges, edge => {
    const { item } = edge;
    return {
      ...edge,
      ...item,
    };
  });
};

export const getStudentTasksFilters = ({
  filters,
  academicYearId,
  courseId,
  activeTypesArr,
  curriculumProgramId,
  orgId,
  currentCurriculumProgramType,
  academicYearSelected,
}) => {
  const {
    assignmentStateTab,
    activeSidebarTab,
    searchText,
    filterDate,
    status,
    folderTopic,
  } = filters;

  const startDate = _.get(filterDate, "deadlineDates.startDate", undefined);
  const endDate = _.get(filterDate, "deadlineDates.endDate", undefined);

  const organizationDetails = getOrganizationDetailsFromCache(orgId);
  const courseDetails = getCourseDetailsFromCache({
    id: courseId,
    courseGradeFilters: { academicYearId },
  });
  const allAcademicYears = _.get(organizationDetails, "academicYears", []);
  const grades = _.get(courseDetails, "grades", []);
  const globalGradeName = _.get(_.first(grades), "globalGrade.uid", null);
  const grade = globalGradeName === "Grade 12" ? DP_2 : DP_1;

  const {
    endDate: overDueEndDate,
    startDate: overDueStartDate,
  } = getDeadlineStartAndEndDate({
    grade,
    allAcademicYears,
    currentCurriculumProgramType,
    academicYearSelected,
  });

  let completionStatus =
    ASSIGNMENT_STATE_TO_HEADER_TAB_MAPPING[assignmentStateTab] || "TODO";

  if (activeSidebarTab === "SCHEDULED") {
    completionStatus = "SCHEDULED";
  }

  const assignmentFilters = {};

  // Handle status filtering
  if (status && status !== "ALL") {
    if (_.includes(SUBMISSION_OPTIONS_V2, status)) {
      assignmentFilters.submissionStatus = [status];
    } else {
      if (status === "EXCUSED") {
        assignmentFilters.isEvalutationApplicable = false;
      } else {
        assignmentFilters.status = [status];
      }
    }
  }

  // Handle folder filtering
  if (folderTopic && folderTopic !== "ALL") {
    assignmentFilters.folderIds = [folderTopic];
  }

  let baseFilters = {
    completionStatus,
    academicYearId,
    courseIds: [courseId],
    entityTypes: activeTypesArr || [],
    searchText,
    excludedAssessmentTypes: EXCLUDED_ASSESSMENT_TYPES,
    curriculumProgramIds: [curriculumProgramId],
  };

  if (!_.isEmpty(assignmentFilters)) {
    baseFilters.assignmentFilters = assignmentFilters;
  }

  // Handle status and date filters based on completion status and sidebar tab
  if (completionStatus === "TODO") {
    baseFilters.status = activeSidebarTab;

    if (activeSidebarTab === "OVERDUE") {
      baseFilters = {
        ...baseFilters,
        startDate: overDueStartDate,
        endDate: overDueEndDate,
      };
    } else {
      baseFilters = {
        ...baseFilters,
        startDate,
        endDate,
      };
    }
  } else if (completionStatus === "COMPLETED") {
    const {
      lastWeekStartDate,
      lastWeekEndDate,
      thisWeekStartDate,
      thisWeekEndDate,
      earlierEndDate,
    } = getDateList({ orgId });

    // Handle folder-based filtering for completed tasks
    if (activeSidebarTab === folderTopic && folderTopic !== "ALL") {
      // This is a folder selection for completed tasks, use default date range
      baseFilters = {
        ...baseFilters,
        startDate,
        endDate,
      };
    } else {
      switch (activeSidebarTab) {
        case "THIS_WEEK":
          baseFilters = {
            ...baseFilters,
            startDate: thisWeekStartDate,
            endDate: thisWeekEndDate,
          };
          break;
        case "LAST_WEEK":
          baseFilters = {
            ...baseFilters,
            startDate: lastWeekStartDate,
            endDate: lastWeekEndDate,
          };
          break;
        case "EARLIER":
          baseFilters = {
            ...baseFilters,
            endDate: earlierEndDate,
          };
          break;
        default:
          baseFilters = {
            ...baseFilters,
            startDate,
            endDate,
          };
      }
    }
  }
  return baseFilters;
};

export const getStudentTasksVariables = ({
  userId,
  childID,
  userType,
  filters,
  academicYearId,
  courseId,
  curriculumProgramId,
  organizationId,
  currentCurriculumProgramType,
  academicYearSelected,
}) => {
  const isParent = userType === "parent";

  const { activeSidebarTab } = filters;

  const studentTasksFilters = getStudentTasksFilters({
    filters,
    academicYearId,
    courseId,
    activeTypesArr: ["STUDENT_ASSIGNMENT"],
    curriculumProgramId,
    orgId: organizationId,
    currentCurriculumProgramType,
    academicYearSelected,
  });

  return {
    userId,
    studentIds: isParent ? childID : undefined,
    type: getUserEntityType(),
    filters: studentTasksFilters,
    first: 10,
    orderByDirection: activeSidebarTab === "UPCOMING" ? "ASC" : "DESC",
  };
};

export const getIsEnableLearningGoalsEvaluationInNewGradingSetup = () => {
  return (
    getIsConfigurationEnabledForCPAY({
      configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
    }) &&
    ACLStore.can("FeatureFlag:EnableLearningGoalsEvaluationInNewGradingSetup")
  );
};

/**
 * Returns a sorted list of student submissions based on the provided sort options.
 *
 * If the sort option is a student name field ("FIRST_NAME", "MIDDLE_NAME", "LAST_NAME", "FULL_NAME"),
 * it delegates sorting to the `getSortedStudents` function. Otherwise, it sorts using
 * `getAllSubmissionsSortOrder`.
 *
 * @param {Object} params - The parameters object.
 * @param {Array} params.assignedStudents - The list of students assigned to the classroom.
 * @param {Function} params.getSortedStudents - Function to sort students by name.
 * @returns {Array} Sorted array of assigned students.
 */
export const getSortedStudentSubmissions = ({
  assignedStudents,
  getSortedStudents,
}) => {
  const sortOptions = {
    value: getDefaultOrderBy({ type: "student" }) || "FIRST_NAME",
    order: `asc`,
  };
  if (!_.isEmpty(sortOptions) && !_.isEmpty(assignedStudents)) {
    if (
      _.includes(
        ["FIRST_NAME", "MIDDLE_NAME", "LAST_NAME", "FULL_NAME"],
        _.get(sortOptions, "value")
      )
    ) {
      return getSortedStudents({
        students: assignedStudents,
        sortOptions,
      });
    }
    return _.orderBy(
      assignedStudents,
      [
        assignedStudent =>
          getAllSubmissionsSortOrder({
            assignedStudent,
            sortOptions,
          }),
      ],
      [_.get(sortOptions, "order")]
    );
  }

  return assignedStudents;
};

export const getIsRatingSubjectOrCourseWise = () => {
  return ACLStore.can("Common:EnableRatingSubjectCourseWise");
};

export const getEmptyStateConfig = ({
  noAssignmentCreatedYet,
  isHeaderTabEmpty,
  activeHeaderTab,
  searchTerm,
  status,
  t,
  isParent,
  childName = "",
}) => {
  const hasSearchTerm = !_.isEmpty(_.trim(searchTerm));
  const isFilterChanged = status !== "ALL";
  const hasNoResult = hasSearchTerm || isFilterChanged;

  let emptyStateIllustration;
  let emptyTitle;
  let emptySubtitle;

  if (hasNoResult) {
    emptyStateIllustration = NoSearchInFilterIllustration;
    emptyTitle = t("common:noResultHeading");
    emptySubtitle = t("common:no_assignments_matching_your_search");
  } else if (noAssignmentCreatedYet) {
    emptyStateIllustration = NoAssignmentIllustration;
    emptyTitle = t("classRoom:no_assignments_and_deadlines_added_yet_title");
    emptySubtitle = isParent
      ? t("classRoom:no_assignment_added_yet_subtitle_with_label", {
          name: childName,
        })
      : t("classRoom:no_assignment_added_yet_subtitle");
  } else if (isHeaderTabEmpty) {
    // Header tab is empty
    if (activeHeaderTab === "TODO") {
      emptyStateIllustration = AllCompletedIllustration;
      emptyTitle = t("classRoom:not_submitted_assignments_empty_state_title");
      emptySubtitle = isParent
        ? t(
            "classRoom:todo_all_assignment_and_deadlines_submitted_with_label",
            {
              name: childName,
            }
          )
        : t("classRoom:todo_all_assignment_and_deadlines_submitted");
    } else if (activeHeaderTab === "NOT_SUBMITTED") {
      emptyStateIllustration = NoAssignmentIllustration;
      emptyTitle = t("classRoom:no_assignment_and_deadlines_missed_yet_title");
      emptySubtitle = isParent
        ? t(
            "classRoom:not_submitted_all_assignment_and_deadlines_submitted_with_label",
            {
              name: childName,
            }
          )
        : t("classRoom:not_submitted_all_assignment_and_deadlines_submitted");
    } else if (activeHeaderTab === "COMPLETED") {
      emptyStateIllustration = NoAssignmentIllustration;
      emptyTitle = t("classRoom:no_assignment_and_deadlines_turned_in_yet");
      emptySubtitle = t("classRoom:once_turned_in_it_will_appear_here");
    }
  } else {
    // Default empty state
    emptyStateIllustration = AllCompletedIllustration;
    emptyTitle = t("classRoom:no_assignments_and_deadlines_added_yet_title");
    emptySubtitle = t("classRoom:no_assignment_added_yet_subtitle");
  }

  return {
    illustration: emptyStateIllustration,
    title: emptyTitle,
    subtitle: emptySubtitle,
  };
};

export const getSubmissionIdFromAssignedStudents = ({
  assignedStudents,
  studentAssignmentId,
}) => {
  return _.get(
    _.find(assignedStudents, s => s.id === studentAssignmentId),
    "submission.id"
  );
};

export const getAssignmentTypeFlags = assignmentData => {
  const assessmentTypeValue = _.get(
    assignmentData,
    "content.assessmentType.value"
  );
  const taskTypeGroup = _.get(assignmentData, "content.taskType.type");
  return {
    isWorksheet:
      assessmentTypeValue === ASSESSMENT_TYPE_WORKSHEET ||
      taskTypeGroup === TASK_TYPE_WORKSHEET,
    isAITutor:
      assessmentTypeValue === ASSESSMENT_TYPE_AI_TUTOR ||
      taskTypeGroup === TASK_TYPE_AI_TUTOR,
  };
};

// Local copies of `getFieldValue` and `getResolvedMinimalTreeSet`
// (originally in Assessments/modules/Utils.js) are inlined here to avoid the
// ClassRoom/utils <-> Assessments/Utils circular dependency. Should be
// consolidated into a leaf file alongside `STANDARD_UIDS` once
// Constants/plannerElementMappings.js lands (see RESTRUCTURE_LARGE_FILES_PLAN.md step 10).
const getFieldValue = ({ fields, uid }) => {
  const fieldData = _.find(fields, { uid });
  return _.get(fieldData, "value", []) || [];
};

const getResolvedMinimalTreeSet = ({ fields, uid, curriculumType }) => {
  const fieldData = _.find(fields, { uid });

  if (uid === "subjects") {
    return _.get(fieldData, `resolvedMinimalTree.subjects`, []);
  }

  if (uid === "unitPlan") {
    return _.get(fieldData, `resolvedMinimalTree.unitPlan`, {});
  }

  if (uid === "pypNestedElement") {
    return _.get(fieldData, `resolvedMinimalTree.nodes`, []);
  }

  switch (curriculumType) {
    case CURRICULUM_TYPE_PYP:
      return _.get(
        fieldData,
        `resolvedMinimalTree.${pypElementSetMapping[uid]}`,
        []
      );
    default:
      return _.get(fieldData, `resolvedMinimalTree.nodes`, []);
  }
};

export const allowLearningGoalsRatingInStandards = ({
  assessmentDetails,
  curriculumProgramType,
}) => {
  const assessmentTools = _.get(assessmentDetails, "assessmentTools", []);
  const assessmentFields = _.get(
    assessmentDetails,
    "allFields",
    _.get(assessmentDetails, "fields", [])
  );
  const _assessmentTools = !_.isEmpty(assessmentTools?.edges)
    ? assessmentTools?.edges
    : assessmentTools;
  const assessmentToolNodes = _.map(_assessmentTools, "node");
  // Doubt - @priyansh
  const isStandardRubricPresent = !_.isEmpty(
    _.find(assessmentToolNodes, {
      assessmentToolType: "STANDARD_BASED_RUBRIC",
    }) || {}
  );
  // If standard rubric is present, we don't allow learning goals rating in standards
  if (isStandardRubricPresent) {
    return false;
  }

  const standardUID = STANDARD_UIDS[curriculumProgramType];
  const fieldValue = getFieldValue({
    fields: assessmentFields,
    uid: standardUID,
  });
  const nodes = getResolvedMinimalTreeSet({
    uid: standardUID,
    fields: assessmentFields,
    curriculumType: curriculumProgramType,
  });

  // Allow learning goals rating in standards only if there are individual graded standards
  const inidividualGradedStandardsValue = _.filter(fieldValue, id => {
    const node = _.find(nodes, { id }) || {};
    return !_.isEmpty(node) && node?.gradingType === "INDIVIDUAL";
  });
  return !_.isEmpty(inidividualGradedStandardsValue);
};

export const allowLearningGoalsRatingInSkills = ({
  fieldUID,
  assessmentDetails,
  curriculumProgramType,
}) => {
  const assessmentFields = _.get(
    assessmentDetails,
    "allFields",
    _.get(assessmentDetails, "fields", [])
  );

  const nodes = getResolvedMinimalTreeSet({
    uid: fieldUID,
    fields: assessmentFields,
    curriculumType: curriculumProgramType,
  });

  return _.some(nodes, ({ plannerElementNodeWrapper, dataSetNodeWrapper }) => {
    const properties =
      plannerElementNodeWrapper?.properties ?? dataSetNodeWrapper?.properties;

    return properties?.isGradedStandard || properties?.isGraded;
  });
};

// function to check whether LE have pyp elements associated
export const getPlannerElementsToEvaluate = ({
  assessmentDetails,
  curriculumProgramType = CURRICULUM_TYPE_PYP,
}) => {
  return _.filter(
    EVALUATE_PLANNER_ELEMENTS_BY_CURRICULUM[curriculumProgramType],
    ({ value }) => {
      if (
        value === STANDARD_UIDS[curriculumProgramType] &&
        getIsConfigurationEnabledForCPAY({
          configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
        })
      ) {
        return allowLearningGoalsRatingInStandards({
          assessmentDetails,
          curriculumProgramType,
        });
      }

      if (
        getIsConfigurationEnabledForCPAY({
          configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
        }) &&
        getIsEnableLearningGoalsEvaluationInNewGradingSetup()
      ) {
        return allowLearningGoalsRatingInSkills({
          fieldUID: value,
          assessmentDetails,
          curriculumProgramType,
        });
      }

      return checkEmptyElementValue({
        fieldKey: value,
        data: assessmentDetails,
        ignoreUnitPlanSubjectCheck: true, // TODO: hack for classroom LE - remove later
      });
    }
  );
};
